export default {
  regionJson: [ {
    "children": [ {
      "children": [ {
        "id": "4-3u",
        "value": "东城区",
        "text": "东城区"
      }, {
        "id": "5-pS",
        "value": "西城区",
        "text": "西城区"
      }, {
        "id": "6-Gi",
        "value": "朝阳区",
        "text": "朝阳区"
      }, {
        "id": "7-u2",
        "value": "丰台区",
        "text": "丰台区"
      }, {
        "id": "8-XJ",
        "value": "石景山区",
        "text": "石景山区"
      }, {
        "id": "9-y4",
        "value": "海淀区",
        "text": "海淀区"
      }, {
        "id": "10-5Z",
        "value": "门头沟区",
        "text": "门头沟区"
      }, {
        "id": "11-Le",
        "value": "房山区",
        "text": "房山区"
      }, {
        "id": "12-bJ",
        "value": "通州区",
        "text": "通州区"
      }, {
        "id": "13-no",
        "value": "顺义区",
        "text": "顺义区"
      }, {
        "id": "14-uu",
        "value": "昌平区",
        "text": "昌平区"
      }, {
        "id": "15-QA",
        "value": "大兴区",
        "text": "大兴区"
      }, {
        "id": "16-zD",
        "value": "怀柔区",
        "text": "怀柔区"
      }, {
        "id": "17-L7",
        "value": "平谷区",
        "text": "平谷区"
      }, {
        "id": "18-o0",
        "value": "密云区",
        "text": "密云区"
      }, {
        "id": "19-aw",
        "value": "延庆区",
        "text": "延庆区"
      } ],
      "id": "3-y9",
      "value": "北京市",
      "text": "北京市"
    } ],
    "id": "2-Cy",
    "value": "北京市",
    "text": "北京市"
  }, {
    "children": [ {
      "children": [ {
        "id": "22-4N",
        "value": "和平区",
        "text": "和平区"
      }, {
        "id": "23-dA",
        "value": "河东区",
        "text": "河东区"
      }, {
        "id": "24-V7",
        "value": "河西区",
        "text": "河西区"
      }, {
        "id": "25-gf",
        "value": "南开区",
        "text": "南开区"
      }, {
        "id": "26-rl",
        "value": "河北区",
        "text": "河北区"
      }, {
        "id": "27-W0",
        "value": "红桥区",
        "text": "红桥区"
      }, {
        "id": "28-4J",
        "value": "东丽区",
        "text": "东丽区"
      }, {
        "id": "29-Ee",
        "value": "西青区",
        "text": "西青区"
      }, {
        "id": "30-kV",
        "value": "津南区",
        "text": "津南区"
      }, {
        "id": "31-up",
        "value": "北辰区",
        "text": "北辰区"
      }, {
        "id": "32-nL",
        "value": "武清区",
        "text": "武清区"
      }, {
        "id": "33-Qv",
        "value": "宝坻区",
        "text": "宝坻区"
      }, {
        "id": "34-gm",
        "value": "滨海新区",
        "text": "滨海新区"
      }, {
        "id": "35-5k",
        "value": "宁河区",
        "text": "宁河区"
      }, {
        "id": "36-Fo",
        "value": "静海区",
        "text": "静海区"
      }, {
        "id": "37-wT",
        "value": "蓟州区",
        "text": "蓟州区"
      } ],
      "id": "21-oj",
      "value": "天津市",
      "text": "天津市"
    } ],
    "id": "20-QB",
    "value": "天津市",
    "text": "天津市"
  }, {
    "children": [ {
      "children": [ {
        "id": "40-Al",
        "value": "长安区",
        "text": "长安区"
      }, {
        "id": "41-UY",
        "value": "桥西区",
        "text": "桥西区"
      }, {
        "id": "42-zz",
        "value": "新华区",
        "text": "新华区"
      }, {
        "id": "43-ZD",
        "value": "井陉矿区",
        "text": "井陉矿区"
      }, {
        "id": "44-Zf",
        "value": "裕华区",
        "text": "裕华区"
      }, {
        "id": "45-sy",
        "value": "藁城区",
        "text": "藁城区"
      }, {
        "id": "46-5x",
        "value": "鹿泉区",
        "text": "鹿泉区"
      }, {
        "id": "47-6D",
        "value": "栾城区",
        "text": "栾城区"
      }, {
        "id": "48-aB",
        "value": "井陉县",
        "text": "井陉县"
      }, {
        "id": "49-6k",
        "value": "正定县",
        "text": "正定县"
      }, {
        "id": "50-wn",
        "value": "行唐县",
        "text": "行唐县"
      }, {
        "id": "51-xF",
        "value": "灵寿县",
        "text": "灵寿县"
      }, {
        "id": "52-Zl",
        "value": "高邑县",
        "text": "高邑县"
      }, {
        "id": "53-z3",
        "value": "深泽县",
        "text": "深泽县"
      }, {
        "id": "54-nA",
        "value": "赞皇县",
        "text": "赞皇县"
      }, {
        "id": "55-V6",
        "value": "无极县",
        "text": "无极县"
      }, {
        "id": "56-Ie",
        "value": "平山县",
        "text": "平山县"
      }, {
        "id": "57-gm",
        "value": "元氏县",
        "text": "元氏县"
      }, {
        "id": "58-M1",
        "value": "赵县",
        "text": "赵县"
      }, {
        "id": "59-lM",
        "value": "晋州市",
        "text": "晋州市"
      }, {
        "id": "60-DJ",
        "value": "新乐市",
        "text": "新乐市"
      } ],
      "id": "39-8M",
      "value": "石家庄市",
      "text": "石家庄市"
    }, {
      "children": [ {
        "id": "62-Mf",
        "value": "路南区",
        "text": "路南区"
      }, {
        "id": "63-Oi",
        "value": "路北区",
        "text": "路北区"
      }, {
        "id": "64-6O",
        "value": "古冶区",
        "text": "古冶区"
      }, {
        "id": "65-pu",
        "value": "开平区",
        "text": "开平区"
      }, {
        "id": "66-64",
        "value": "丰南区",
        "text": "丰南区"
      }, {
        "id": "67-zE",
        "value": "丰润区",
        "text": "丰润区"
      }, {
        "id": "68-0D",
        "value": "曹妃甸区",
        "text": "曹妃甸区"
      }, {
        "id": "69-8x",
        "value": "滦县",
        "text": "滦县"
      }, {
        "id": "70-kT",
        "value": "滦南县",
        "text": "滦南县"
      }, {
        "id": "71-Ac",
        "value": "乐亭县",
        "text": "乐亭县"
      }, {
        "id": "72-Lc",
        "value": "迁西县",
        "text": "迁西县"
      }, {
        "id": "73-yG",
        "value": "玉田县",
        "text": "玉田县"
      }, {
        "id": "74-eb",
        "value": "遵化市",
        "text": "遵化市"
      }, {
        "id": "75-Xn",
        "value": "迁安市",
        "text": "迁安市"
      } ],
      "id": "61-16",
      "value": "唐山市",
      "text": "唐山市"
    }, {
      "children": [ {
        "id": "77-MJ",
        "value": "海港区",
        "text": "海港区"
      }, {
        "id": "78-tz",
        "value": "山海关区",
        "text": "山海关区"
      }, {
        "id": "79-6R",
        "value": "北戴河区",
        "text": "北戴河区"
      }, {
        "id": "80-s5",
        "value": "抚宁区",
        "text": "抚宁区"
      }, {
        "id": "81-0h",
        "value": "青龙满族自治县",
        "text": "青龙满族自治县"
      }, {
        "id": "82-b6",
        "value": "昌黎县",
        "text": "昌黎县"
      }, {
        "id": "83-Sa",
        "value": "卢龙县",
        "text": "卢龙县"
      } ],
      "id": "76-vG",
      "value": "秦皇岛市",
      "text": "秦皇岛市"
    }, {
      "children": [ {
        "id": "85-C2",
        "value": "邯山区",
        "text": "邯山区"
      }, {
        "id": "86-MD",
        "value": "丛台区",
        "text": "丛台区"
      }, {
        "id": "87-YQ",
        "value": "复兴区",
        "text": "复兴区"
      }, {
        "id": "88-Ce",
        "value": "峰峰矿区",
        "text": "峰峰矿区"
      }, {
        "id": "89-UK",
        "value": "邯郸县",
        "text": "邯郸县"
      }, {
        "id": "90-xh",
        "value": "临漳县",
        "text": "临漳县"
      }, {
        "id": "91-kf",
        "value": "成安县",
        "text": "成安县"
      }, {
        "id": "92-UJ",
        "value": "大名县",
        "text": "大名县"
      }, {
        "id": "93-9z",
        "value": "涉县",
        "text": "涉县"
      }, {
        "id": "94-GG",
        "value": "磁县",
        "text": "磁县"
      }, {
        "id": "95-zG",
        "value": "肥乡县",
        "text": "肥乡县"
      }, {
        "id": "96-KW",
        "value": "永年县",
        "text": "永年县"
      }, {
        "id": "97-KM",
        "value": "邱县",
        "text": "邱县"
      }, {
        "id": "98-8Q",
        "value": "鸡泽县",
        "text": "鸡泽县"
      }, {
        "id": "99-1X",
        "value": "广平县",
        "text": "广平县"
      }, {
        "id": "100-fN",
        "value": "馆陶县",
        "text": "馆陶县"
      }, {
        "id": "101-Ai",
        "value": "魏县",
        "text": "魏县"
      }, {
        "id": "102-JP",
        "value": "曲周县",
        "text": "曲周县"
      }, {
        "id": "103-CG",
        "value": "武安市",
        "text": "武安市"
      } ],
      "id": "84-62",
      "value": "邯郸市",
      "text": "邯郸市"
    }, {
      "children": [ {
        "id": "105-73",
        "value": "桥东区",
        "text": "桥东区"
      }, {
        "id": "106-9q",
        "value": "桥西区",
        "text": "桥西区"
      }, {
        "id": "107-F1",
        "value": "邢台县",
        "text": "邢台县"
      }, {
        "id": "108-Nf",
        "value": "临城县",
        "text": "临城县"
      }, {
        "id": "109-Ww",
        "value": "内丘县",
        "text": "内丘县"
      }, {
        "id": "110-R5",
        "value": "柏乡县",
        "text": "柏乡县"
      }, {
        "id": "111-T7",
        "value": "隆尧县",
        "text": "隆尧县"
      }, {
        "id": "112-Ic",
        "value": "任县",
        "text": "任县"
      }, {
        "id": "113-Oy",
        "value": "南和县",
        "text": "南和县"
      }, {
        "id": "114-ia",
        "value": "宁晋县",
        "text": "宁晋县"
      }, {
        "id": "115-so",
        "value": "巨鹿县",
        "text": "巨鹿县"
      }, {
        "id": "116-zd",
        "value": "新河县",
        "text": "新河县"
      }, {
        "id": "117-eB",
        "value": "广宗县",
        "text": "广宗县"
      }, {
        "id": "118-JA",
        "value": "平乡县",
        "text": "平乡县"
      }, {
        "id": "119-Fi",
        "value": "威县",
        "text": "威县"
      }, {
        "id": "120-om",
        "value": "清河县",
        "text": "清河县"
      }, {
        "id": "121-yt",
        "value": "临西县",
        "text": "临西县"
      }, {
        "id": "122-cW",
        "value": "南宫市",
        "text": "南宫市"
      }, {
        "id": "123-M0",
        "value": "沙河市",
        "text": "沙河市"
      } ],
      "id": "104-DM",
      "value": "邢台市",
      "text": "邢台市"
    }, {
      "children": [ {
        "id": "125-3F",
        "value": "竞秀区",
        "text": "竞秀区"
      }, {
        "id": "126-km",
        "value": "莲池区",
        "text": "莲池区"
      }, {
        "id": "127-ur",
        "value": "满城区",
        "text": "满城区"
      }, {
        "id": "128-j4",
        "value": "清苑区",
        "text": "清苑区"
      }, {
        "id": "129-tZ",
        "value": "徐水区",
        "text": "徐水区"
      }, {
        "id": "130-Pg",
        "value": "涞水县",
        "text": "涞水县"
      }, {
        "id": "131-cG",
        "value": "阜平县",
        "text": "阜平县"
      }, {
        "id": "132-C9",
        "value": "定兴县",
        "text": "定兴县"
      }, {
        "id": "133-ld",
        "value": "唐县",
        "text": "唐县"
      }, {
        "id": "134-bI",
        "value": "高阳县",
        "text": "高阳县"
      }, {
        "id": "135-bh",
        "value": "容城县",
        "text": "容城县"
      }, {
        "id": "136-Hv",
        "value": "涞源县",
        "text": "涞源县"
      }, {
        "id": "137-Cr",
        "value": "望都县",
        "text": "望都县"
      }, {
        "id": "138-wX",
        "value": "安新县",
        "text": "安新县"
      }, {
        "id": "139-jQ",
        "value": "易县",
        "text": "易县"
      }, {
        "id": "140-zK",
        "value": "曲阳县",
        "text": "曲阳县"
      }, {
        "id": "141-Ss",
        "value": "蠡县",
        "text": "蠡县"
      }, {
        "id": "142-im",
        "value": "顺平县",
        "text": "顺平县"
      }, {
        "id": "143-RZ",
        "value": "博野县",
        "text": "博野县"
      }, {
        "id": "144-Rc",
        "value": "雄县",
        "text": "雄县"
      }, {
        "id": "145-Rc",
        "value": "涿州市",
        "text": "涿州市"
      }, {
        "id": "146-Ho",
        "value": "安国市",
        "text": "安国市"
      }, {
        "id": "147-Li",
        "value": "高碑店市",
        "text": "高碑店市"
      } ],
      "id": "124-75",
      "value": "保定市",
      "text": "保定市"
    }, {
      "children": [ {
        "id": "149-BL",
        "value": "桥东区",
        "text": "桥东区"
      }, {
        "id": "150-DT",
        "value": "桥西区",
        "text": "桥西区"
      }, {
        "id": "151-I9",
        "value": "宣化区",
        "text": "宣化区"
      }, {
        "id": "152-Lp",
        "value": "下花园区",
        "text": "下花园区"
      }, {
        "id": "153-PI",
        "value": "万全区",
        "text": "万全区"
      }, {
        "id": "154-jQ",
        "value": "崇礼区",
        "text": "崇礼区"
      }, {
        "id": "155-UT",
        "value": "张北县",
        "text": "张北县"
      }, {
        "id": "156-dv",
        "value": "康保县",
        "text": "康保县"
      }, {
        "id": "157-ET",
        "value": "沽源县",
        "text": "沽源县"
      }, {
        "id": "158-5m",
        "value": "尚义县",
        "text": "尚义县"
      }, {
        "id": "159-eV",
        "value": "蔚县",
        "text": "蔚县"
      }, {
        "id": "160-Vv",
        "value": "阳原县",
        "text": "阳原县"
      }, {
        "id": "161-e8",
        "value": "怀安县",
        "text": "怀安县"
      }, {
        "id": "162-77",
        "value": "怀来县",
        "text": "怀来县"
      }, {
        "id": "163-ES",
        "value": "涿鹿县",
        "text": "涿鹿县"
      }, {
        "id": "164-IH",
        "value": "赤城县",
        "text": "赤城县"
      } ],
      "id": "148-if",
      "value": "张家口市",
      "text": "张家口市"
    }, {
      "children": [ {
        "id": "166-jS",
        "value": "双桥区",
        "text": "双桥区"
      }, {
        "id": "167-8H",
        "value": "双滦区",
        "text": "双滦区"
      }, {
        "id": "168-4o",
        "value": "鹰手营子矿区",
        "text": "鹰手营子矿区"
      }, {
        "id": "169-AJ",
        "value": "承德县",
        "text": "承德县"
      }, {
        "id": "170-BL",
        "value": "兴隆县",
        "text": "兴隆县"
      }, {
        "id": "171-nG",
        "value": "平泉县",
        "text": "平泉县"
      }, {
        "id": "172-Hn",
        "value": "滦平县",
        "text": "滦平县"
      }, {
        "id": "173-AU",
        "value": "隆化县",
        "text": "隆化县"
      }, {
        "id": "174-tQ",
        "value": "丰宁满族自治县",
        "text": "丰宁满族自治县"
      }, {
        "id": "175-b6",
        "value": "宽城满族自治县",
        "text": "宽城满族自治县"
      }, {
        "id": "176-WA",
        "value": "围场满族蒙古族自治县",
        "text": "围场满族蒙古族自治县"
      } ],
      "id": "165-pH",
      "value": "承德市",
      "text": "承德市"
    }, {
      "children": [ {
        "id": "178-XB",
        "value": "新华区",
        "text": "新华区"
      }, {
        "id": "179-DI",
        "value": "运河区",
        "text": "运河区"
      }, {
        "id": "180-xV",
        "value": "沧县",
        "text": "沧县"
      }, {
        "id": "181-sH",
        "value": "青县",
        "text": "青县"
      }, {
        "id": "182-j4",
        "value": "东光县",
        "text": "东光县"
      }, {
        "id": "183-Hq",
        "value": "海兴县",
        "text": "海兴县"
      }, {
        "id": "184-jS",
        "value": "盐山县",
        "text": "盐山县"
      }, {
        "id": "185-Kj",
        "value": "肃宁县",
        "text": "肃宁县"
      }, {
        "id": "186-Zz",
        "value": "南皮县",
        "text": "南皮县"
      }, {
        "id": "187-79",
        "value": "吴桥县",
        "text": "吴桥县"
      }, {
        "id": "188-sx",
        "value": "献县",
        "text": "献县"
      }, {
        "id": "189-C0",
        "value": "孟村回族自治县",
        "text": "孟村回族自治县"
      }, {
        "id": "190-DH",
        "value": "泊头市",
        "text": "泊头市"
      }, {
        "id": "191-tz",
        "value": "任丘市",
        "text": "任丘市"
      }, {
        "id": "192-X8",
        "value": "黄骅市",
        "text": "黄骅市"
      }, {
        "id": "193-e3",
        "value": "河间市",
        "text": "河间市"
      } ],
      "id": "177-je",
      "value": "沧州市",
      "text": "沧州市"
    }, {
      "children": [ {
        "id": "195-P2",
        "value": "安次区",
        "text": "安次区"
      }, {
        "id": "196-Ie",
        "value": "广阳区",
        "text": "广阳区"
      }, {
        "id": "197-p6",
        "value": "固安县",
        "text": "固安县"
      }, {
        "id": "198-9T",
        "value": "永清县",
        "text": "永清县"
      }, {
        "id": "199-v1",
        "value": "香河县",
        "text": "香河县"
      }, {
        "id": "200-fC",
        "value": "大城县",
        "text": "大城县"
      }, {
        "id": "201-mu",
        "value": "文安县",
        "text": "文安县"
      }, {
        "id": "202-ub",
        "value": "大厂回族自治县",
        "text": "大厂回族自治县"
      }, {
        "id": "203-je",
        "value": "霸州市",
        "text": "霸州市"
      }, {
        "id": "204-Gg",
        "value": "三河市",
        "text": "三河市"
      } ],
      "id": "194-sU",
      "value": "廊坊市",
      "text": "廊坊市"
    }, {
      "children": [ {
        "id": "206-ee",
        "value": "桃城区",
        "text": "桃城区"
      }, {
        "id": "207-Mt",
        "value": "冀州区",
        "text": "冀州区"
      }, {
        "id": "208-UL",
        "value": "枣强县",
        "text": "枣强县"
      }, {
        "id": "209-8S",
        "value": "武邑县",
        "text": "武邑县"
      }, {
        "id": "210-TZ",
        "value": "武强县",
        "text": "武强县"
      }, {
        "id": "211-oQ",
        "value": "饶阳县",
        "text": "饶阳县"
      }, {
        "id": "212-o6",
        "value": "安平县",
        "text": "安平县"
      }, {
        "id": "213-OK",
        "value": "故城县",
        "text": "故城县"
      }, {
        "id": "214-4a",
        "value": "景县",
        "text": "景县"
      }, {
        "id": "215-Wg",
        "value": "阜城县",
        "text": "阜城县"
      }, {
        "id": "216-xO",
        "value": "深州市",
        "text": "深州市"
      } ],
      "id": "205-fH",
      "value": "衡水市",
      "text": "衡水市"
    }, {
      "children": [ {
        "id": "218-d1",
        "value": "定州市",
        "text": "定州市"
      }, {
        "id": "219-nE",
        "value": "辛集市",
        "text": "辛集市"
      } ],
      "id": "217-bn",
      "value": "省直辖县级行政区划",
      "text": "省直辖县级行政区划"
    } ],
    "id": "38-vP",
    "value": "河北省",
    "text": "河北省"
  }, {
    "children": [ {
      "children": [ {
        "id": "222-ht",
        "value": "小店区",
        "text": "小店区"
      }, {
        "id": "223-en",
        "value": "迎泽区",
        "text": "迎泽区"
      }, {
        "id": "224-yy",
        "value": "杏花岭区",
        "text": "杏花岭区"
      }, {
        "id": "225-Q5",
        "value": "尖草坪区",
        "text": "尖草坪区"
      }, {
        "id": "226-NA",
        "value": "万柏林区",
        "text": "万柏林区"
      }, {
        "id": "227-96",
        "value": "晋源区",
        "text": "晋源区"
      }, {
        "id": "228-f2",
        "value": "清徐县",
        "text": "清徐县"
      }, {
        "id": "229-YP",
        "value": "阳曲县",
        "text": "阳曲县"
      }, {
        "id": "230-5I",
        "value": "娄烦县",
        "text": "娄烦县"
      }, {
        "id": "231-nu",
        "value": "古交市",
        "text": "古交市"
      } ],
      "id": "221-7R",
      "value": "太原市",
      "text": "太原市"
    }, {
      "children": [ {
        "id": "233-xH",
        "value": "城区",
        "text": "城区"
      }, {
        "id": "234-V2",
        "value": "矿区",
        "text": "矿区"
      }, {
        "id": "235-a2",
        "value": "南郊区",
        "text": "南郊区"
      }, {
        "id": "236-lc",
        "value": "新荣区",
        "text": "新荣区"
      }, {
        "id": "237-Lf",
        "value": "阳高县",
        "text": "阳高县"
      }, {
        "id": "238-sq",
        "value": "天镇县",
        "text": "天镇县"
      }, {
        "id": "239-WZ",
        "value": "广灵县",
        "text": "广灵县"
      }, {
        "id": "240-ht",
        "value": "灵丘县",
        "text": "灵丘县"
      }, {
        "id": "241-iL",
        "value": "浑源县",
        "text": "浑源县"
      }, {
        "id": "242-8F",
        "value": "左云县",
        "text": "左云县"
      }, {
        "id": "243-Pb",
        "value": "大同县",
        "text": "大同县"
      } ],
      "id": "232-QO",
      "value": "大同市",
      "text": "大同市"
    }, {
      "children": [ {
        "id": "245-eh",
        "value": "城区",
        "text": "城区"
      }, {
        "id": "246-Ev",
        "value": "矿区",
        "text": "矿区"
      }, {
        "id": "247-qm",
        "value": "郊区",
        "text": "郊区"
      }, {
        "id": "248-hZ",
        "value": "平定县",
        "text": "平定县"
      }, {
        "id": "249-b1",
        "value": "盂县",
        "text": "盂县"
      } ],
      "id": "244-I2",
      "value": "阳泉市",
      "text": "阳泉市"
    }, {
      "children": [ {
        "id": "251-7W",
        "value": "城区",
        "text": "城区"
      }, {
        "id": "252-db",
        "value": "郊区",
        "text": "郊区"
      }, {
        "id": "253-Ed",
        "value": "长治县",
        "text": "长治县"
      }, {
        "id": "254-nZ",
        "value": "襄垣县",
        "text": "襄垣县"
      }, {
        "id": "255-Z6",
        "value": "屯留县",
        "text": "屯留县"
      }, {
        "id": "256-tf",
        "value": "平顺县",
        "text": "平顺县"
      }, {
        "id": "257-O5",
        "value": "黎城县",
        "text": "黎城县"
      }, {
        "id": "258-k0",
        "value": "壶关县",
        "text": "壶关县"
      }, {
        "id": "259-r2",
        "value": "长子县",
        "text": "长子县"
      }, {
        "id": "260-LK",
        "value": "武乡县",
        "text": "武乡县"
      }, {
        "id": "261-MF",
        "value": "沁县",
        "text": "沁县"
      }, {
        "id": "262-5i",
        "value": "沁源县",
        "text": "沁源县"
      }, {
        "id": "263-ma",
        "value": "潞城市",
        "text": "潞城市"
      } ],
      "id": "250-Qv",
      "value": "长治市",
      "text": "长治市"
    }, {
      "children": [ {
        "id": "265-He",
        "value": "城区",
        "text": "城区"
      }, {
        "id": "266-ak",
        "value": "沁水县",
        "text": "沁水县"
      }, {
        "id": "267-O3",
        "value": "阳城县",
        "text": "阳城县"
      }, {
        "id": "268-tF",
        "value": "陵川县",
        "text": "陵川县"
      }, {
        "id": "269-RU",
        "value": "泽州县",
        "text": "泽州县"
      }, {
        "id": "270-DT",
        "value": "高平市",
        "text": "高平市"
      } ],
      "id": "264-rz",
      "value": "晋城市",
      "text": "晋城市"
    }, {
      "children": [ {
        "id": "272-NP",
        "value": "朔城区",
        "text": "朔城区"
      }, {
        "id": "273-qm",
        "value": "平鲁区",
        "text": "平鲁区"
      }, {
        "id": "274-1m",
        "value": "山阴县",
        "text": "山阴县"
      }, {
        "id": "275-Iv",
        "value": "应县",
        "text": "应县"
      }, {
        "id": "276-7c",
        "value": "右玉县",
        "text": "右玉县"
      }, {
        "id": "277-eo",
        "value": "怀仁县",
        "text": "怀仁县"
      } ],
      "id": "271-r1",
      "value": "朔州市",
      "text": "朔州市"
    }, {
      "children": [ {
        "id": "279-5d",
        "value": "榆次区",
        "text": "榆次区"
      }, {
        "id": "280-E2",
        "value": "榆社县",
        "text": "榆社县"
      }, {
        "id": "281-nF",
        "value": "左权县",
        "text": "左权县"
      }, {
        "id": "282-1m",
        "value": "和顺县",
        "text": "和顺县"
      }, {
        "id": "283-b8",
        "value": "昔阳县",
        "text": "昔阳县"
      }, {
        "id": "284-YV",
        "value": "寿阳县",
        "text": "寿阳县"
      }, {
        "id": "285-Q0",
        "value": "太谷县",
        "text": "太谷县"
      }, {
        "id": "286-bl",
        "value": "祁县",
        "text": "祁县"
      }, {
        "id": "287-qE",
        "value": "平遥县",
        "text": "平遥县"
      }, {
        "id": "288-bH",
        "value": "灵石县",
        "text": "灵石县"
      }, {
        "id": "289-ml",
        "value": "介休市",
        "text": "介休市"
      } ],
      "id": "278-hI",
      "value": "晋中市",
      "text": "晋中市"
    }, {
      "children": [ {
        "id": "291-u6",
        "value": "盐湖区",
        "text": "盐湖区"
      }, {
        "id": "292-Oq",
        "value": "临猗县",
        "text": "临猗县"
      }, {
        "id": "293-77",
        "value": "万荣县",
        "text": "万荣县"
      }, {
        "id": "294-sQ",
        "value": "闻喜县",
        "text": "闻喜县"
      }, {
        "id": "295-4V",
        "value": "稷山县",
        "text": "稷山县"
      }, {
        "id": "296-of",
        "value": "新绛县",
        "text": "新绛县"
      }, {
        "id": "297-T9",
        "value": "绛县",
        "text": "绛县"
      }, {
        "id": "298-tq",
        "value": "垣曲县",
        "text": "垣曲县"
      }, {
        "id": "299-ZH",
        "value": "夏县",
        "text": "夏县"
      }, {
        "id": "300-G6",
        "value": "平陆县",
        "text": "平陆县"
      }, {
        "id": "301-Qy",
        "value": "芮城县",
        "text": "芮城县"
      }, {
        "id": "302-0H",
        "value": "永济市",
        "text": "永济市"
      }, {
        "id": "303-DH",
        "value": "河津市",
        "text": "河津市"
      } ],
      "id": "290-sB",
      "value": "运城市",
      "text": "运城市"
    }, {
      "children": [ {
        "id": "305-ZX",
        "value": "忻府区",
        "text": "忻府区"
      }, {
        "id": "306-0a",
        "value": "定襄县",
        "text": "定襄县"
      }, {
        "id": "307-TB",
        "value": "五台县",
        "text": "五台县"
      }, {
        "id": "308-ln",
        "value": "代县",
        "text": "代县"
      }, {
        "id": "309-F9",
        "value": "繁峙县",
        "text": "繁峙县"
      }, {
        "id": "310-xb",
        "value": "宁武县",
        "text": "宁武县"
      }, {
        "id": "311-8u",
        "value": "静乐县",
        "text": "静乐县"
      }, {
        "id": "312-17",
        "value": "神池县",
        "text": "神池县"
      }, {
        "id": "313-9g",
        "value": "五寨县",
        "text": "五寨县"
      }, {
        "id": "314-Zx",
        "value": "岢岚县",
        "text": "岢岚县"
      }, {
        "id": "315-9Y",
        "value": "河曲县",
        "text": "河曲县"
      }, {
        "id": "316-rv",
        "value": "保德县",
        "text": "保德县"
      }, {
        "id": "317-6T",
        "value": "偏关县",
        "text": "偏关县"
      }, {
        "id": "318-Zk",
        "value": "原平市",
        "text": "原平市"
      } ],
      "id": "304-nr",
      "value": "忻州市",
      "text": "忻州市"
    }, {
      "children": [ {
        "id": "320-Iz",
        "value": "尧都区",
        "text": "尧都区"
      }, {
        "id": "321-Ra",
        "value": "曲沃县",
        "text": "曲沃县"
      }, {
        "id": "322-xd",
        "value": "翼城县",
        "text": "翼城县"
      }, {
        "id": "323-LO",
        "value": "襄汾县",
        "text": "襄汾县"
      }, {
        "id": "324-OH",
        "value": "洪洞县",
        "text": "洪洞县"
      }, {
        "id": "325-Wx",
        "value": "古县",
        "text": "古县"
      }, {
        "id": "326-cT",
        "value": "安泽县",
        "text": "安泽县"
      }, {
        "id": "327-W4",
        "value": "浮山县",
        "text": "浮山县"
      }, {
        "id": "328-5G",
        "value": "吉县",
        "text": "吉县"
      }, {
        "id": "329-gZ",
        "value": "乡宁县",
        "text": "乡宁县"
      }, {
        "id": "330-4s",
        "value": "大宁县",
        "text": "大宁县"
      }, {
        "id": "331-c1",
        "value": "隰县",
        "text": "隰县"
      }, {
        "id": "332-S5",
        "value": "永和县",
        "text": "永和县"
      }, {
        "id": "333-sq",
        "value": "蒲县",
        "text": "蒲县"
      }, {
        "id": "334-eY",
        "value": "汾西县",
        "text": "汾西县"
      }, {
        "id": "335-dp",
        "value": "侯马市",
        "text": "侯马市"
      }, {
        "id": "336-GG",
        "value": "霍州市",
        "text": "霍州市"
      } ],
      "id": "319-4T",
      "value": "临汾市",
      "text": "临汾市"
    }, {
      "children": [ {
        "id": "338-iH",
        "value": "离石区",
        "text": "离石区"
      }, {
        "id": "339-Kn",
        "value": "文水县",
        "text": "文水县"
      }, {
        "id": "340-7b",
        "value": "交城县",
        "text": "交城县"
      }, {
        "id": "341-6w",
        "value": "兴县",
        "text": "兴县"
      }, {
        "id": "342-K9",
        "value": "临县",
        "text": "临县"
      }, {
        "id": "343-nB",
        "value": "柳林县",
        "text": "柳林县"
      }, {
        "id": "344-6j",
        "value": "石楼县",
        "text": "石楼县"
      }, {
        "id": "345-oY",
        "value": "岚县",
        "text": "岚县"
      }, {
        "id": "346-Ii",
        "value": "方山县",
        "text": "方山县"
      }, {
        "id": "347-69",
        "value": "中阳县",
        "text": "中阳县"
      }, {
        "id": "348-AY",
        "value": "交口县",
        "text": "交口县"
      }, {
        "id": "349-Ns",
        "value": "孝义市",
        "text": "孝义市"
      }, {
        "id": "350-3V",
        "value": "汾阳市",
        "text": "汾阳市"
      } ],
      "id": "337-94",
      "value": "吕梁市",
      "text": "吕梁市"
    } ],
    "id": "220-Ep",
    "value": "山西省",
    "text": "山西省"
  }, {
    "children": [ {
      "children": [ {
        "id": "353-wJ",
        "value": "新城区",
        "text": "新城区"
      }, {
        "id": "354-FM",
        "value": "回民区",
        "text": "回民区"
      }, {
        "id": "355-HP",
        "value": "玉泉区",
        "text": "玉泉区"
      }, {
        "id": "356-RT",
        "value": "赛罕区",
        "text": "赛罕区"
      }, {
        "id": "357-66",
        "value": "土默特左旗",
        "text": "土默特左旗"
      }, {
        "id": "358-KD",
        "value": "托克托县",
        "text": "托克托县"
      }, {
        "id": "359-UA",
        "value": "和林格尔县",
        "text": "和林格尔县"
      }, {
        "id": "360-qd",
        "value": "清水河县",
        "text": "清水河县"
      }, {
        "id": "361-79",
        "value": "武川县",
        "text": "武川县"
      } ],
      "id": "352-BR",
      "value": "呼和浩特市",
      "text": "呼和浩特市"
    }, {
      "children": [ {
        "id": "363-8s",
        "value": "东河区",
        "text": "东河区"
      }, {
        "id": "364-So",
        "value": "昆都仑区",
        "text": "昆都仑区"
      }, {
        "id": "365-fm",
        "value": "青山区",
        "text": "青山区"
      }, {
        "id": "366-ZX",
        "value": "石拐区",
        "text": "石拐区"
      }, {
        "id": "367-IX",
        "value": "白云鄂博矿区",
        "text": "白云鄂博矿区"
      }, {
        "id": "368-Qa",
        "value": "九原区",
        "text": "九原区"
      }, {
        "id": "369-B2",
        "value": "土默特右旗",
        "text": "土默特右旗"
      }, {
        "id": "370-nU",
        "value": "固阳县",
        "text": "固阳县"
      }, {
        "id": "371-Ht",
        "value": "达尔罕茂明安联合旗",
        "text": "达尔罕茂明安联合旗"
      } ],
      "id": "362-mE",
      "value": "包头市",
      "text": "包头市"
    }, {
      "children": [ {
        "id": "373-UF",
        "value": "海勃湾区",
        "text": "海勃湾区"
      }, {
        "id": "374-aV",
        "value": "海南区",
        "text": "海南区"
      }, {
        "id": "375-Kp",
        "value": "乌达区",
        "text": "乌达区"
      } ],
      "id": "372-er",
      "value": "乌海市",
      "text": "乌海市"
    }, {
      "children": [ {
        "id": "377-9x",
        "value": "红山区",
        "text": "红山区"
      }, {
        "id": "378-IV",
        "value": "元宝山区",
        "text": "元宝山区"
      }, {
        "id": "379-KJ",
        "value": "松山区",
        "text": "松山区"
      }, {
        "id": "380-JH",
        "value": "阿鲁科尔沁旗",
        "text": "阿鲁科尔沁旗"
      }, {
        "id": "381-jN",
        "value": "巴林左旗",
        "text": "巴林左旗"
      }, {
        "id": "382-iZ",
        "value": "巴林右旗",
        "text": "巴林右旗"
      }, {
        "id": "383-Pi",
        "value": "林西县",
        "text": "林西县"
      }, {
        "id": "384-nB",
        "value": "克什克腾旗",
        "text": "克什克腾旗"
      }, {
        "id": "385-uO",
        "value": "翁牛特旗",
        "text": "翁牛特旗"
      }, {
        "id": "386-gw",
        "value": "喀喇沁旗",
        "text": "喀喇沁旗"
      }, {
        "id": "387-xL",
        "value": "宁城县",
        "text": "宁城县"
      }, {
        "id": "388-et",
        "value": "敖汉旗",
        "text": "敖汉旗"
      } ],
      "id": "376-IU",
      "value": "赤峰市",
      "text": "赤峰市"
    }, {
      "children": [ {
        "id": "390-fg",
        "value": "科尔沁区",
        "text": "科尔沁区"
      }, {
        "id": "391-l8",
        "value": "科尔沁左翼中旗",
        "text": "科尔沁左翼中旗"
      }, {
        "id": "392-iE",
        "value": "科尔沁左翼后旗",
        "text": "科尔沁左翼后旗"
      }, {
        "id": "393-99",
        "value": "开鲁县",
        "text": "开鲁县"
      }, {
        "id": "394-oa",
        "value": "库伦旗",
        "text": "库伦旗"
      }, {
        "id": "395-dA",
        "value": "奈曼旗",
        "text": "奈曼旗"
      }, {
        "id": "396-K8",
        "value": "扎鲁特旗",
        "text": "扎鲁特旗"
      }, {
        "id": "397-HS",
        "value": "霍林郭勒市",
        "text": "霍林郭勒市"
      } ],
      "id": "389-pR",
      "value": "通辽市",
      "text": "通辽市"
    }, {
      "children": [ {
        "id": "399-3j",
        "value": "东胜区",
        "text": "东胜区"
      }, {
        "id": "400-JK",
        "value": "康巴什区",
        "text": "康巴什区"
      }, {
        "id": "401-Xn",
        "value": "达拉特旗",
        "text": "达拉特旗"
      }, {
        "id": "402-Lq",
        "value": "准格尔旗",
        "text": "准格尔旗"
      }, {
        "id": "403-BA",
        "value": "鄂托克前旗",
        "text": "鄂托克前旗"
      }, {
        "id": "404-jr",
        "value": "鄂托克旗",
        "text": "鄂托克旗"
      }, {
        "id": "405-xG",
        "value": "杭锦旗",
        "text": "杭锦旗"
      }, {
        "id": "406-zD",
        "value": "乌审旗",
        "text": "乌审旗"
      }, {
        "id": "407-sf",
        "value": "伊金霍洛旗",
        "text": "伊金霍洛旗"
      } ],
      "id": "398-TS",
      "value": "鄂尔多斯市",
      "text": "鄂尔多斯市"
    }, {
      "children": [ {
        "id": "409-y9",
        "value": "海拉尔区",
        "text": "海拉尔区"
      }, {
        "id": "410-3l",
        "value": "扎赉诺尔区",
        "text": "扎赉诺尔区"
      }, {
        "id": "411-be",
        "value": "阿荣旗",
        "text": "阿荣旗"
      }, {
        "id": "412-kF",
        "value": "莫力达瓦达斡尔族自治旗",
        "text": "莫力达瓦达斡尔族自治旗"
      }, {
        "id": "413-m9",
        "value": "鄂伦春自治旗",
        "text": "鄂伦春自治旗"
      }, {
        "id": "414-zA",
        "value": "鄂温克族自治旗",
        "text": "鄂温克族自治旗"
      }, {
        "id": "415-Zf",
        "value": "陈巴尔虎旗",
        "text": "陈巴尔虎旗"
      }, {
        "id": "416-Wc",
        "value": "新巴尔虎左旗",
        "text": "新巴尔虎左旗"
      }, {
        "id": "417-Nl",
        "value": "新巴尔虎右旗",
        "text": "新巴尔虎右旗"
      }, {
        "id": "418-jf",
        "value": "满洲里市",
        "text": "满洲里市"
      }, {
        "id": "419-OZ",
        "value": "牙克石市",
        "text": "牙克石市"
      }, {
        "id": "420-Pf",
        "value": "扎兰屯市",
        "text": "扎兰屯市"
      }, {
        "id": "421-d6",
        "value": "额尔古纳市",
        "text": "额尔古纳市"
      }, {
        "id": "422-sx",
        "value": "根河市",
        "text": "根河市"
      } ],
      "id": "408-AB",
      "value": "呼伦贝尔市",
      "text": "呼伦贝尔市"
    }, {
      "children": [ {
        "id": "424-Nt",
        "value": "临河区",
        "text": "临河区"
      }, {
        "id": "425-w2",
        "value": "五原县",
        "text": "五原县"
      }, {
        "id": "426-cK",
        "value": "磴口县",
        "text": "磴口县"
      }, {
        "id": "427-28",
        "value": "乌拉特前旗",
        "text": "乌拉特前旗"
      }, {
        "id": "428-fH",
        "value": "乌拉特中旗",
        "text": "乌拉特中旗"
      }, {
        "id": "429-y0",
        "value": "乌拉特后旗",
        "text": "乌拉特后旗"
      }, {
        "id": "430-2b",
        "value": "杭锦后旗",
        "text": "杭锦后旗"
      } ],
      "id": "423-60",
      "value": "巴彦淖尔市",
      "text": "巴彦淖尔市"
    }, {
      "children": [ {
        "id": "432-nK",
        "value": "集宁区",
        "text": "集宁区"
      }, {
        "id": "433-ka",
        "value": "卓资县",
        "text": "卓资县"
      }, {
        "id": "434-Qw",
        "value": "化德县",
        "text": "化德县"
      }, {
        "id": "435-J8",
        "value": "商都县",
        "text": "商都县"
      }, {
        "id": "436-rU",
        "value": "兴和县",
        "text": "兴和县"
      }, {
        "id": "437-cM",
        "value": "凉城县",
        "text": "凉城县"
      }, {
        "id": "438-Md",
        "value": "察哈尔右翼前旗",
        "text": "察哈尔右翼前旗"
      }, {
        "id": "439-cb",
        "value": "察哈尔右翼中旗",
        "text": "察哈尔右翼中旗"
      }, {
        "id": "440-p2",
        "value": "察哈尔右翼后旗",
        "text": "察哈尔右翼后旗"
      }, {
        "id": "441-lC",
        "value": "四子王旗",
        "text": "四子王旗"
      }, {
        "id": "442-80",
        "value": "丰镇市",
        "text": "丰镇市"
      } ],
      "id": "431-xY",
      "value": "乌兰察布市",
      "text": "乌兰察布市"
    }, {
      "children": [ {
        "id": "444-Wz",
        "value": "乌兰浩特市",
        "text": "乌兰浩特市"
      }, {
        "id": "445-6Q",
        "value": "阿尔山市",
        "text": "阿尔山市"
      }, {
        "id": "446-AI",
        "value": "科尔沁右翼前旗",
        "text": "科尔沁右翼前旗"
      }, {
        "id": "447-Tw",
        "value": "科尔沁右翼中旗",
        "text": "科尔沁右翼中旗"
      }, {
        "id": "448-N8",
        "value": "扎赉特旗",
        "text": "扎赉特旗"
      }, {
        "id": "449-42",
        "value": "突泉县",
        "text": "突泉县"
      } ],
      "id": "443-2o",
      "value": "兴安盟",
      "text": "兴安盟"
    }, {
      "children": [ {
        "id": "451-uv",
        "value": "二连浩特市",
        "text": "二连浩特市"
      }, {
        "id": "452-by",
        "value": "锡林浩特市",
        "text": "锡林浩特市"
      }, {
        "id": "453-rb",
        "value": "阿巴嘎旗",
        "text": "阿巴嘎旗"
      }, {
        "id": "454-ma",
        "value": "苏尼特左旗",
        "text": "苏尼特左旗"
      }, {
        "id": "455-xP",
        "value": "苏尼特右旗",
        "text": "苏尼特右旗"
      }, {
        "id": "456-XQ",
        "value": "东乌珠穆沁旗",
        "text": "东乌珠穆沁旗"
      }, {
        "id": "457-QB",
        "value": "西乌珠穆沁旗",
        "text": "西乌珠穆沁旗"
      }, {
        "id": "458-O5",
        "value": "太仆寺旗",
        "text": "太仆寺旗"
      }, {
        "id": "459-Eq",
        "value": "镶黄旗",
        "text": "镶黄旗"
      }, {
        "id": "460-OV",
        "value": "正镶白旗",
        "text": "正镶白旗"
      }, {
        "id": "461-dc",
        "value": "正蓝旗",
        "text": "正蓝旗"
      }, {
        "id": "462-aB",
        "value": "多伦县",
        "text": "多伦县"
      } ],
      "id": "450-fI",
      "value": "锡林郭勒盟",
      "text": "锡林郭勒盟"
    }, {
      "children": [ {
        "id": "464-RO",
        "value": "阿拉善左旗",
        "text": "阿拉善左旗"
      }, {
        "id": "465-8S",
        "value": "阿拉善右旗",
        "text": "阿拉善右旗"
      }, {
        "id": "466-7r",
        "value": "额济纳旗",
        "text": "额济纳旗"
      } ],
      "id": "463-NY",
      "value": "阿拉善盟",
      "text": "阿拉善盟"
    } ],
    "id": "351-CD",
    "value": "内蒙古自治区",
    "text": "内蒙古自治区"
  }, {
    "children": [ {
      "children": [ {
        "id": "469-Dq",
        "value": "和平区",
        "text": "和平区"
      }, {
        "id": "470-UY",
        "value": "沈河区",
        "text": "沈河区"
      }, {
        "id": "471-q4",
        "value": "大东区",
        "text": "大东区"
      }, {
        "id": "472-kS",
        "value": "皇姑区",
        "text": "皇姑区"
      }, {
        "id": "473-FG",
        "value": "铁西区",
        "text": "铁西区"
      }, {
        "id": "474-uq",
        "value": "苏家屯区",
        "text": "苏家屯区"
      }, {
        "id": "475-Xq",
        "value": "浑南区",
        "text": "浑南区"
      }, {
        "id": "476-D6",
        "value": "沈北新区",
        "text": "沈北新区"
      }, {
        "id": "477-js",
        "value": "于洪区",
        "text": "于洪区"
      }, {
        "id": "478-uW",
        "value": "辽中区",
        "text": "辽中区"
      }, {
        "id": "479-Fv",
        "value": "康平县",
        "text": "康平县"
      }, {
        "id": "480-oV",
        "value": "法库县",
        "text": "法库县"
      }, {
        "id": "481-rz",
        "value": "新民市",
        "text": "新民市"
      } ],
      "id": "468-FQ",
      "value": "沈阳市",
      "text": "沈阳市"
    }, {
      "children": [ {
        "id": "483-l9",
        "value": "中山区",
        "text": "中山区"
      }, {
        "id": "484-i0",
        "value": "西岗区",
        "text": "西岗区"
      }, {
        "id": "485-mu",
        "value": "沙河口区",
        "text": "沙河口区"
      }, {
        "id": "486-kr",
        "value": "甘井子区",
        "text": "甘井子区"
      }, {
        "id": "487-XM",
        "value": "旅顺口区",
        "text": "旅顺口区"
      }, {
        "id": "488-Uu",
        "value": "金州区",
        "text": "金州区"
      }, {
        "id": "489-lj",
        "value": "普兰店区",
        "text": "普兰店区"
      }, {
        "id": "490-KP",
        "value": "长海县",
        "text": "长海县"
      }, {
        "id": "491-Yw",
        "value": "瓦房店市",
        "text": "瓦房店市"
      }, {
        "id": "492-eS",
        "value": "庄河市",
        "text": "庄河市"
      } ],
      "id": "482-md",
      "value": "大连市",
      "text": "大连市"
    }, {
      "children": [ {
        "id": "494-Lv",
        "value": "铁东区",
        "text": "铁东区"
      }, {
        "id": "495-tO",
        "value": "铁西区",
        "text": "铁西区"
      }, {
        "id": "496-lr",
        "value": "立山区",
        "text": "立山区"
      }, {
        "id": "497-X7",
        "value": "千山区",
        "text": "千山区"
      }, {
        "id": "498-xf",
        "value": "台安县",
        "text": "台安县"
      }, {
        "id": "499-yg",
        "value": "岫岩满族自治县",
        "text": "岫岩满族自治县"
      }, {
        "id": "500-Hf",
        "value": "海城市",
        "text": "海城市"
      } ],
      "id": "493-q6",
      "value": "鞍山市",
      "text": "鞍山市"
    }, {
      "children": [ {
        "id": "502-RE",
        "value": "新抚区",
        "text": "新抚区"
      }, {
        "id": "503-DI",
        "value": "东洲区",
        "text": "东洲区"
      }, {
        "id": "504-0d",
        "value": "望花区",
        "text": "望花区"
      }, {
        "id": "505-NV",
        "value": "顺城区",
        "text": "顺城区"
      }, {
        "id": "506-VT",
        "value": "抚顺县",
        "text": "抚顺县"
      }, {
        "id": "507-bn",
        "value": "新宾满族自治县",
        "text": "新宾满族自治县"
      }, {
        "id": "508-vg",
        "value": "清原满族自治县",
        "text": "清原满族自治县"
      } ],
      "id": "501-lL",
      "value": "抚顺市",
      "text": "抚顺市"
    }, {
      "children": [ {
        "id": "510-w8",
        "value": "平山区",
        "text": "平山区"
      }, {
        "id": "511-re",
        "value": "溪湖区",
        "text": "溪湖区"
      }, {
        "id": "512-sT",
        "value": "明山区",
        "text": "明山区"
      }, {
        "id": "513-TB",
        "value": "南芬区",
        "text": "南芬区"
      }, {
        "id": "514-3I",
        "value": "本溪满族自治县",
        "text": "本溪满族自治县"
      }, {
        "id": "515-rm",
        "value": "桓仁满族自治县",
        "text": "桓仁满族自治县"
      } ],
      "id": "509-dN",
      "value": "本溪市",
      "text": "本溪市"
    }, {
      "children": [ {
        "id": "517-LD",
        "value": "元宝区",
        "text": "元宝区"
      }, {
        "id": "518-cj",
        "value": "振兴区",
        "text": "振兴区"
      }, {
        "id": "519-rH",
        "value": "振安区",
        "text": "振安区"
      }, {
        "id": "520-K0",
        "value": "宽甸满族自治县",
        "text": "宽甸满族自治县"
      }, {
        "id": "521-w4",
        "value": "东港市",
        "text": "东港市"
      }, {
        "id": "522-xp",
        "value": "凤城市",
        "text": "凤城市"
      } ],
      "id": "516-r7",
      "value": "丹东市",
      "text": "丹东市"
    }, {
      "children": [ {
        "id": "524-jQ",
        "value": "古塔区",
        "text": "古塔区"
      }, {
        "id": "525-V6",
        "value": "凌河区",
        "text": "凌河区"
      }, {
        "id": "526-fF",
        "value": "太和区",
        "text": "太和区"
      }, {
        "id": "527-Vg",
        "value": "黑山县",
        "text": "黑山县"
      }, {
        "id": "528-pY",
        "value": "义县",
        "text": "义县"
      }, {
        "id": "529-3t",
        "value": "凌海市",
        "text": "凌海市"
      }, {
        "id": "530-TG",
        "value": "北镇市",
        "text": "北镇市"
      } ],
      "id": "523-kc",
      "value": "锦州市",
      "text": "锦州市"
    }, {
      "children": [ {
        "id": "532-XF",
        "value": "站前区",
        "text": "站前区"
      }, {
        "id": "533-bk",
        "value": "西市区",
        "text": "西市区"
      }, {
        "id": "534-ov",
        "value": "鲅鱼圈区",
        "text": "鲅鱼圈区"
      }, {
        "id": "535-bj",
        "value": "老边区",
        "text": "老边区"
      }, {
        "id": "536-4A",
        "value": "盖州市",
        "text": "盖州市"
      }, {
        "id": "537-Wa",
        "value": "大石桥市",
        "text": "大石桥市"
      } ],
      "id": "531-V6",
      "value": "营口市",
      "text": "营口市"
    }, {
      "children": [ {
        "id": "539-1m",
        "value": "海州区",
        "text": "海州区"
      }, {
        "id": "540-5W",
        "value": "新邱区",
        "text": "新邱区"
      }, {
        "id": "541-ZO",
        "value": "太平区",
        "text": "太平区"
      }, {
        "id": "542-tx",
        "value": "清河门区",
        "text": "清河门区"
      }, {
        "id": "543-uW",
        "value": "细河区",
        "text": "细河区"
      }, {
        "id": "544-9N",
        "value": "阜新蒙古族自治县",
        "text": "阜新蒙古族自治县"
      }, {
        "id": "545-71",
        "value": "彰武县",
        "text": "彰武县"
      } ],
      "id": "538-yR",
      "value": "阜新市",
      "text": "阜新市"
    }, {
      "children": [ {
        "id": "547-n7",
        "value": "白塔区",
        "text": "白塔区"
      }, {
        "id": "548-Dn",
        "value": "文圣区",
        "text": "文圣区"
      }, {
        "id": "549-qr",
        "value": "宏伟区",
        "text": "宏伟区"
      }, {
        "id": "550-QD",
        "value": "弓长岭区",
        "text": "弓长岭区"
      }, {
        "id": "551-4m",
        "value": "太子河区",
        "text": "太子河区"
      }, {
        "id": "552-Oe",
        "value": "辽阳县",
        "text": "辽阳县"
      }, {
        "id": "553-i5",
        "value": "灯塔市",
        "text": "灯塔市"
      } ],
      "id": "546-5P",
      "value": "辽阳市",
      "text": "辽阳市"
    }, {
      "children": [ {
        "id": "555-6n",
        "value": "双台子区",
        "text": "双台子区"
      }, {
        "id": "556-9w",
        "value": "兴隆台区",
        "text": "兴隆台区"
      }, {
        "id": "557-8I",
        "value": "大洼区",
        "text": "大洼区"
      }, {
        "id": "558-Vi",
        "value": "盘山县",
        "text": "盘山县"
      } ],
      "id": "554-Xy",
      "value": "盘锦市",
      "text": "盘锦市"
    }, {
      "children": [ {
        "id": "560-2M",
        "value": "银州区",
        "text": "银州区"
      }, {
        "id": "561-wU",
        "value": "清河区",
        "text": "清河区"
      }, {
        "id": "562-XO",
        "value": "铁岭县",
        "text": "铁岭县"
      }, {
        "id": "563-wc",
        "value": "西丰县",
        "text": "西丰县"
      }, {
        "id": "564-Mp",
        "value": "昌图县",
        "text": "昌图县"
      }, {
        "id": "565-Rr",
        "value": "调兵山市",
        "text": "调兵山市"
      }, {
        "id": "566-eU",
        "value": "开原市",
        "text": "开原市"
      } ],
      "id": "559-l6",
      "value": "铁岭市",
      "text": "铁岭市"
    }, {
      "children": [ {
        "id": "568-Yt",
        "value": "双塔区",
        "text": "双塔区"
      }, {
        "id": "569-2I",
        "value": "龙城区",
        "text": "龙城区"
      }, {
        "id": "570-TO",
        "value": "朝阳县",
        "text": "朝阳县"
      }, {
        "id": "571-qI",
        "value": "建平县",
        "text": "建平县"
      }, {
        "id": "572-8N",
        "value": "喀喇沁左翼蒙古族自治县",
        "text": "喀喇沁左翼蒙古族自治县"
      }, {
        "id": "573-YO",
        "value": "北票市",
        "text": "北票市"
      }, {
        "id": "574-5p",
        "value": "凌源市",
        "text": "凌源市"
      } ],
      "id": "567-2y",
      "value": "朝阳市",
      "text": "朝阳市"
    }, {
      "children": [ {
        "id": "576-Ww",
        "value": "连山区",
        "text": "连山区"
      }, {
        "id": "577-eo",
        "value": "龙港区",
        "text": "龙港区"
      }, {
        "id": "578-vj",
        "value": "南票区",
        "text": "南票区"
      }, {
        "id": "579-sV",
        "value": "绥中县",
        "text": "绥中县"
      }, {
        "id": "580-nC",
        "value": "建昌县",
        "text": "建昌县"
      }, {
        "id": "581-T9",
        "value": "兴城市",
        "text": "兴城市"
      } ],
      "id": "575-OJ",
      "value": "葫芦岛市",
      "text": "葫芦岛市"
    } ],
    "id": "467-Wi",
    "value": "辽宁省",
    "text": "辽宁省"
  }, {
    "children": [ {
      "children": [ {
        "id": "584-b3",
        "value": "南关区",
        "text": "南关区"
      }, {
        "id": "585-op",
        "value": "宽城区",
        "text": "宽城区"
      }, {
        "id": "586-xV",
        "value": "朝阳区",
        "text": "朝阳区"
      }, {
        "id": "587-TR",
        "value": "二道区",
        "text": "二道区"
      }, {
        "id": "588-hK",
        "value": "绿园区",
        "text": "绿园区"
      }, {
        "id": "589-HZ",
        "value": "双阳区",
        "text": "双阳区"
      }, {
        "id": "590-UC",
        "value": "九台区",
        "text": "九台区"
      }, {
        "id": "591-lU",
        "value": "农安县",
        "text": "农安县"
      }, {
        "id": "592-lq",
        "value": "榆树市",
        "text": "榆树市"
      }, {
        "id": "593-sF",
        "value": "德惠市",
        "text": "德惠市"
      } ],
      "id": "583-uV",
      "value": "长春市",
      "text": "长春市"
    }, {
      "children": [ {
        "id": "595-xN",
        "value": "昌邑区",
        "text": "昌邑区"
      }, {
        "id": "596-g7",
        "value": "龙潭区",
        "text": "龙潭区"
      }, {
        "id": "597-kh",
        "value": "船营区",
        "text": "船营区"
      }, {
        "id": "598-Mn",
        "value": "丰满区",
        "text": "丰满区"
      }, {
        "id": "599-Vi",
        "value": "永吉县",
        "text": "永吉县"
      }, {
        "id": "600-zM",
        "value": "蛟河市",
        "text": "蛟河市"
      }, {
        "id": "601-o6",
        "value": "桦甸市",
        "text": "桦甸市"
      }, {
        "id": "602-rK",
        "value": "舒兰市",
        "text": "舒兰市"
      }, {
        "id": "603-OS",
        "value": "磐石市",
        "text": "磐石市"
      } ],
      "id": "594-QW",
      "value": "吉林市",
      "text": "吉林市"
    }, {
      "children": [ {
        "id": "605-Fa",
        "value": "铁西区",
        "text": "铁西区"
      }, {
        "id": "606-YL",
        "value": "铁东区",
        "text": "铁东区"
      }, {
        "id": "607-mB",
        "value": "梨树县",
        "text": "梨树县"
      }, {
        "id": "608-eb",
        "value": "伊通满族自治县",
        "text": "伊通满族自治县"
      }, {
        "id": "609-8J",
        "value": "公主岭市",
        "text": "公主岭市"
      }, {
        "id": "610-Oo",
        "value": "双辽市",
        "text": "双辽市"
      } ],
      "id": "604-uy",
      "value": "四平市",
      "text": "四平市"
    }, {
      "children": [ {
        "id": "612-qx",
        "value": "龙山区",
        "text": "龙山区"
      }, {
        "id": "613-sI",
        "value": "西安区",
        "text": "西安区"
      }, {
        "id": "614-5J",
        "value": "东丰县",
        "text": "东丰县"
      }, {
        "id": "615-lH",
        "value": "东辽县",
        "text": "东辽县"
      } ],
      "id": "611-HC",
      "value": "辽源市",
      "text": "辽源市"
    }, {
      "children": [ {
        "id": "617-HS",
        "value": "东昌区",
        "text": "东昌区"
      }, {
        "id": "618-D7",
        "value": "二道江区",
        "text": "二道江区"
      }, {
        "id": "619-Bi",
        "value": "通化县",
        "text": "通化县"
      }, {
        "id": "620-JF",
        "value": "辉南县",
        "text": "辉南县"
      }, {
        "id": "621-td",
        "value": "柳河县",
        "text": "柳河县"
      }, {
        "id": "622-6d",
        "value": "梅河口市",
        "text": "梅河口市"
      }, {
        "id": "623-bp",
        "value": "集安市",
        "text": "集安市"
      } ],
      "id": "616-OQ",
      "value": "通化市",
      "text": "通化市"
    }, {
      "children": [ {
        "id": "625-3i",
        "value": "浑江区",
        "text": "浑江区"
      }, {
        "id": "626-3O",
        "value": "江源区",
        "text": "江源区"
      }, {
        "id": "627-yT",
        "value": "抚松县",
        "text": "抚松县"
      }, {
        "id": "628-2Y",
        "value": "靖宇县",
        "text": "靖宇县"
      }, {
        "id": "629-YI",
        "value": "长白朝鲜族自治县",
        "text": "长白朝鲜族自治县"
      }, {
        "id": "630-uN",
        "value": "临江市",
        "text": "临江市"
      } ],
      "id": "624-R1",
      "value": "白山市",
      "text": "白山市"
    }, {
      "children": [ {
        "id": "632-40",
        "value": "宁江区",
        "text": "宁江区"
      }, {
        "id": "633-1G",
        "value": "前郭尔罗斯蒙古族自治县",
        "text": "前郭尔罗斯蒙古族自治县"
      }, {
        "id": "634-Xm",
        "value": "长岭县",
        "text": "长岭县"
      }, {
        "id": "635-kF",
        "value": "乾安县",
        "text": "乾安县"
      }, {
        "id": "636-18",
        "value": "扶余市",
        "text": "扶余市"
      } ],
      "id": "631-h1",
      "value": "松原市",
      "text": "松原市"
    }, {
      "children": [ {
        "id": "638-OF",
        "value": "洮北区",
        "text": "洮北区"
      }, {
        "id": "639-KF",
        "value": "镇赉县",
        "text": "镇赉县"
      }, {
        "id": "640-OK",
        "value": "通榆县",
        "text": "通榆县"
      }, {
        "id": "641-Bx",
        "value": "洮南市",
        "text": "洮南市"
      }, {
        "id": "642-6x",
        "value": "大安市",
        "text": "大安市"
      } ],
      "id": "637-rL",
      "value": "白城市",
      "text": "白城市"
    }, {
      "children": [ {
        "id": "644-qe",
        "value": "延吉市",
        "text": "延吉市"
      }, {
        "id": "645-se",
        "value": "图们市",
        "text": "图们市"
      }, {
        "id": "646-2u",
        "value": "敦化市",
        "text": "敦化市"
      }, {
        "id": "647-m4",
        "value": "珲春市",
        "text": "珲春市"
      }, {
        "id": "648-6p",
        "value": "龙井市",
        "text": "龙井市"
      }, {
        "id": "649-LJ",
        "value": "和龙市",
        "text": "和龙市"
      }, {
        "id": "650-Oy",
        "value": "汪清县",
        "text": "汪清县"
      }, {
        "id": "651-Lt",
        "value": "安图县",
        "text": "安图县"
      } ],
      "id": "643-vH",
      "value": "延边朝鲜族自治州",
      "text": "延边朝鲜族自治州"
    } ],
    "id": "582-zl",
    "value": "吉林省",
    "text": "吉林省"
  }, {
    "children": [ {
      "children": [ {
        "id": "654-eF",
        "value": "道里区",
        "text": "道里区"
      }, {
        "id": "655-hQ",
        "value": "南岗区",
        "text": "南岗区"
      }, {
        "id": "656-YE",
        "value": "道外区",
        "text": "道外区"
      }, {
        "id": "657-b0",
        "value": "平房区",
        "text": "平房区"
      }, {
        "id": "658-9e",
        "value": "松北区",
        "text": "松北区"
      }, {
        "id": "659-uO",
        "value": "香坊区",
        "text": "香坊区"
      }, {
        "id": "660-Ii",
        "value": "呼兰区",
        "text": "呼兰区"
      }, {
        "id": "661-TW",
        "value": "阿城区",
        "text": "阿城区"
      }, {
        "id": "662-vK",
        "value": "双城区",
        "text": "双城区"
      }, {
        "id": "663-SE",
        "value": "依兰县",
        "text": "依兰县"
      }, {
        "id": "664-sH",
        "value": "方正县",
        "text": "方正县"
      }, {
        "id": "665-MX",
        "value": "宾县",
        "text": "宾县"
      }, {
        "id": "666-LX",
        "value": "巴彦县",
        "text": "巴彦县"
      }, {
        "id": "667-uA",
        "value": "木兰县",
        "text": "木兰县"
      }, {
        "id": "668-3H",
        "value": "通河县",
        "text": "通河县"
      }, {
        "id": "669-IA",
        "value": "延寿县",
        "text": "延寿县"
      }, {
        "id": "670-Xk",
        "value": "尚志市",
        "text": "尚志市"
      }, {
        "id": "671-PZ",
        "value": "五常市",
        "text": "五常市"
      } ],
      "id": "653-3d",
      "value": "哈尔滨市",
      "text": "哈尔滨市"
    }, {
      "children": [ {
        "id": "673-vg",
        "value": "龙沙区",
        "text": "龙沙区"
      }, {
        "id": "674-2b",
        "value": "建华区",
        "text": "建华区"
      }, {
        "id": "675-by",
        "value": "铁锋区",
        "text": "铁锋区"
      }, {
        "id": "676-vP",
        "value": "昂昂溪区",
        "text": "昂昂溪区"
      }, {
        "id": "677-G1",
        "value": "富拉尔基区",
        "text": "富拉尔基区"
      }, {
        "id": "678-sU",
        "value": "碾子山区",
        "text": "碾子山区"
      }, {
        "id": "679-MP",
        "value": "梅里斯达斡尔族区",
        "text": "梅里斯达斡尔族区"
      }, {
        "id": "680-qB",
        "value": "龙江县",
        "text": "龙江县"
      }, {
        "id": "681-OU",
        "value": "依安县",
        "text": "依安县"
      }, {
        "id": "682-VB",
        "value": "泰来县",
        "text": "泰来县"
      }, {
        "id": "683-On",
        "value": "甘南县",
        "text": "甘南县"
      }, {
        "id": "684-Vi",
        "value": "富裕县",
        "text": "富裕县"
      }, {
        "id": "685-51",
        "value": "克山县",
        "text": "克山县"
      }, {
        "id": "686-gV",
        "value": "克东县",
        "text": "克东县"
      }, {
        "id": "687-N7",
        "value": "拜泉县",
        "text": "拜泉县"
      }, {
        "id": "688-cn",
        "value": "讷河市",
        "text": "讷河市"
      } ],
      "id": "672-np",
      "value": "齐齐哈尔市",
      "text": "齐齐哈尔市"
    }, {
      "children": [ {
        "id": "690-C2",
        "value": "鸡冠区",
        "text": "鸡冠区"
      }, {
        "id": "691-Pt",
        "value": "恒山区",
        "text": "恒山区"
      }, {
        "id": "692-bZ",
        "value": "滴道区",
        "text": "滴道区"
      }, {
        "id": "693-ZO",
        "value": "梨树区",
        "text": "梨树区"
      }, {
        "id": "694-i6",
        "value": "城子河区",
        "text": "城子河区"
      }, {
        "id": "695-fo",
        "value": "麻山区",
        "text": "麻山区"
      }, {
        "id": "696-LF",
        "value": "鸡东县",
        "text": "鸡东县"
      }, {
        "id": "697-6l",
        "value": "虎林市",
        "text": "虎林市"
      }, {
        "id": "698-dt",
        "value": "密山市",
        "text": "密山市"
      } ],
      "id": "689-pX",
      "value": "鸡西市",
      "text": "鸡西市"
    }, {
      "children": [ {
        "id": "700-r1",
        "value": "向阳区",
        "text": "向阳区"
      }, {
        "id": "701-Lm",
        "value": "工农区",
        "text": "工农区"
      }, {
        "id": "702-HH",
        "value": "南山区",
        "text": "南山区"
      }, {
        "id": "703-xH",
        "value": "兴安区",
        "text": "兴安区"
      }, {
        "id": "704-S1",
        "value": "东山区",
        "text": "东山区"
      }, {
        "id": "705-Fb",
        "value": "兴山区",
        "text": "兴山区"
      }, {
        "id": "706-WB",
        "value": "萝北县",
        "text": "萝北县"
      }, {
        "id": "707-9d",
        "value": "绥滨县",
        "text": "绥滨县"
      } ],
      "id": "699-pg",
      "value": "鹤岗市",
      "text": "鹤岗市"
    }, {
      "children": [ {
        "id": "709-35",
        "value": "尖山区",
        "text": "尖山区"
      }, {
        "id": "710-Mq",
        "value": "岭东区",
        "text": "岭东区"
      }, {
        "id": "711-eJ",
        "value": "四方台区",
        "text": "四方台区"
      }, {
        "id": "712-Fz",
        "value": "宝山区",
        "text": "宝山区"
      }, {
        "id": "713-iH",
        "value": "集贤县",
        "text": "集贤县"
      }, {
        "id": "714-9z",
        "value": "友谊县",
        "text": "友谊县"
      }, {
        "id": "715-tt",
        "value": "宝清县",
        "text": "宝清县"
      }, {
        "id": "716-U3",
        "value": "饶河县",
        "text": "饶河县"
      } ],
      "id": "708-Un",
      "value": "双鸭山市",
      "text": "双鸭山市"
    }, {
      "children": [ {
        "id": "718-bC",
        "value": "萨尔图区",
        "text": "萨尔图区"
      }, {
        "id": "719-tf",
        "value": "龙凤区",
        "text": "龙凤区"
      }, {
        "id": "720-3Y",
        "value": "让胡路区",
        "text": "让胡路区"
      }, {
        "id": "721-lC",
        "value": "红岗区",
        "text": "红岗区"
      }, {
        "id": "722-wo",
        "value": "大同区",
        "text": "大同区"
      }, {
        "id": "723-Zi",
        "value": "肇州县",
        "text": "肇州县"
      }, {
        "id": "724-5i",
        "value": "肇源县",
        "text": "肇源县"
      }, {
        "id": "725-D7",
        "value": "林甸县",
        "text": "林甸县"
      }, {
        "id": "726-Gb",
        "value": "杜尔伯特蒙古族自治县",
        "text": "杜尔伯特蒙古族自治县"
      } ],
      "id": "717-5y",
      "value": "大庆市",
      "text": "大庆市"
    }, {
      "children": [ {
        "id": "728-zJ",
        "value": "伊春区",
        "text": "伊春区"
      }, {
        "id": "729-EI",
        "value": "南岔区",
        "text": "南岔区"
      }, {
        "id": "730-On",
        "value": "友好区",
        "text": "友好区"
      }, {
        "id": "731-xu",
        "value": "西林区",
        "text": "西林区"
      }, {
        "id": "732-Oq",
        "value": "翠峦区",
        "text": "翠峦区"
      }, {
        "id": "733-Zu",
        "value": "新青区",
        "text": "新青区"
      }, {
        "id": "734-F4",
        "value": "美溪区",
        "text": "美溪区"
      }, {
        "id": "735-zH",
        "value": "金山屯区",
        "text": "金山屯区"
      }, {
        "id": "736-bj",
        "value": "五营区",
        "text": "五营区"
      }, {
        "id": "737-1K",
        "value": "乌马河区",
        "text": "乌马河区"
      }, {
        "id": "738-n1",
        "value": "汤旺河区",
        "text": "汤旺河区"
      }, {
        "id": "739-Sg",
        "value": "带岭区",
        "text": "带岭区"
      }, {
        "id": "740-TF",
        "value": "乌伊岭区",
        "text": "乌伊岭区"
      }, {
        "id": "741-af",
        "value": "红星区",
        "text": "红星区"
      }, {
        "id": "742-Si",
        "value": "上甘岭区",
        "text": "上甘岭区"
      }, {
        "id": "743-pD",
        "value": "嘉荫县",
        "text": "嘉荫县"
      }, {
        "id": "744-Et",
        "value": "铁力市",
        "text": "铁力市"
      } ],
      "id": "727-nq",
      "value": "伊春市",
      "text": "伊春市"
    }, {
      "children": [ {
        "id": "746-h3",
        "value": "向阳区",
        "text": "向阳区"
      }, {
        "id": "747-Ht",
        "value": "前进区",
        "text": "前进区"
      }, {
        "id": "748-L5",
        "value": "东风区",
        "text": "东风区"
      }, {
        "id": "749-4c",
        "value": "郊区",
        "text": "郊区"
      }, {
        "id": "750-Rv",
        "value": "桦南县",
        "text": "桦南县"
      }, {
        "id": "751-Ds",
        "value": "桦川县",
        "text": "桦川县"
      }, {
        "id": "752-4y",
        "value": "汤原县",
        "text": "汤原县"
      }, {
        "id": "753-zK",
        "value": "同江市",
        "text": "同江市"
      }, {
        "id": "754-M0",
        "value": "富锦市",
        "text": "富锦市"
      }, {
        "id": "755-pZ",
        "value": "抚远市",
        "text": "抚远市"
      } ],
      "id": "745-pj",
      "value": "佳木斯市",
      "text": "佳木斯市"
    }, {
      "children": [ {
        "id": "757-cX",
        "value": "新兴区",
        "text": "新兴区"
      }, {
        "id": "758-92",
        "value": "桃山区",
        "text": "桃山区"
      }, {
        "id": "759-OF",
        "value": "茄子河区",
        "text": "茄子河区"
      }, {
        "id": "760-ha",
        "value": "勃利县",
        "text": "勃利县"
      } ],
      "id": "756-sE",
      "value": "七台河市",
      "text": "七台河市"
    }, {
      "children": [ {
        "id": "762-XV",
        "value": "东安区",
        "text": "东安区"
      }, {
        "id": "763-K6",
        "value": "阳明区",
        "text": "阳明区"
      }, {
        "id": "764-8P",
        "value": "爱民区",
        "text": "爱民区"
      }, {
        "id": "765-8q",
        "value": "西安区",
        "text": "西安区"
      }, {
        "id": "766-iK",
        "value": "林口县",
        "text": "林口县"
      }, {
        "id": "767-aR",
        "value": "绥芬河市",
        "text": "绥芬河市"
      }, {
        "id": "768-Eo",
        "value": "海林市",
        "text": "海林市"
      }, {
        "id": "769-5b",
        "value": "宁安市",
        "text": "宁安市"
      }, {
        "id": "770-B6",
        "value": "穆棱市",
        "text": "穆棱市"
      }, {
        "id": "771-Ev",
        "value": "东宁市",
        "text": "东宁市"
      } ],
      "id": "761-zk",
      "value": "牡丹江市",
      "text": "牡丹江市"
    }, {
      "children": [ {
        "id": "773-jq",
        "value": "爱辉区",
        "text": "爱辉区"
      }, {
        "id": "774-0f",
        "value": "嫩江县",
        "text": "嫩江县"
      }, {
        "id": "775-tC",
        "value": "逊克县",
        "text": "逊克县"
      }, {
        "id": "776-lJ",
        "value": "孙吴县",
        "text": "孙吴县"
      }, {
        "id": "777-vH",
        "value": "北安市",
        "text": "北安市"
      }, {
        "id": "778-tm",
        "value": "五大连池市",
        "text": "五大连池市"
      } ],
      "id": "772-ng",
      "value": "黑河市",
      "text": "黑河市"
    }, {
      "children": [ {
        "id": "780-QW",
        "value": "北林区",
        "text": "北林区"
      }, {
        "id": "781-JB",
        "value": "望奎县",
        "text": "望奎县"
      }, {
        "id": "782-ah",
        "value": "兰西县",
        "text": "兰西县"
      }, {
        "id": "783-GS",
        "value": "青冈县",
        "text": "青冈县"
      }, {
        "id": "784-aW",
        "value": "庆安县",
        "text": "庆安县"
      }, {
        "id": "785-Hi",
        "value": "明水县",
        "text": "明水县"
      }, {
        "id": "786-E4",
        "value": "绥棱县",
        "text": "绥棱县"
      }, {
        "id": "787-sd",
        "value": "安达市",
        "text": "安达市"
      }, {
        "id": "788-Gc",
        "value": "肇东市",
        "text": "肇东市"
      }, {
        "id": "789-25",
        "value": "海伦市",
        "text": "海伦市"
      } ],
      "id": "779-MM",
      "value": "绥化市",
      "text": "绥化市"
    }, {
      "children": [ {
        "id": "791-SF",
        "value": "呼玛县",
        "text": "呼玛县"
      }, {
        "id": "792-YY",
        "value": "塔河县",
        "text": "塔河县"
      }, {
        "id": "793-aj",
        "value": "漠河县",
        "text": "漠河县"
      } ],
      "id": "790-gZ",
      "value": "大兴安岭地区",
      "text": "大兴安岭地区"
    } ],
    "id": "652-A2",
    "value": "黑龙江省",
    "text": "黑龙江省"
  }, {
    "children": [ {
      "children": [ {
        "id": "796-fm",
        "value": "黄浦区",
        "text": "黄浦区"
      }, {
        "id": "797-Mm",
        "value": "徐汇区",
        "text": "徐汇区"
      }, {
        "id": "798-Mh",
        "value": "长宁区",
        "text": "长宁区"
      }, {
        "id": "799-T8",
        "value": "静安区",
        "text": "静安区"
      }, {
        "id": "800-QV",
        "value": "普陀区",
        "text": "普陀区"
      }, {
        "id": "801-K1",
        "value": "虹口区",
        "text": "虹口区"
      }, {
        "id": "802-Ia",
        "value": "杨浦区",
        "text": "杨浦区"
      }, {
        "id": "803-Ym",
        "value": "闵行区",
        "text": "闵行区"
      }, {
        "id": "804-Uu",
        "value": "宝山区",
        "text": "宝山区"
      }, {
        "id": "805-LM",
        "value": "嘉定区",
        "text": "嘉定区"
      }, {
        "id": "806-q4",
        "value": "浦东新区",
        "text": "浦东新区"
      }, {
        "id": "807-ow",
        "value": "金山区",
        "text": "金山区"
      }, {
        "id": "808-hg",
        "value": "松江区",
        "text": "松江区"
      }, {
        "id": "809-VM",
        "value": "青浦区",
        "text": "青浦区"
      }, {
        "id": "810-NY",
        "value": "奉贤区",
        "text": "奉贤区"
      }, {
        "id": "811-CP",
        "value": "崇明区",
        "text": "崇明区"
      } ],
      "id": "795-Ye",
      "value": "上海市",
      "text": "上海市"
    } ],
    "id": "794-cJ",
    "value": "上海市",
    "text": "上海市"
  }, {
    "children": [ {
      "children": [ {
        "id": "814-h4",
        "value": "玄武区",
        "text": "玄武区"
      }, {
        "id": "815-RU",
        "value": "秦淮区",
        "text": "秦淮区"
      }, {
        "id": "816-JP",
        "value": "建邺区",
        "text": "建邺区"
      }, {
        "id": "817-4R",
        "value": "鼓楼区",
        "text": "鼓楼区"
      }, {
        "id": "818-P1",
        "value": "浦口区",
        "text": "浦口区"
      }, {
        "id": "819-nt",
        "value": "栖霞区",
        "text": "栖霞区"
      }, {
        "id": "820-xL",
        "value": "雨花台区",
        "text": "雨花台区"
      }, {
        "id": "821-mB",
        "value": "江宁区",
        "text": "江宁区"
      }, {
        "id": "822-hT",
        "value": "六合区",
        "text": "六合区"
      }, {
        "id": "823-I3",
        "value": "溧水区",
        "text": "溧水区"
      }, {
        "id": "824-ue",
        "value": "高淳区",
        "text": "高淳区"
      } ],
      "id": "813-Kb",
      "value": "南京市",
      "text": "南京市"
    }, {
      "children": [ {
        "id": "826-SW",
        "value": "锡山区",
        "text": "锡山区"
      }, {
        "id": "827-Ty",
        "value": "惠山区",
        "text": "惠山区"
      }, {
        "id": "828-OQ",
        "value": "滨湖区",
        "text": "滨湖区"
      }, {
        "id": "829-iR",
        "value": "梁溪区",
        "text": "梁溪区"
      }, {
        "id": "830-p9",
        "value": "新吴区",
        "text": "新吴区"
      }, {
        "id": "831-KB",
        "value": "江阴市",
        "text": "江阴市"
      }, {
        "id": "832-he",
        "value": "宜兴市",
        "text": "宜兴市"
      } ],
      "id": "825-pt",
      "value": "无锡市",
      "text": "无锡市"
    }, {
      "children": [ {
        "id": "834-TD",
        "value": "鼓楼区",
        "text": "鼓楼区"
      }, {
        "id": "835-lV",
        "value": "云龙区",
        "text": "云龙区"
      }, {
        "id": "836-jc",
        "value": "贾汪区",
        "text": "贾汪区"
      }, {
        "id": "837-VW",
        "value": "泉山区",
        "text": "泉山区"
      }, {
        "id": "838-Uz",
        "value": "铜山区",
        "text": "铜山区"
      }, {
        "id": "839-rU",
        "value": "丰县",
        "text": "丰县"
      }, {
        "id": "840-IC",
        "value": "沛县",
        "text": "沛县"
      }, {
        "id": "841-zO",
        "value": "睢宁县",
        "text": "睢宁县"
      }, {
        "id": "842-oT",
        "value": "新沂市",
        "text": "新沂市"
      }, {
        "id": "843-iR",
        "value": "邳州市",
        "text": "邳州市"
      } ],
      "id": "833-F7",
      "value": "徐州市",
      "text": "徐州市"
    }, {
      "children": [ {
        "id": "845-rh",
        "value": "天宁区",
        "text": "天宁区"
      }, {
        "id": "846-Vn",
        "value": "钟楼区",
        "text": "钟楼区"
      }, {
        "id": "847-ea",
        "value": "新北区",
        "text": "新北区"
      }, {
        "id": "848-IN",
        "value": "武进区",
        "text": "武进区"
      }, {
        "id": "849-Z7",
        "value": "金坛区",
        "text": "金坛区"
      }, {
        "id": "850-25",
        "value": "溧阳市",
        "text": "溧阳市"
      } ],
      "id": "844-5U",
      "value": "常州市",
      "text": "常州市"
    }, {
      "children": [ {
        "id": "852-NX",
        "value": "虎丘区",
        "text": "虎丘区"
      }, {
        "id": "853-Ys",
        "value": "吴中区",
        "text": "吴中区"
      }, {
        "id": "854-Fm",
        "value": "相城区",
        "text": "相城区"
      }, {
        "id": "855-6R",
        "value": "姑苏区",
        "text": "姑苏区"
      }, {
        "id": "856-GC",
        "value": "吴江区",
        "text": "吴江区"
      }, {
        "id": "857-pJ",
        "value": "常熟市",
        "text": "常熟市"
      }, {
        "id": "858-Wy",
        "value": "张家港市",
        "text": "张家港市"
      }, {
        "id": "859-hD",
        "value": "昆山市",
        "text": "昆山市"
      }, {
        "id": "860-qY",
        "value": "太仓市",
        "text": "太仓市"
      } ],
      "id": "851-R5",
      "value": "苏州市",
      "text": "苏州市"
    }, {
      "children": [ {
        "id": "862-oo",
        "value": "崇川区",
        "text": "崇川区"
      }, {
        "id": "863-gG",
        "value": "港闸区",
        "text": "港闸区"
      }, {
        "id": "864-Az",
        "value": "通州区",
        "text": "通州区"
      }, {
        "id": "865-Wm",
        "value": "海安县",
        "text": "海安县"
      }, {
        "id": "866-qi",
        "value": "如东县",
        "text": "如东县"
      }, {
        "id": "867-IE",
        "value": "启东市",
        "text": "启东市"
      }, {
        "id": "868-Re",
        "value": "如皋市",
        "text": "如皋市"
      }, {
        "id": "869-45",
        "value": "海门市",
        "text": "海门市"
      } ],
      "id": "861-rX",
      "value": "南通市",
      "text": "南通市"
    }, {
      "children": [ {
        "id": "871-Pu",
        "value": "连云区",
        "text": "连云区"
      }, {
        "id": "872-4a",
        "value": "海州区",
        "text": "海州区"
      }, {
        "id": "873-cS",
        "value": "赣榆区",
        "text": "赣榆区"
      }, {
        "id": "874-g3",
        "value": "东海县",
        "text": "东海县"
      }, {
        "id": "875-uP",
        "value": "灌云县",
        "text": "灌云县"
      }, {
        "id": "876-Xd",
        "value": "灌南县",
        "text": "灌南县"
      } ],
      "id": "870-ad",
      "value": "连云港市",
      "text": "连云港市"
    }, {
      "children": [ {
        "id": "878-Ay",
        "value": "淮安区",
        "text": "淮安区"
      }, {
        "id": "879-QU",
        "value": "淮阴区",
        "text": "淮阴区"
      }, {
        "id": "880-N4",
        "value": "清江浦区",
        "text": "清江浦区"
      }, {
        "id": "881-If",
        "value": "洪泽区",
        "text": "洪泽区"
      }, {
        "id": "882-uY",
        "value": "涟水县",
        "text": "涟水县"
      }, {
        "id": "883-dE",
        "value": "盱眙县",
        "text": "盱眙县"
      }, {
        "id": "884-pR",
        "value": "金湖县",
        "text": "金湖县"
      } ],
      "id": "877-P2",
      "value": "淮安市",
      "text": "淮安市"
    }, {
      "children": [ {
        "id": "886-vq",
        "value": "亭湖区",
        "text": "亭湖区"
      }, {
        "id": "887-ii",
        "value": "盐都区",
        "text": "盐都区"
      }, {
        "id": "888-SH",
        "value": "大丰区",
        "text": "大丰区"
      }, {
        "id": "889-8O",
        "value": "响水县",
        "text": "响水县"
      }, {
        "id": "890-IM",
        "value": "滨海县",
        "text": "滨海县"
      }, {
        "id": "891-br",
        "value": "阜宁县",
        "text": "阜宁县"
      }, {
        "id": "892-zg",
        "value": "射阳县",
        "text": "射阳县"
      }, {
        "id": "893-JE",
        "value": "建湖县",
        "text": "建湖县"
      }, {
        "id": "894-b5",
        "value": "东台市",
        "text": "东台市"
      } ],
      "id": "885-3d",
      "value": "盐城市",
      "text": "盐城市"
    }, {
      "children": [ {
        "id": "896-LA",
        "value": "广陵区",
        "text": "广陵区"
      }, {
        "id": "897-AH",
        "value": "邗江区",
        "text": "邗江区"
      }, {
        "id": "898-m5",
        "value": "江都区",
        "text": "江都区"
      }, {
        "id": "899-Ux",
        "value": "宝应县",
        "text": "宝应县"
      }, {
        "id": "900-Dk",
        "value": "仪征市",
        "text": "仪征市"
      }, {
        "id": "901-Ox",
        "value": "高邮市",
        "text": "高邮市"
      } ],
      "id": "895-Wq",
      "value": "扬州市",
      "text": "扬州市"
    }, {
      "children": [ {
        "id": "903-A2",
        "value": "京口区",
        "text": "京口区"
      }, {
        "id": "904-KO",
        "value": "润州区",
        "text": "润州区"
      }, {
        "id": "905-ab",
        "value": "丹徒区",
        "text": "丹徒区"
      }, {
        "id": "906-X1",
        "value": "丹阳市",
        "text": "丹阳市"
      }, {
        "id": "907-7h",
        "value": "扬中市",
        "text": "扬中市"
      }, {
        "id": "908-wB",
        "value": "句容市",
        "text": "句容市"
      } ],
      "id": "902-Ee",
      "value": "镇江市",
      "text": "镇江市"
    }, {
      "children": [ {
        "id": "910-J0",
        "value": "海陵区",
        "text": "海陵区"
      }, {
        "id": "911-3F",
        "value": "高港区",
        "text": "高港区"
      }, {
        "id": "912-WT",
        "value": "姜堰区",
        "text": "姜堰区"
      }, {
        "id": "913-yp",
        "value": "兴化市",
        "text": "兴化市"
      }, {
        "id": "914-iU",
        "value": "靖江市",
        "text": "靖江市"
      }, {
        "id": "915-uI",
        "value": "泰兴市",
        "text": "泰兴市"
      } ],
      "id": "909-DW",
      "value": "泰州市",
      "text": "泰州市"
    }, {
      "children": [ {
        "id": "917-wk",
        "value": "宿城区",
        "text": "宿城区"
      }, {
        "id": "918-t0",
        "value": "宿豫区",
        "text": "宿豫区"
      }, {
        "id": "919-rF",
        "value": "沭阳县",
        "text": "沭阳县"
      }, {
        "id": "920-fO",
        "value": "泗阳县",
        "text": "泗阳县"
      }, {
        "id": "921-Cf",
        "value": "泗洪县",
        "text": "泗洪县"
      } ],
      "id": "916-gB",
      "value": "宿迁市",
      "text": "宿迁市"
    } ],
    "id": "812-UP",
    "value": "江苏省",
    "text": "江苏省"
  }, {
    "children": [ {
      "children": [ {
        "id": "924-1t",
        "value": "上城区",
        "text": "上城区"
      }, {
        "id": "925-l7",
        "value": "下城区",
        "text": "下城区"
      }, {
        "id": "926-5R",
        "value": "江干区",
        "text": "江干区"
      }, {
        "id": "927-n1",
        "value": "拱墅区",
        "text": "拱墅区"
      }, {
        "id": "928-BI",
        "value": "西湖区",
        "text": "西湖区"
      }, {
        "id": "929-S7",
        "value": "滨江区",
        "text": "滨江区"
      }, {
        "id": "930-lH",
        "value": "萧山区",
        "text": "萧山区"
      }, {
        "id": "931-zz",
        "value": "余杭区",
        "text": "余杭区"
      }, {
        "id": "932-la",
        "value": "富阳区",
        "text": "富阳区"
      }, {
        "id": "933-Pr",
        "value": "桐庐县",
        "text": "桐庐县"
      }, {
        "id": "934-fP",
        "value": "淳安县",
        "text": "淳安县"
      }, {
        "id": "935-ZS",
        "value": "建德市",
        "text": "建德市"
      }, {
        "id": "936-Pm",
        "value": "临安市",
        "text": "临安市"
      } ],
      "id": "923-e0",
      "value": "杭州市",
      "text": "杭州市"
    }, {
      "children": [ {
        "id": "938-ba",
        "value": "海曙区",
        "text": "海曙区"
      }, {
        "id": "939-as",
        "value": "江东区",
        "text": "江东区"
      }, {
        "id": "940-Zr",
        "value": "江北区",
        "text": "江北区"
      }, {
        "id": "941-vt",
        "value": "北仑区",
        "text": "北仑区"
      }, {
        "id": "942-lJ",
        "value": "镇海区",
        "text": "镇海区"
      }, {
        "id": "943-kg",
        "value": "鄞州区",
        "text": "鄞州区"
      }, {
        "id": "944-T2",
        "value": "象山县",
        "text": "象山县"
      }, {
        "id": "945-XH",
        "value": "宁海县",
        "text": "宁海县"
      }, {
        "id": "946-fy",
        "value": "余姚市",
        "text": "余姚市"
      }, {
        "id": "947-Dr",
        "value": "慈溪市",
        "text": "慈溪市"
      }, {
        "id": "948-wu",
        "value": "奉化市",
        "text": "奉化市"
      } ],
      "id": "937-Es",
      "value": "宁波市",
      "text": "宁波市"
    }, {
      "children": [ {
        "id": "950-jC",
        "value": "鹿城区",
        "text": "鹿城区"
      }, {
        "id": "951-8g",
        "value": "龙湾区",
        "text": "龙湾区"
      }, {
        "id": "952-QZ",
        "value": "瓯海区",
        "text": "瓯海区"
      }, {
        "id": "953-5Z",
        "value": "洞头区",
        "text": "洞头区"
      }, {
        "id": "954-sH",
        "value": "永嘉县",
        "text": "永嘉县"
      }, {
        "id": "955-Yi",
        "value": "平阳县",
        "text": "平阳县"
      }, {
        "id": "956-LX",
        "value": "苍南县",
        "text": "苍南县"
      }, {
        "id": "957-ST",
        "value": "文成县",
        "text": "文成县"
      }, {
        "id": "958-yE",
        "value": "泰顺县",
        "text": "泰顺县"
      }, {
        "id": "959-Ou",
        "value": "瑞安市",
        "text": "瑞安市"
      }, {
        "id": "960-jr",
        "value": "乐清市",
        "text": "乐清市"
      } ],
      "id": "949-Wl",
      "value": "温州市",
      "text": "温州市"
    }, {
      "children": [ {
        "id": "962-kv",
        "value": "南湖区",
        "text": "南湖区"
      }, {
        "id": "963-f5",
        "value": "秀洲区",
        "text": "秀洲区"
      }, {
        "id": "964-ze",
        "value": "嘉善县",
        "text": "嘉善县"
      }, {
        "id": "965-Ih",
        "value": "海盐县",
        "text": "海盐县"
      }, {
        "id": "966-lm",
        "value": "海宁市",
        "text": "海宁市"
      }, {
        "id": "967-FP",
        "value": "平湖市",
        "text": "平湖市"
      }, {
        "id": "968-YY",
        "value": "桐乡市",
        "text": "桐乡市"
      } ],
      "id": "961-V3",
      "value": "嘉兴市",
      "text": "嘉兴市"
    }, {
      "children": [ {
        "id": "970-w4",
        "value": "吴兴区",
        "text": "吴兴区"
      }, {
        "id": "971-Th",
        "value": "南浔区",
        "text": "南浔区"
      }, {
        "id": "972-C4",
        "value": "德清县",
        "text": "德清县"
      }, {
        "id": "973-k5",
        "value": "长兴县",
        "text": "长兴县"
      }, {
        "id": "974-uJ",
        "value": "安吉县",
        "text": "安吉县"
      } ],
      "id": "969-gP",
      "value": "湖州市",
      "text": "湖州市"
    }, {
      "children": [ {
        "id": "976-6T",
        "value": "越城区",
        "text": "越城区"
      }, {
        "id": "977-pX",
        "value": "柯桥区",
        "text": "柯桥区"
      }, {
        "id": "978-VG",
        "value": "上虞区",
        "text": "上虞区"
      }, {
        "id": "979-YS",
        "value": "新昌县",
        "text": "新昌县"
      }, {
        "id": "980-CX",
        "value": "诸暨市",
        "text": "诸暨市"
      }, {
        "id": "981-9E",
        "value": "嵊州市",
        "text": "嵊州市"
      } ],
      "id": "975-5p",
      "value": "绍兴市",
      "text": "绍兴市"
    }, {
      "children": [ {
        "id": "983-Vz",
        "value": "婺城区",
        "text": "婺城区"
      }, {
        "id": "984-nD",
        "value": "金东区",
        "text": "金东区"
      }, {
        "id": "985-XX",
        "value": "武义县",
        "text": "武义县"
      }, {
        "id": "986-8K",
        "value": "浦江县",
        "text": "浦江县"
      }, {
        "id": "987-Fp",
        "value": "磐安县",
        "text": "磐安县"
      }, {
        "id": "988-7s",
        "value": "兰溪市",
        "text": "兰溪市"
      }, {
        "id": "989-oz",
        "value": "义乌市",
        "text": "义乌市"
      }, {
        "id": "990-DZ",
        "value": "东阳市",
        "text": "东阳市"
      }, {
        "id": "991-9c",
        "value": "永康市",
        "text": "永康市"
      } ],
      "id": "982-I8",
      "value": "金华市",
      "text": "金华市"
    }, {
      "children": [ {
        "id": "993-vE",
        "value": "柯城区",
        "text": "柯城区"
      }, {
        "id": "994-WK",
        "value": "衢江区",
        "text": "衢江区"
      }, {
        "id": "995-jx",
        "value": "常山县",
        "text": "常山县"
      }, {
        "id": "996-ZC",
        "value": "开化县",
        "text": "开化县"
      }, {
        "id": "997-9T",
        "value": "龙游县",
        "text": "龙游县"
      }, {
        "id": "998-3I",
        "value": "江山市",
        "text": "江山市"
      } ],
      "id": "992-RA",
      "value": "衢州市",
      "text": "衢州市"
    }, {
      "children": [ {
        "id": "1000-eU",
        "value": "定海区",
        "text": "定海区"
      }, {
        "id": "1001-Zb",
        "value": "普陀区",
        "text": "普陀区"
      }, {
        "id": "1002-Ui",
        "value": "岱山县",
        "text": "岱山县"
      }, {
        "id": "1003-88",
        "value": "嵊泗县",
        "text": "嵊泗县"
      } ],
      "id": "999-tx",
      "value": "舟山市",
      "text": "舟山市"
    }, {
      "children": [ {
        "id": "1005-Y2",
        "value": "椒江区",
        "text": "椒江区"
      }, {
        "id": "1006-In",
        "value": "黄岩区",
        "text": "黄岩区"
      }, {
        "id": "1007-dC",
        "value": "路桥区",
        "text": "路桥区"
      }, {
        "id": "1008-eb",
        "value": "玉环县",
        "text": "玉环县"
      }, {
        "id": "1009-of",
        "value": "三门县",
        "text": "三门县"
      }, {
        "id": "1010-ix",
        "value": "天台县",
        "text": "天台县"
      }, {
        "id": "1011-8D",
        "value": "仙居县",
        "text": "仙居县"
      }, {
        "id": "1012-LU",
        "value": "温岭市",
        "text": "温岭市"
      }, {
        "id": "1013-Ml",
        "value": "临海市",
        "text": "临海市"
      } ],
      "id": "1004-Kz",
      "value": "台州市",
      "text": "台州市"
    }, {
      "children": [ {
        "id": "1015-v3",
        "value": "莲都区",
        "text": "莲都区"
      }, {
        "id": "1016-83",
        "value": "青田县",
        "text": "青田县"
      }, {
        "id": "1017-Dg",
        "value": "缙云县",
        "text": "缙云县"
      }, {
        "id": "1018-Aj",
        "value": "遂昌县",
        "text": "遂昌县"
      }, {
        "id": "1019-DF",
        "value": "松阳县",
        "text": "松阳县"
      }, {
        "id": "1020-xg",
        "value": "云和县",
        "text": "云和县"
      }, {
        "id": "1021-Eu",
        "value": "庆元县",
        "text": "庆元县"
      }, {
        "id": "1022-Zf",
        "value": "景宁畲族自治县",
        "text": "景宁畲族自治县"
      }, {
        "id": "1023-As",
        "value": "龙泉市",
        "text": "龙泉市"
      } ],
      "id": "1014-qi",
      "value": "丽水市",
      "text": "丽水市"
    } ],
    "id": "922-0w",
    "value": "浙江省",
    "text": "浙江省"
  }, {
    "children": [ {
      "children": [ {
        "id": "1026-Wg",
        "value": "瑶海区",
        "text": "瑶海区"
      }, {
        "id": "1027-eX",
        "value": "庐阳区",
        "text": "庐阳区"
      }, {
        "id": "1028-gj",
        "value": "蜀山区",
        "text": "蜀山区"
      }, {
        "id": "1029-wo",
        "value": "包河区",
        "text": "包河区"
      }, {
        "id": "1030-t7",
        "value": "长丰县",
        "text": "长丰县"
      }, {
        "id": "1031-A1",
        "value": "肥东县",
        "text": "肥东县"
      }, {
        "id": "1032-LL",
        "value": "肥西县",
        "text": "肥西县"
      }, {
        "id": "1033-Wk",
        "value": "庐江县",
        "text": "庐江县"
      }, {
        "id": "1034-Oz",
        "value": "巢湖市",
        "text": "巢湖市"
      } ],
      "id": "1025-JB",
      "value": "合肥市",
      "text": "合肥市"
    }, {
      "children": [ {
        "id": "1036-18",
        "value": "镜湖区",
        "text": "镜湖区"
      }, {
        "id": "1037-5V",
        "value": "弋江区",
        "text": "弋江区"
      }, {
        "id": "1038-wb",
        "value": "鸠江区",
        "text": "鸠江区"
      }, {
        "id": "1039-eV",
        "value": "三山区",
        "text": "三山区"
      }, {
        "id": "1040-aF",
        "value": "芜湖县",
        "text": "芜湖县"
      }, {
        "id": "1041-OR",
        "value": "繁昌县",
        "text": "繁昌县"
      }, {
        "id": "1042-qA",
        "value": "南陵县",
        "text": "南陵县"
      }, {
        "id": "1043-SN",
        "value": "无为县",
        "text": "无为县"
      } ],
      "id": "1035-Cq",
      "value": "芜湖市",
      "text": "芜湖市"
    }, {
      "children": [ {
        "id": "1045-bN",
        "value": "龙子湖区",
        "text": "龙子湖区"
      }, {
        "id": "1046-QC",
        "value": "蚌山区",
        "text": "蚌山区"
      }, {
        "id": "1047-N0",
        "value": "禹会区",
        "text": "禹会区"
      }, {
        "id": "1048-SP",
        "value": "淮上区",
        "text": "淮上区"
      }, {
        "id": "1049-J1",
        "value": "怀远县",
        "text": "怀远县"
      }, {
        "id": "1050-bt",
        "value": "五河县",
        "text": "五河县"
      }, {
        "id": "1051-GA",
        "value": "固镇县",
        "text": "固镇县"
      } ],
      "id": "1044-8X",
      "value": "蚌埠市",
      "text": "蚌埠市"
    }, {
      "children": [ {
        "id": "1053-RE",
        "value": "大通区",
        "text": "大通区"
      }, {
        "id": "1054-ex",
        "value": "田家庵区",
        "text": "田家庵区"
      }, {
        "id": "1055-ss",
        "value": "谢家集区",
        "text": "谢家集区"
      }, {
        "id": "1056-vB",
        "value": "八公山区",
        "text": "八公山区"
      }, {
        "id": "1057-3x",
        "value": "潘集区",
        "text": "潘集区"
      }, {
        "id": "1058-4C",
        "value": "凤台县",
        "text": "凤台县"
      }, {
        "id": "1059-Rh",
        "value": "寿县",
        "text": "寿县"
      } ],
      "id": "1052-u7",
      "value": "淮南市",
      "text": "淮南市"
    }, {
      "children": [ {
        "id": "1061-K3",
        "value": "花山区",
        "text": "花山区"
      }, {
        "id": "1062-7C",
        "value": "雨山区",
        "text": "雨山区"
      }, {
        "id": "1063-c5",
        "value": "博望区",
        "text": "博望区"
      }, {
        "id": "1064-7U",
        "value": "当涂县",
        "text": "当涂县"
      }, {
        "id": "1065-VO",
        "value": "含山县",
        "text": "含山县"
      }, {
        "id": "1066-4h",
        "value": "和县",
        "text": "和县"
      } ],
      "id": "1060-pP",
      "value": "马鞍山市",
      "text": "马鞍山市"
    }, {
      "children": [ {
        "id": "1068-48",
        "value": "杜集区",
        "text": "杜集区"
      }, {
        "id": "1069-II",
        "value": "相山区",
        "text": "相山区"
      }, {
        "id": "1070-B3",
        "value": "烈山区",
        "text": "烈山区"
      }, {
        "id": "1071-ZS",
        "value": "濉溪县",
        "text": "濉溪县"
      } ],
      "id": "1067-AV",
      "value": "淮北市",
      "text": "淮北市"
    }, {
      "children": [ {
        "id": "1073-xD",
        "value": "铜官区",
        "text": "铜官区"
      }, {
        "id": "1074-wX",
        "value": "义安区",
        "text": "义安区"
      }, {
        "id": "1075-Jl",
        "value": "郊区",
        "text": "郊区"
      }, {
        "id": "1076-Sr",
        "value": "枞阳县",
        "text": "枞阳县"
      } ],
      "id": "1072-8g",
      "value": "铜陵市",
      "text": "铜陵市"
    }, {
      "children": [ {
        "id": "1078-yy",
        "value": "迎江区",
        "text": "迎江区"
      }, {
        "id": "1079-zp",
        "value": "大观区",
        "text": "大观区"
      }, {
        "id": "1080-oc",
        "value": "宜秀区",
        "text": "宜秀区"
      }, {
        "id": "1081-gt",
        "value": "怀宁县",
        "text": "怀宁县"
      }, {
        "id": "1082-iF",
        "value": "潜山县",
        "text": "潜山县"
      }, {
        "id": "1083-GL",
        "value": "太湖县",
        "text": "太湖县"
      }, {
        "id": "1084-h9",
        "value": "宿松县",
        "text": "宿松县"
      }, {
        "id": "1085-3O",
        "value": "望江县",
        "text": "望江县"
      }, {
        "id": "1086-45",
        "value": "岳西县",
        "text": "岳西县"
      }, {
        "id": "1087-lv",
        "value": "桐城市",
        "text": "桐城市"
      } ],
      "id": "1077-CV",
      "value": "安庆市",
      "text": "安庆市"
    }, {
      "children": [ {
        "id": "1089-r3",
        "value": "屯溪区",
        "text": "屯溪区"
      }, {
        "id": "1090-ur",
        "value": "黄山区",
        "text": "黄山区"
      }, {
        "id": "1091-UP",
        "value": "徽州区",
        "text": "徽州区"
      }, {
        "id": "1092-8F",
        "value": "歙县",
        "text": "歙县"
      }, {
        "id": "1093-pu",
        "value": "休宁县",
        "text": "休宁县"
      }, {
        "id": "1094-7q",
        "value": "黟县",
        "text": "黟县"
      }, {
        "id": "1095-PF",
        "value": "祁门县",
        "text": "祁门县"
      } ],
      "id": "1088-jE",
      "value": "黄山市",
      "text": "黄山市"
    }, {
      "children": [ {
        "id": "1097-ll",
        "value": "琅琊区",
        "text": "琅琊区"
      }, {
        "id": "1098-lM",
        "value": "南谯区",
        "text": "南谯区"
      }, {
        "id": "1099-C4",
        "value": "来安县",
        "text": "来安县"
      }, {
        "id": "1100-1t",
        "value": "全椒县",
        "text": "全椒县"
      }, {
        "id": "1101-8r",
        "value": "定远县",
        "text": "定远县"
      }, {
        "id": "1102-zA",
        "value": "凤阳县",
        "text": "凤阳县"
      }, {
        "id": "1103-Jn",
        "value": "天长市",
        "text": "天长市"
      }, {
        "id": "1104-YU",
        "value": "明光市",
        "text": "明光市"
      } ],
      "id": "1096-GN",
      "value": "滁州市",
      "text": "滁州市"
    }, {
      "children": [ {
        "id": "1106-np",
        "value": "颍州区",
        "text": "颍州区"
      }, {
        "id": "1107-wy",
        "value": "颍东区",
        "text": "颍东区"
      }, {
        "id": "1108-I4",
        "value": "颍泉区",
        "text": "颍泉区"
      }, {
        "id": "1109-lO",
        "value": "临泉县",
        "text": "临泉县"
      }, {
        "id": "1110-CT",
        "value": "太和县",
        "text": "太和县"
      }, {
        "id": "1111-g8",
        "value": "阜南县",
        "text": "阜南县"
      }, {
        "id": "1112-KH",
        "value": "颍上县",
        "text": "颍上县"
      }, {
        "id": "1113-h8",
        "value": "界首市",
        "text": "界首市"
      } ],
      "id": "1105-Ku",
      "value": "阜阳市",
      "text": "阜阳市"
    }, {
      "children": [ {
        "id": "1115-WV",
        "value": "埇桥区",
        "text": "埇桥区"
      }, {
        "id": "1116-hM",
        "value": "砀山县",
        "text": "砀山县"
      }, {
        "id": "1117-rE",
        "value": "萧县",
        "text": "萧县"
      }, {
        "id": "1118-vk",
        "value": "灵璧县",
        "text": "灵璧县"
      }, {
        "id": "1119-vo",
        "value": "泗县",
        "text": "泗县"
      } ],
      "id": "1114-j4",
      "value": "宿州市",
      "text": "宿州市"
    }, {
      "children": [ {
        "id": "1121-r5",
        "value": "金安区",
        "text": "金安区"
      }, {
        "id": "1122-To",
        "value": "裕安区",
        "text": "裕安区"
      }, {
        "id": "1123-Tp",
        "value": "叶集区",
        "text": "叶集区"
      }, {
        "id": "1124-IK",
        "value": "霍邱县",
        "text": "霍邱县"
      }, {
        "id": "1125-hi",
        "value": "舒城县",
        "text": "舒城县"
      }, {
        "id": "1126-CI",
        "value": "金寨县",
        "text": "金寨县"
      }, {
        "id": "1127-Gr",
        "value": "霍山县",
        "text": "霍山县"
      } ],
      "id": "1120-NS",
      "value": "六安市",
      "text": "六安市"
    }, {
      "children": [ {
        "id": "1129-YC",
        "value": "谯城区",
        "text": "谯城区"
      }, {
        "id": "1130-DX",
        "value": "涡阳县",
        "text": "涡阳县"
      }, {
        "id": "1131-Of",
        "value": "蒙城县",
        "text": "蒙城县"
      }, {
        "id": "1132-bv",
        "value": "利辛县",
        "text": "利辛县"
      } ],
      "id": "1128-Od",
      "value": "亳州市",
      "text": "亳州市"
    }, {
      "children": [ {
        "id": "1134-nT",
        "value": "贵池区",
        "text": "贵池区"
      }, {
        "id": "1135-kT",
        "value": "东至县",
        "text": "东至县"
      }, {
        "id": "1136-HB",
        "value": "石台县",
        "text": "石台县"
      }, {
        "id": "1137-EI",
        "value": "青阳县",
        "text": "青阳县"
      } ],
      "id": "1133-p3",
      "value": "池州市",
      "text": "池州市"
    }, {
      "children": [ {
        "id": "1139-tS",
        "value": "宣州区",
        "text": "宣州区"
      }, {
        "id": "1140-bn",
        "value": "郎溪县",
        "text": "郎溪县"
      }, {
        "id": "1141-31",
        "value": "广德县",
        "text": "广德县"
      }, {
        "id": "1142-rv",
        "value": "泾县",
        "text": "泾县"
      }, {
        "id": "1143-FV",
        "value": "绩溪县",
        "text": "绩溪县"
      }, {
        "id": "1144-Bq",
        "value": "旌德县",
        "text": "旌德县"
      }, {
        "id": "1145-1x",
        "value": "宁国市",
        "text": "宁国市"
      } ],
      "id": "1138-fG",
      "value": "宣城市",
      "text": "宣城市"
    } ],
    "id": "1024-9V",
    "value": "安徽省",
    "text": "安徽省"
  }, {
    "children": [ {
      "children": [ {
        "id": "1148-UU",
        "value": "鼓楼区",
        "text": "鼓楼区"
      }, {
        "id": "1149-oN",
        "value": "台江区",
        "text": "台江区"
      }, {
        "id": "1150-a9",
        "value": "仓山区",
        "text": "仓山区"
      }, {
        "id": "1151-2o",
        "value": "马尾区",
        "text": "马尾区"
      }, {
        "id": "1152-OS",
        "value": "晋安区",
        "text": "晋安区"
      }, {
        "id": "1153-jx",
        "value": "闽侯县",
        "text": "闽侯县"
      }, {
        "id": "1154-AD",
        "value": "连江县",
        "text": "连江县"
      }, {
        "id": "1155-OF",
        "value": "罗源县",
        "text": "罗源县"
      }, {
        "id": "1156-N7",
        "value": "闽清县",
        "text": "闽清县"
      }, {
        "id": "1157-DD",
        "value": "永泰县",
        "text": "永泰县"
      }, {
        "id": "1158-KW",
        "value": "平潭县",
        "text": "平潭县"
      }, {
        "id": "1159-sA",
        "value": "福清市",
        "text": "福清市"
      }, {
        "id": "1160-29",
        "value": "长乐市",
        "text": "长乐市"
      } ],
      "id": "1147-WE",
      "value": "福州市",
      "text": "福州市"
    }, {
      "children": [ {
        "id": "1162-P8",
        "value": "思明区",
        "text": "思明区"
      }, {
        "id": "1163-DR",
        "value": "海沧区",
        "text": "海沧区"
      }, {
        "id": "1164-is",
        "value": "湖里区",
        "text": "湖里区"
      }, {
        "id": "1165-2B",
        "value": "集美区",
        "text": "集美区"
      }, {
        "id": "1166-A2",
        "value": "同安区",
        "text": "同安区"
      }, {
        "id": "1167-BT",
        "value": "翔安区",
        "text": "翔安区"
      } ],
      "id": "1161-JJ",
      "value": "厦门市",
      "text": "厦门市"
    }, {
      "children": [ {
        "id": "1169-HY",
        "value": "城厢区",
        "text": "城厢区"
      }, {
        "id": "1170-gt",
        "value": "涵江区",
        "text": "涵江区"
      }, {
        "id": "1171-Tl",
        "value": "荔城区",
        "text": "荔城区"
      }, {
        "id": "1172-N7",
        "value": "秀屿区",
        "text": "秀屿区"
      }, {
        "id": "1173-4V",
        "value": "仙游县",
        "text": "仙游县"
      } ],
      "id": "1168-Z1",
      "value": "莆田市",
      "text": "莆田市"
    }, {
      "children": [ {
        "id": "1175-KK",
        "value": "梅列区",
        "text": "梅列区"
      }, {
        "id": "1176-9T",
        "value": "三元区",
        "text": "三元区"
      }, {
        "id": "1177-Gs",
        "value": "明溪县",
        "text": "明溪县"
      }, {
        "id": "1178-Sz",
        "value": "清流县",
        "text": "清流县"
      }, {
        "id": "1179-Rn",
        "value": "宁化县",
        "text": "宁化县"
      }, {
        "id": "1180-SR",
        "value": "大田县",
        "text": "大田县"
      }, {
        "id": "1181-AX",
        "value": "尤溪县",
        "text": "尤溪县"
      }, {
        "id": "1182-0Q",
        "value": "沙县",
        "text": "沙县"
      }, {
        "id": "1183-ef",
        "value": "将乐县",
        "text": "将乐县"
      }, {
        "id": "1184-cb",
        "value": "泰宁县",
        "text": "泰宁县"
      }, {
        "id": "1185-Oj",
        "value": "建宁县",
        "text": "建宁县"
      }, {
        "id": "1186-0S",
        "value": "永安市",
        "text": "永安市"
      } ],
      "id": "1174-gJ",
      "value": "三明市",
      "text": "三明市"
    }, {
      "children": [ {
        "id": "1188-1X",
        "value": "鲤城区",
        "text": "鲤城区"
      }, {
        "id": "1189-eQ",
        "value": "丰泽区",
        "text": "丰泽区"
      }, {
        "id": "1190-Qe",
        "value": "洛江区",
        "text": "洛江区"
      }, {
        "id": "1191-OU",
        "value": "泉港区",
        "text": "泉港区"
      }, {
        "id": "1192-GW",
        "value": "惠安县",
        "text": "惠安县"
      }, {
        "id": "1193-xb",
        "value": "安溪县",
        "text": "安溪县"
      }, {
        "id": "1194-WU",
        "value": "永春县",
        "text": "永春县"
      }, {
        "id": "1195-ae",
        "value": "德化县",
        "text": "德化县"
      }, {
        "id": "1196-82",
        "value": "金门县",
        "text": "金门县"
      }, {
        "id": "1197-Zh",
        "value": "石狮市",
        "text": "石狮市"
      }, {
        "id": "1198-tH",
        "value": "晋江市",
        "text": "晋江市"
      }, {
        "id": "1199-8P",
        "value": "南安市",
        "text": "南安市"
      } ],
      "id": "1187-Hr",
      "value": "泉州市",
      "text": "泉州市"
    }, {
      "children": [ {
        "id": "1201-YH",
        "value": "芗城区",
        "text": "芗城区"
      }, {
        "id": "1202-fN",
        "value": "龙文区",
        "text": "龙文区"
      }, {
        "id": "1203-0a",
        "value": "云霄县",
        "text": "云霄县"
      }, {
        "id": "1204-2u",
        "value": "漳浦县",
        "text": "漳浦县"
      }, {
        "id": "1205-w0",
        "value": "诏安县",
        "text": "诏安县"
      }, {
        "id": "1206-u7",
        "value": "长泰县",
        "text": "长泰县"
      }, {
        "id": "1207-0S",
        "value": "东山县",
        "text": "东山县"
      }, {
        "id": "1208-dn",
        "value": "南靖县",
        "text": "南靖县"
      }, {
        "id": "1209-Kn",
        "value": "平和县",
        "text": "平和县"
      }, {
        "id": "1210-bK",
        "value": "华安县",
        "text": "华安县"
      }, {
        "id": "1211-zz",
        "value": "龙海市",
        "text": "龙海市"
      } ],
      "id": "1200-2i",
      "value": "漳州市",
      "text": "漳州市"
    }, {
      "children": [ {
        "id": "1213-by",
        "value": "延平区",
        "text": "延平区"
      }, {
        "id": "1214-Er",
        "value": "建阳区",
        "text": "建阳区"
      }, {
        "id": "1215-cD",
        "value": "顺昌县",
        "text": "顺昌县"
      }, {
        "id": "1216-tu",
        "value": "浦城县",
        "text": "浦城县"
      }, {
        "id": "1217-a9",
        "value": "光泽县",
        "text": "光泽县"
      }, {
        "id": "1218-rp",
        "value": "松溪县",
        "text": "松溪县"
      }, {
        "id": "1219-lT",
        "value": "政和县",
        "text": "政和县"
      }, {
        "id": "1220-jq",
        "value": "邵武市",
        "text": "邵武市"
      }, {
        "id": "1221-qo",
        "value": "武夷山市",
        "text": "武夷山市"
      }, {
        "id": "1222-gc",
        "value": "建瓯市",
        "text": "建瓯市"
      } ],
      "id": "1212-Y3",
      "value": "南平市",
      "text": "南平市"
    }, {
      "children": [ {
        "id": "1224-g6",
        "value": "新罗区",
        "text": "新罗区"
      }, {
        "id": "1225-bD",
        "value": "永定区",
        "text": "永定区"
      }, {
        "id": "1226-a0",
        "value": "长汀县",
        "text": "长汀县"
      }, {
        "id": "1227-nl",
        "value": "上杭县",
        "text": "上杭县"
      }, {
        "id": "1228-bp",
        "value": "武平县",
        "text": "武平县"
      }, {
        "id": "1229-EP",
        "value": "连城县",
        "text": "连城县"
      }, {
        "id": "1230-XI",
        "value": "漳平市",
        "text": "漳平市"
      } ],
      "id": "1223-Gl",
      "value": "龙岩市",
      "text": "龙岩市"
    }, {
      "children": [ {
        "id": "1232-6C",
        "value": "蕉城区",
        "text": "蕉城区"
      }, {
        "id": "1233-jS",
        "value": "霞浦县",
        "text": "霞浦县"
      }, {
        "id": "1234-XA",
        "value": "古田县",
        "text": "古田县"
      }, {
        "id": "1235-LE",
        "value": "屏南县",
        "text": "屏南县"
      }, {
        "id": "1236-jI",
        "value": "寿宁县",
        "text": "寿宁县"
      }, {
        "id": "1237-ke",
        "value": "周宁县",
        "text": "周宁县"
      }, {
        "id": "1238-89",
        "value": "柘荣县",
        "text": "柘荣县"
      }, {
        "id": "1239-tR",
        "value": "福安市",
        "text": "福安市"
      }, {
        "id": "1240-r9",
        "value": "福鼎市",
        "text": "福鼎市"
      } ],
      "id": "1231-LK",
      "value": "宁德市",
      "text": "宁德市"
    } ],
    "id": "1146-T0",
    "value": "福建省",
    "text": "福建省"
  }, {
    "children": [ {
      "children": [ {
        "id": "1243-z7",
        "value": "东湖区",
        "text": "东湖区"
      }, {
        "id": "1244-Wt",
        "value": "西湖区",
        "text": "西湖区"
      }, {
        "id": "1245-P6",
        "value": "青云谱区",
        "text": "青云谱区"
      }, {
        "id": "1246-mg",
        "value": "湾里区",
        "text": "湾里区"
      }, {
        "id": "1247-os",
        "value": "青山湖区",
        "text": "青山湖区"
      }, {
        "id": "1248-ZC",
        "value": "新建区",
        "text": "新建区"
      }, {
        "id": "1249-Ud",
        "value": "南昌县",
        "text": "南昌县"
      }, {
        "id": "1250-bZ",
        "value": "安义县",
        "text": "安义县"
      }, {
        "id": "1251-is",
        "value": "进贤县",
        "text": "进贤县"
      } ],
      "id": "1242-g1",
      "value": "南昌市",
      "text": "南昌市"
    }, {
      "children": [ {
        "id": "1253-9G",
        "value": "昌江区",
        "text": "昌江区"
      }, {
        "id": "1254-Zn",
        "value": "珠山区",
        "text": "珠山区"
      }, {
        "id": "1255-7r",
        "value": "浮梁县",
        "text": "浮梁县"
      }, {
        "id": "1256-8Q",
        "value": "乐平市",
        "text": "乐平市"
      } ],
      "id": "1252-hf",
      "value": "景德镇市",
      "text": "景德镇市"
    }, {
      "children": [ {
        "id": "1258-li",
        "value": "安源区",
        "text": "安源区"
      }, {
        "id": "1259-6O",
        "value": "湘东区",
        "text": "湘东区"
      }, {
        "id": "1260-82",
        "value": "莲花县",
        "text": "莲花县"
      }, {
        "id": "1261-PC",
        "value": "上栗县",
        "text": "上栗县"
      }, {
        "id": "1262-ba",
        "value": "芦溪县",
        "text": "芦溪县"
      } ],
      "id": "1257-LF",
      "value": "萍乡市",
      "text": "萍乡市"
    }, {
      "children": [ {
        "id": "1264-oJ",
        "value": "濂溪区",
        "text": "濂溪区"
      }, {
        "id": "1265-Iq",
        "value": "浔阳区",
        "text": "浔阳区"
      }, {
        "id": "1266-57",
        "value": "九江县",
        "text": "九江县"
      }, {
        "id": "1267-UC",
        "value": "武宁县",
        "text": "武宁县"
      }, {
        "id": "1268-ik",
        "value": "修水县",
        "text": "修水县"
      }, {
        "id": "1269-Fz",
        "value": "永修县",
        "text": "永修县"
      }, {
        "id": "1270-RE",
        "value": "德安县",
        "text": "德安县"
      }, {
        "id": "1271-CC",
        "value": "都昌县",
        "text": "都昌县"
      }, {
        "id": "1272-H4",
        "value": "湖口县",
        "text": "湖口县"
      }, {
        "id": "1273-GK",
        "value": "彭泽县",
        "text": "彭泽县"
      }, {
        "id": "1274-PT",
        "value": "瑞昌市",
        "text": "瑞昌市"
      }, {
        "id": "1275-Uy",
        "value": "共青城市",
        "text": "共青城市"
      }, {
        "id": "1276-0P",
        "value": "庐山市",
        "text": "庐山市"
      } ],
      "id": "1263-Q2",
      "value": "九江市",
      "text": "九江市"
    }, {
      "children": [ {
        "id": "1278-zb",
        "value": "渝水区",
        "text": "渝水区"
      }, {
        "id": "1279-TI",
        "value": "分宜县",
        "text": "分宜县"
      } ],
      "id": "1277-gI",
      "value": "新余市",
      "text": "新余市"
    }, {
      "children": [ {
        "id": "1281-KG",
        "value": "月湖区",
        "text": "月湖区"
      }, {
        "id": "1282-aY",
        "value": "余江县",
        "text": "余江县"
      }, {
        "id": "1283-do",
        "value": "贵溪市",
        "text": "贵溪市"
      } ],
      "id": "1280-Nh",
      "value": "鹰潭市",
      "text": "鹰潭市"
    }, {
      "children": [ {
        "id": "1285-vx",
        "value": "章贡区",
        "text": "章贡区"
      }, {
        "id": "1286-nM",
        "value": "南康区",
        "text": "南康区"
      }, {
        "id": "1287-XU",
        "value": "赣县",
        "text": "赣县"
      }, {
        "id": "1288-gc",
        "value": "信丰县",
        "text": "信丰县"
      }, {
        "id": "1289-7V",
        "value": "大余县",
        "text": "大余县"
      }, {
        "id": "1290-zC",
        "value": "上犹县",
        "text": "上犹县"
      }, {
        "id": "1291-DB",
        "value": "崇义县",
        "text": "崇义县"
      }, {
        "id": "1292-x2",
        "value": "安远县",
        "text": "安远县"
      }, {
        "id": "1293-g4",
        "value": "龙南县",
        "text": "龙南县"
      }, {
        "id": "1294-ms",
        "value": "定南县",
        "text": "定南县"
      }, {
        "id": "1295-WZ",
        "value": "全南县",
        "text": "全南县"
      }, {
        "id": "1296-OZ",
        "value": "宁都县",
        "text": "宁都县"
      }, {
        "id": "1297-fT",
        "value": "于都县",
        "text": "于都县"
      }, {
        "id": "1298-7h",
        "value": "兴国县",
        "text": "兴国县"
      }, {
        "id": "1299-Pw",
        "value": "会昌县",
        "text": "会昌县"
      }, {
        "id": "1300-up",
        "value": "寻乌县",
        "text": "寻乌县"
      }, {
        "id": "1301-M8",
        "value": "石城县",
        "text": "石城县"
      }, {
        "id": "1302-Fy",
        "value": "瑞金市",
        "text": "瑞金市"
      } ],
      "id": "1284-bc",
      "value": "赣州市",
      "text": "赣州市"
    }, {
      "children": [ {
        "id": "1304-YV",
        "value": "吉州区",
        "text": "吉州区"
      }, {
        "id": "1305-er",
        "value": "青原区",
        "text": "青原区"
      }, {
        "id": "1306-Na",
        "value": "吉安县",
        "text": "吉安县"
      }, {
        "id": "1307-Ts",
        "value": "吉水县",
        "text": "吉水县"
      }, {
        "id": "1308-BS",
        "value": "峡江县",
        "text": "峡江县"
      }, {
        "id": "1309-u7",
        "value": "新干县",
        "text": "新干县"
      }, {
        "id": "1310-s8",
        "value": "永丰县",
        "text": "永丰县"
      }, {
        "id": "1311-qc",
        "value": "泰和县",
        "text": "泰和县"
      }, {
        "id": "1312-GB",
        "value": "遂川县",
        "text": "遂川县"
      }, {
        "id": "1313-hd",
        "value": "万安县",
        "text": "万安县"
      }, {
        "id": "1314-1v",
        "value": "安福县",
        "text": "安福县"
      }, {
        "id": "1315-ft",
        "value": "永新县",
        "text": "永新县"
      }, {
        "id": "1316-4b",
        "value": "井冈山市",
        "text": "井冈山市"
      } ],
      "id": "1303-yD",
      "value": "吉安市",
      "text": "吉安市"
    }, {
      "children": [ {
        "id": "1318-IA",
        "value": "袁州区",
        "text": "袁州区"
      }, {
        "id": "1319-Gj",
        "value": "奉新县",
        "text": "奉新县"
      }, {
        "id": "1320-Hc",
        "value": "万载县",
        "text": "万载县"
      }, {
        "id": "1321-C8",
        "value": "上高县",
        "text": "上高县"
      }, {
        "id": "1322-bb",
        "value": "宜丰县",
        "text": "宜丰县"
      }, {
        "id": "1323-W2",
        "value": "靖安县",
        "text": "靖安县"
      }, {
        "id": "1324-Dy",
        "value": "铜鼓县",
        "text": "铜鼓县"
      }, {
        "id": "1325-04",
        "value": "丰城市",
        "text": "丰城市"
      }, {
        "id": "1326-M9",
        "value": "樟树市",
        "text": "樟树市"
      }, {
        "id": "1327-Ph",
        "value": "高安市",
        "text": "高安市"
      } ],
      "id": "1317-RH",
      "value": "宜春市",
      "text": "宜春市"
    }, {
      "children": [ {
        "id": "1329-fB",
        "value": "临川区",
        "text": "临川区"
      }, {
        "id": "1330-YH",
        "value": "南城县",
        "text": "南城县"
      }, {
        "id": "1331-QZ",
        "value": "黎川县",
        "text": "黎川县"
      }, {
        "id": "1332-ou",
        "value": "南丰县",
        "text": "南丰县"
      }, {
        "id": "1333-7K",
        "value": "崇仁县",
        "text": "崇仁县"
      }, {
        "id": "1334-M0",
        "value": "乐安县",
        "text": "乐安县"
      }, {
        "id": "1335-DG",
        "value": "宜黄县",
        "text": "宜黄县"
      }, {
        "id": "1336-jW",
        "value": "金溪县",
        "text": "金溪县"
      }, {
        "id": "1337-oQ",
        "value": "资溪县",
        "text": "资溪县"
      }, {
        "id": "1338-BV",
        "value": "东乡县",
        "text": "东乡县"
      }, {
        "id": "1339-r0",
        "value": "广昌县",
        "text": "广昌县"
      } ],
      "id": "1328-AH",
      "value": "抚州市",
      "text": "抚州市"
    }, {
      "children": [ {
        "id": "1341-dr",
        "value": "信州区",
        "text": "信州区"
      }, {
        "id": "1342-xX",
        "value": "广丰区",
        "text": "广丰区"
      }, {
        "id": "1343-Ub",
        "value": "上饶县",
        "text": "上饶县"
      }, {
        "id": "1344-10",
        "value": "玉山县",
        "text": "玉山县"
      }, {
        "id": "1345-xf",
        "value": "铅山县",
        "text": "铅山县"
      }, {
        "id": "1346-RW",
        "value": "横峰县",
        "text": "横峰县"
      }, {
        "id": "1347-rm",
        "value": "弋阳县",
        "text": "弋阳县"
      }, {
        "id": "1348-Gy",
        "value": "余干县",
        "text": "余干县"
      }, {
        "id": "1349-0a",
        "value": "鄱阳县",
        "text": "鄱阳县"
      }, {
        "id": "1350-Ca",
        "value": "万年县",
        "text": "万年县"
      }, {
        "id": "1351-8X",
        "value": "婺源县",
        "text": "婺源县"
      }, {
        "id": "1352-8k",
        "value": "德兴市",
        "text": "德兴市"
      } ],
      "id": "1340-6T",
      "value": "上饶市",
      "text": "上饶市"
    } ],
    "id": "1241-c2",
    "value": "江西省",
    "text": "江西省"
  }, {
    "children": [ {
      "children": [ {
        "id": "1355-JD",
        "value": "历下区",
        "text": "历下区"
      }, {
        "id": "1356-J9",
        "value": "市中区",
        "text": "市中区"
      }, {
        "id": "1357-6f",
        "value": "槐荫区",
        "text": "槐荫区"
      }, {
        "id": "1358-kZ",
        "value": "天桥区",
        "text": "天桥区"
      }, {
        "id": "1359-MC",
        "value": "历城区",
        "text": "历城区"
      }, {
        "id": "1360-BT",
        "value": "长清区",
        "text": "长清区"
      }, {
        "id": "1361-hN",
        "value": "平阴县",
        "text": "平阴县"
      }, {
        "id": "1362-L4",
        "value": "济阳县",
        "text": "济阳县"
      }, {
        "id": "1363-gc",
        "value": "商河县",
        "text": "商河县"
      }, {
        "id": "1364-o5",
        "value": "章丘市",
        "text": "章丘市"
      } ],
      "id": "1354-rA",
      "value": "济南市",
      "text": "济南市"
    }, {
      "children": [ {
        "id": "1366-12",
        "value": "市南区",
        "text": "市南区"
      }, {
        "id": "1367-pW",
        "value": "市北区",
        "text": "市北区"
      }, {
        "id": "1368-ZE",
        "value": "黄岛区",
        "text": "黄岛区"
      }, {
        "id": "1369-dg",
        "value": "崂山区",
        "text": "崂山区"
      }, {
        "id": "1370-t9",
        "value": "李沧区",
        "text": "李沧区"
      }, {
        "id": "1371-vs",
        "value": "城阳区",
        "text": "城阳区"
      }, {
        "id": "1372-Lb",
        "value": "胶州市",
        "text": "胶州市"
      }, {
        "id": "1373-IP",
        "value": "即墨市",
        "text": "即墨市"
      }, {
        "id": "1374-sq",
        "value": "平度市",
        "text": "平度市"
      }, {
        "id": "1375-wQ",
        "value": "莱西市",
        "text": "莱西市"
      } ],
      "id": "1365-Y7",
      "value": "青岛市",
      "text": "青岛市"
    }, {
      "children": [ {
        "id": "1377-EE",
        "value": "淄川区",
        "text": "淄川区"
      }, {
        "id": "1378-2a",
        "value": "张店区",
        "text": "张店区"
      }, {
        "id": "1379-Li",
        "value": "博山区",
        "text": "博山区"
      }, {
        "id": "1380-Iv",
        "value": "临淄区",
        "text": "临淄区"
      }, {
        "id": "1381-AR",
        "value": "周村区",
        "text": "周村区"
      }, {
        "id": "1382-1N",
        "value": "桓台县",
        "text": "桓台县"
      }, {
        "id": "1383-BI",
        "value": "高青县",
        "text": "高青县"
      }, {
        "id": "1384-oQ",
        "value": "沂源县",
        "text": "沂源县"
      } ],
      "id": "1376-rR",
      "value": "淄博市",
      "text": "淄博市"
    }, {
      "children": [ {
        "id": "1386-Kl",
        "value": "市中区",
        "text": "市中区"
      }, {
        "id": "1387-Lx",
        "value": "薛城区",
        "text": "薛城区"
      }, {
        "id": "1388-4Y",
        "value": "峄城区",
        "text": "峄城区"
      }, {
        "id": "1389-YH",
        "value": "台儿庄区",
        "text": "台儿庄区"
      }, {
        "id": "1390-Za",
        "value": "山亭区",
        "text": "山亭区"
      }, {
        "id": "1391-iU",
        "value": "滕州市",
        "text": "滕州市"
      } ],
      "id": "1385-Mi",
      "value": "枣庄市",
      "text": "枣庄市"
    }, {
      "children": [ {
        "id": "1393-gb",
        "value": "东营区",
        "text": "东营区"
      }, {
        "id": "1394-2F",
        "value": "河口区",
        "text": "河口区"
      }, {
        "id": "1395-dg",
        "value": "垦利区",
        "text": "垦利区"
      }, {
        "id": "1396-gc",
        "value": "利津县",
        "text": "利津县"
      }, {
        "id": "1397-ow",
        "value": "广饶县",
        "text": "广饶县"
      } ],
      "id": "1392-CS",
      "value": "东营市",
      "text": "东营市"
    }, {
      "children": [ {
        "id": "1399-xh",
        "value": "芝罘区",
        "text": "芝罘区"
      }, {
        "id": "1400-Td",
        "value": "福山区",
        "text": "福山区"
      }, {
        "id": "1401-sW",
        "value": "牟平区",
        "text": "牟平区"
      }, {
        "id": "1402-MU",
        "value": "莱山区",
        "text": "莱山区"
      }, {
        "id": "1403-xc",
        "value": "长岛县",
        "text": "长岛县"
      }, {
        "id": "1404-83",
        "value": "龙口市",
        "text": "龙口市"
      }, {
        "id": "1405-Fk",
        "value": "莱阳市",
        "text": "莱阳市"
      }, {
        "id": "1406-rC",
        "value": "莱州市",
        "text": "莱州市"
      }, {
        "id": "1407-Cc",
        "value": "蓬莱市",
        "text": "蓬莱市"
      }, {
        "id": "1408-LE",
        "value": "招远市",
        "text": "招远市"
      }, {
        "id": "1409-iX",
        "value": "栖霞市",
        "text": "栖霞市"
      }, {
        "id": "1410-Ut",
        "value": "海阳市",
        "text": "海阳市"
      } ],
      "id": "1398-IL",
      "value": "烟台市",
      "text": "烟台市"
    }, {
      "children": [ {
        "id": "1412-TY",
        "value": "潍城区",
        "text": "潍城区"
      }, {
        "id": "1413-HP",
        "value": "寒亭区",
        "text": "寒亭区"
      }, {
        "id": "1414-QL",
        "value": "坊子区",
        "text": "坊子区"
      }, {
        "id": "1415-rC",
        "value": "奎文区",
        "text": "奎文区"
      }, {
        "id": "1416-Fq",
        "value": "临朐县",
        "text": "临朐县"
      }, {
        "id": "1417-CE",
        "value": "昌乐县",
        "text": "昌乐县"
      }, {
        "id": "1418-6a",
        "value": "青州市",
        "text": "青州市"
      }, {
        "id": "1419-rQ",
        "value": "诸城市",
        "text": "诸城市"
      }, {
        "id": "1420-Mp",
        "value": "寿光市",
        "text": "寿光市"
      }, {
        "id": "1421-yZ",
        "value": "安丘市",
        "text": "安丘市"
      }, {
        "id": "1422-QF",
        "value": "高密市",
        "text": "高密市"
      }, {
        "id": "1423-cg",
        "value": "昌邑市",
        "text": "昌邑市"
      } ],
      "id": "1411-Bj",
      "value": "潍坊市",
      "text": "潍坊市"
    }, {
      "children": [ {
        "id": "1425-c0",
        "value": "任城区",
        "text": "任城区"
      }, {
        "id": "1426-fA",
        "value": "兖州区",
        "text": "兖州区"
      }, {
        "id": "1427-3O",
        "value": "微山县",
        "text": "微山县"
      }, {
        "id": "1428-LO",
        "value": "鱼台县",
        "text": "鱼台县"
      }, {
        "id": "1429-eA",
        "value": "金乡县",
        "text": "金乡县"
      }, {
        "id": "1430-c8",
        "value": "嘉祥县",
        "text": "嘉祥县"
      }, {
        "id": "1431-Gx",
        "value": "汶上县",
        "text": "汶上县"
      }, {
        "id": "1432-a0",
        "value": "泗水县",
        "text": "泗水县"
      }, {
        "id": "1433-na",
        "value": "梁山县",
        "text": "梁山县"
      }, {
        "id": "1434-Qk",
        "value": "曲阜市",
        "text": "曲阜市"
      }, {
        "id": "1435-sT",
        "value": "邹城市",
        "text": "邹城市"
      } ],
      "id": "1424-5V",
      "value": "济宁市",
      "text": "济宁市"
    }, {
      "children": [ {
        "id": "1437-Rg",
        "value": "泰山区",
        "text": "泰山区"
      }, {
        "id": "1438-Pz",
        "value": "岱岳区",
        "text": "岱岳区"
      }, {
        "id": "1439-fk",
        "value": "宁阳县",
        "text": "宁阳县"
      }, {
        "id": "1440-FT",
        "value": "东平县",
        "text": "东平县"
      }, {
        "id": "1441-4r",
        "value": "新泰市",
        "text": "新泰市"
      }, {
        "id": "1442-HP",
        "value": "肥城市",
        "text": "肥城市"
      } ],
      "id": "1436-mg",
      "value": "泰安市",
      "text": "泰安市"
    }, {
      "children": [ {
        "id": "1444-xz",
        "value": "环翠区",
        "text": "环翠区"
      }, {
        "id": "1445-Jb",
        "value": "文登区",
        "text": "文登区"
      }, {
        "id": "1446-sU",
        "value": "荣成市",
        "text": "荣成市"
      }, {
        "id": "1447-wN",
        "value": "乳山市",
        "text": "乳山市"
      } ],
      "id": "1443-Kb",
      "value": "威海市",
      "text": "威海市"
    }, {
      "children": [ {
        "id": "1449-6w",
        "value": "东港区",
        "text": "东港区"
      }, {
        "id": "1450-s4",
        "value": "岚山区",
        "text": "岚山区"
      }, {
        "id": "1451-7r",
        "value": "五莲县",
        "text": "五莲县"
      }, {
        "id": "1452-5S",
        "value": "莒县",
        "text": "莒县"
      } ],
      "id": "1448-li",
      "value": "日照市",
      "text": "日照市"
    }, {
      "children": [ {
        "id": "1454-xj",
        "value": "莱城区",
        "text": "莱城区"
      }, {
        "id": "1455-No",
        "value": "钢城区",
        "text": "钢城区"
      } ],
      "id": "1453-C2",
      "value": "莱芜市",
      "text": "莱芜市"
    }, {
      "children": [ {
        "id": "1457-DK",
        "value": "兰山区",
        "text": "兰山区"
      }, {
        "id": "1458-Kt",
        "value": "罗庄区",
        "text": "罗庄区"
      }, {
        "id": "1459-J5",
        "value": "河东区",
        "text": "河东区"
      }, {
        "id": "1460-eT",
        "value": "沂南县",
        "text": "沂南县"
      }, {
        "id": "1461-N0",
        "value": "郯城县",
        "text": "郯城县"
      }, {
        "id": "1462-KN",
        "value": "沂水县",
        "text": "沂水县"
      }, {
        "id": "1463-qi",
        "value": "兰陵县",
        "text": "兰陵县"
      }, {
        "id": "1464-tn",
        "value": "费县",
        "text": "费县"
      }, {
        "id": "1465-Eq",
        "value": "平邑县",
        "text": "平邑县"
      }, {
        "id": "1466-u4",
        "value": "莒南县",
        "text": "莒南县"
      }, {
        "id": "1467-Oa",
        "value": "蒙阴县",
        "text": "蒙阴县"
      }, {
        "id": "1468-Pw",
        "value": "临沭县",
        "text": "临沭县"
      } ],
      "id": "1456-kA",
      "value": "临沂市",
      "text": "临沂市"
    }, {
      "children": [ {
        "id": "1470-T4",
        "value": "德城区",
        "text": "德城区"
      }, {
        "id": "1471-lx",
        "value": "陵城区",
        "text": "陵城区"
      }, {
        "id": "1472-Jm",
        "value": "宁津县",
        "text": "宁津县"
      }, {
        "id": "1473-Sc",
        "value": "庆云县",
        "text": "庆云县"
      }, {
        "id": "1474-ih",
        "value": "临邑县",
        "text": "临邑县"
      }, {
        "id": "1475-FG",
        "value": "齐河县",
        "text": "齐河县"
      }, {
        "id": "1476-zs",
        "value": "平原县",
        "text": "平原县"
      }, {
        "id": "1477-hK",
        "value": "夏津县",
        "text": "夏津县"
      }, {
        "id": "1478-X6",
        "value": "武城县",
        "text": "武城县"
      }, {
        "id": "1479-KT",
        "value": "乐陵市",
        "text": "乐陵市"
      }, {
        "id": "1480-rP",
        "value": "禹城市",
        "text": "禹城市"
      } ],
      "id": "1469-ve",
      "value": "德州市",
      "text": "德州市"
    }, {
      "children": [ {
        "id": "1482-xT",
        "value": "东昌府区",
        "text": "东昌府区"
      }, {
        "id": "1483-Qi",
        "value": "阳谷县",
        "text": "阳谷县"
      }, {
        "id": "1484-BL",
        "value": "莘县",
        "text": "莘县"
      }, {
        "id": "1485-72",
        "value": "茌平县",
        "text": "茌平县"
      }, {
        "id": "1486-d4",
        "value": "东阿县",
        "text": "东阿县"
      }, {
        "id": "1487-k8",
        "value": "冠县",
        "text": "冠县"
      }, {
        "id": "1488-pD",
        "value": "高唐县",
        "text": "高唐县"
      }, {
        "id": "1489-lw",
        "value": "临清市",
        "text": "临清市"
      } ],
      "id": "1481-8B",
      "value": "聊城市",
      "text": "聊城市"
    }, {
      "children": [ {
        "id": "1491-ID",
        "value": "滨城区",
        "text": "滨城区"
      }, {
        "id": "1492-8P",
        "value": "沾化区",
        "text": "沾化区"
      }, {
        "id": "1493-oB",
        "value": "惠民县",
        "text": "惠民县"
      }, {
        "id": "1494-wk",
        "value": "阳信县",
        "text": "阳信县"
      }, {
        "id": "1495-cw",
        "value": "无棣县",
        "text": "无棣县"
      }, {
        "id": "1496-Tp",
        "value": "博兴县",
        "text": "博兴县"
      }, {
        "id": "1497-fb",
        "value": "邹平县",
        "text": "邹平县"
      } ],
      "id": "1490-Az",
      "value": "滨州市",
      "text": "滨州市"
    }, {
      "children": [ {
        "id": "1499-hu",
        "value": "牡丹区",
        "text": "牡丹区"
      }, {
        "id": "1500-TE",
        "value": "定陶区",
        "text": "定陶区"
      }, {
        "id": "1501-0s",
        "value": "曹县",
        "text": "曹县"
      }, {
        "id": "1502-vP",
        "value": "单县",
        "text": "单县"
      }, {
        "id": "1503-xO",
        "value": "成武县",
        "text": "成武县"
      }, {
        "id": "1504-Bd",
        "value": "巨野县",
        "text": "巨野县"
      }, {
        "id": "1505-Lw",
        "value": "郓城县",
        "text": "郓城县"
      }, {
        "id": "1506-D4",
        "value": "鄄城县",
        "text": "鄄城县"
      }, {
        "id": "1507-uU",
        "value": "东明县",
        "text": "东明县"
      } ],
      "id": "1498-YS",
      "value": "菏泽市",
      "text": "菏泽市"
    } ],
    "id": "1353-9n",
    "value": "山东省",
    "text": "山东省"
  }, {
    "children": [ {
      "children": [ {
        "id": "1510-ae",
        "value": "中原区",
        "text": "中原区"
      }, {
        "id": "1511-fQ",
        "value": "二七区",
        "text": "二七区"
      }, {
        "id": "1512-Ie",
        "value": "管城回族区",
        "text": "管城回族区"
      }, {
        "id": "1513-OB",
        "value": "金水区",
        "text": "金水区"
      }, {
        "id": "1514-2g",
        "value": "上街区",
        "text": "上街区"
      }, {
        "id": "1515-zm",
        "value": "惠济区",
        "text": "惠济区"
      }, {
        "id": "1516-Jg",
        "value": "中牟县",
        "text": "中牟县"
      }, {
        "id": "1517-CK",
        "value": "巩义市",
        "text": "巩义市"
      }, {
        "id": "1518-v2",
        "value": "荥阳市",
        "text": "荥阳市"
      }, {
        "id": "1519-hR",
        "value": "新密市",
        "text": "新密市"
      }, {
        "id": "1520-23",
        "value": "新郑市",
        "text": "新郑市"
      }, {
        "id": "1521-bV",
        "value": "登封市",
        "text": "登封市"
      } ],
      "id": "1509-ms",
      "value": "郑州市",
      "text": "郑州市"
    }, {
      "children": [ {
        "id": "1523-Jr",
        "value": "龙亭区",
        "text": "龙亭区"
      }, {
        "id": "1524-X1",
        "value": "顺河回族区",
        "text": "顺河回族区"
      }, {
        "id": "1525-eS",
        "value": "鼓楼区",
        "text": "鼓楼区"
      }, {
        "id": "1526-n2",
        "value": "禹王台区",
        "text": "禹王台区"
      }, {
        "id": "1527-IR",
        "value": "金明区",
        "text": "金明区"
      }, {
        "id": "1528-4o",
        "value": "祥符区",
        "text": "祥符区"
      }, {
        "id": "1529-Qc",
        "value": "杞县",
        "text": "杞县"
      }, {
        "id": "1530-7M",
        "value": "通许县",
        "text": "通许县"
      }, {
        "id": "1531-JM",
        "value": "尉氏县",
        "text": "尉氏县"
      }, {
        "id": "1532-XM",
        "value": "兰考县",
        "text": "兰考县"
      } ],
      "id": "1522-UG",
      "value": "开封市",
      "text": "开封市"
    }, {
      "children": [ {
        "id": "1534-VA",
        "value": "老城区",
        "text": "老城区"
      }, {
        "id": "1535-9U",
        "value": "西工区",
        "text": "西工区"
      }, {
        "id": "1536-QK",
        "value": "瀍河回族区",
        "text": "瀍河回族区"
      }, {
        "id": "1537-Lv",
        "value": "涧西区",
        "text": "涧西区"
      }, {
        "id": "1538-Uz",
        "value": "吉利区",
        "text": "吉利区"
      }, {
        "id": "1539-Ot",
        "value": "洛龙区",
        "text": "洛龙区"
      }, {
        "id": "1540-Qh",
        "value": "孟津县",
        "text": "孟津县"
      }, {
        "id": "1541-ct",
        "value": "新安县",
        "text": "新安县"
      }, {
        "id": "1542-MP",
        "value": "栾川县",
        "text": "栾川县"
      }, {
        "id": "1543-OX",
        "value": "嵩县",
        "text": "嵩县"
      }, {
        "id": "1544-sM",
        "value": "汝阳县",
        "text": "汝阳县"
      }, {
        "id": "1545-W9",
        "value": "宜阳县",
        "text": "宜阳县"
      }, {
        "id": "1546-Ks",
        "value": "洛宁县",
        "text": "洛宁县"
      }, {
        "id": "1547-Am",
        "value": "伊川县",
        "text": "伊川县"
      }, {
        "id": "1548-zj",
        "value": "偃师市",
        "text": "偃师市"
      } ],
      "id": "1533-tO",
      "value": "洛阳市",
      "text": "洛阳市"
    }, {
      "children": [ {
        "id": "1550-h1",
        "value": "新华区",
        "text": "新华区"
      }, {
        "id": "1551-Ks",
        "value": "卫东区",
        "text": "卫东区"
      }, {
        "id": "1552-Lo",
        "value": "石龙区",
        "text": "石龙区"
      }, {
        "id": "1553-zc",
        "value": "湛河区",
        "text": "湛河区"
      }, {
        "id": "1554-FM",
        "value": "宝丰县",
        "text": "宝丰县"
      }, {
        "id": "1555-Ly",
        "value": "叶县",
        "text": "叶县"
      }, {
        "id": "1556-dl",
        "value": "鲁山县",
        "text": "鲁山县"
      }, {
        "id": "1557-i5",
        "value": "郏县",
        "text": "郏县"
      }, {
        "id": "1558-jj",
        "value": "舞钢市",
        "text": "舞钢市"
      }, {
        "id": "1559-yx",
        "value": "汝州市",
        "text": "汝州市"
      } ],
      "id": "1549-v7",
      "value": "平顶山市",
      "text": "平顶山市"
    }, {
      "children": [ {
        "id": "1561-SC",
        "value": "文峰区",
        "text": "文峰区"
      }, {
        "id": "1562-TM",
        "value": "北关区",
        "text": "北关区"
      }, {
        "id": "1563-bs",
        "value": "殷都区",
        "text": "殷都区"
      }, {
        "id": "1564-OB",
        "value": "龙安区",
        "text": "龙安区"
      }, {
        "id": "1565-UX",
        "value": "安阳县",
        "text": "安阳县"
      }, {
        "id": "1566-a8",
        "value": "汤阴县",
        "text": "汤阴县"
      }, {
        "id": "1567-IK",
        "value": "滑县",
        "text": "滑县"
      }, {
        "id": "1568-gb",
        "value": "内黄县",
        "text": "内黄县"
      }, {
        "id": "1569-LZ",
        "value": "林州市",
        "text": "林州市"
      } ],
      "id": "1560-op",
      "value": "安阳市",
      "text": "安阳市"
    }, {
      "children": [ {
        "id": "1571-Nk",
        "value": "鹤山区",
        "text": "鹤山区"
      }, {
        "id": "1572-ST",
        "value": "山城区",
        "text": "山城区"
      }, {
        "id": "1573-j8",
        "value": "淇滨区",
        "text": "淇滨区"
      }, {
        "id": "1574-Mj",
        "value": "浚县",
        "text": "浚县"
      }, {
        "id": "1575-Lt",
        "value": "淇县",
        "text": "淇县"
      } ],
      "id": "1570-98",
      "value": "鹤壁市",
      "text": "鹤壁市"
    }, {
      "children": [ {
        "id": "1577-rB",
        "value": "红旗区",
        "text": "红旗区"
      }, {
        "id": "1578-Zd",
        "value": "卫滨区",
        "text": "卫滨区"
      }, {
        "id": "1579-Iv",
        "value": "凤泉区",
        "text": "凤泉区"
      }, {
        "id": "1580-BF",
        "value": "牧野区",
        "text": "牧野区"
      }, {
        "id": "1581-Yh",
        "value": "新乡县",
        "text": "新乡县"
      }, {
        "id": "1582-ub",
        "value": "获嘉县",
        "text": "获嘉县"
      }, {
        "id": "1583-eA",
        "value": "原阳县",
        "text": "原阳县"
      }, {
        "id": "1584-lV",
        "value": "延津县",
        "text": "延津县"
      }, {
        "id": "1585-jy",
        "value": "封丘县",
        "text": "封丘县"
      }, {
        "id": "1586-dH",
        "value": "长垣县",
        "text": "长垣县"
      }, {
        "id": "1587-JT",
        "value": "卫辉市",
        "text": "卫辉市"
      }, {
        "id": "1588-1H",
        "value": "辉县市",
        "text": "辉县市"
      } ],
      "id": "1576-OI",
      "value": "新乡市",
      "text": "新乡市"
    }, {
      "children": [ {
        "id": "1590-7v",
        "value": "解放区",
        "text": "解放区"
      }, {
        "id": "1591-JF",
        "value": "中站区",
        "text": "中站区"
      }, {
        "id": "1592-0X",
        "value": "马村区",
        "text": "马村区"
      }, {
        "id": "1593-vZ",
        "value": "山阳区",
        "text": "山阳区"
      }, {
        "id": "1594-2Q",
        "value": "修武县",
        "text": "修武县"
      }, {
        "id": "1595-wJ",
        "value": "博爱县",
        "text": "博爱县"
      }, {
        "id": "1596-Fw",
        "value": "武陟县",
        "text": "武陟县"
      }, {
        "id": "1597-fk",
        "value": "温县",
        "text": "温县"
      }, {
        "id": "1598-0V",
        "value": "沁阳市",
        "text": "沁阳市"
      }, {
        "id": "1599-6F",
        "value": "孟州市",
        "text": "孟州市"
      } ],
      "id": "1589-mX",
      "value": "焦作市",
      "text": "焦作市"
    }, {
      "children": [ {
        "id": "1601-qv",
        "value": "华龙区",
        "text": "华龙区"
      }, {
        "id": "1602-K8",
        "value": "清丰县",
        "text": "清丰县"
      }, {
        "id": "1603-MD",
        "value": "南乐县",
        "text": "南乐县"
      }, {
        "id": "1604-6N",
        "value": "范县",
        "text": "范县"
      }, {
        "id": "1605-f8",
        "value": "台前县",
        "text": "台前县"
      }, {
        "id": "1606-T1",
        "value": "濮阳县",
        "text": "濮阳县"
      } ],
      "id": "1600-Ln",
      "value": "濮阳市",
      "text": "濮阳市"
    }, {
      "children": [ {
        "id": "1608-vR",
        "value": "魏都区",
        "text": "魏都区"
      }, {
        "id": "1609-Hx",
        "value": "许昌县",
        "text": "许昌县"
      }, {
        "id": "1610-XK",
        "value": "鄢陵县",
        "text": "鄢陵县"
      }, {
        "id": "1611-0n",
        "value": "襄城县",
        "text": "襄城县"
      }, {
        "id": "1612-oV",
        "value": "禹州市",
        "text": "禹州市"
      }, {
        "id": "1613-Qo",
        "value": "长葛市",
        "text": "长葛市"
      } ],
      "id": "1607-n0",
      "value": "许昌市",
      "text": "许昌市"
    }, {
      "children": [ {
        "id": "1615-ol",
        "value": "源汇区",
        "text": "源汇区"
      }, {
        "id": "1616-o4",
        "value": "郾城区",
        "text": "郾城区"
      }, {
        "id": "1617-cG",
        "value": "召陵区",
        "text": "召陵区"
      }, {
        "id": "1618-1e",
        "value": "舞阳县",
        "text": "舞阳县"
      }, {
        "id": "1619-Bk",
        "value": "临颍县",
        "text": "临颍县"
      } ],
      "id": "1614-BR",
      "value": "漯河市",
      "text": "漯河市"
    }, {
      "children": [ {
        "id": "1621-pL",
        "value": "湖滨区",
        "text": "湖滨区"
      }, {
        "id": "1622-zv",
        "value": "陕州区",
        "text": "陕州区"
      }, {
        "id": "1623-Xr",
        "value": "渑池县",
        "text": "渑池县"
      }, {
        "id": "1624-7O",
        "value": "卢氏县",
        "text": "卢氏县"
      }, {
        "id": "1625-AA",
        "value": "义马市",
        "text": "义马市"
      }, {
        "id": "1626-Ts",
        "value": "灵宝市",
        "text": "灵宝市"
      } ],
      "id": "1620-hu",
      "value": "三门峡市",
      "text": "三门峡市"
    }, {
      "children": [ {
        "id": "1628-Wk",
        "value": "宛城区",
        "text": "宛城区"
      }, {
        "id": "1629-im",
        "value": "卧龙区",
        "text": "卧龙区"
      }, {
        "id": "1630-Tw",
        "value": "南召县",
        "text": "南召县"
      }, {
        "id": "1631-Fa",
        "value": "方城县",
        "text": "方城县"
      }, {
        "id": "1632-Yi",
        "value": "西峡县",
        "text": "西峡县"
      }, {
        "id": "1633-gy",
        "value": "镇平县",
        "text": "镇平县"
      }, {
        "id": "1634-p7",
        "value": "内乡县",
        "text": "内乡县"
      }, {
        "id": "1635-cg",
        "value": "淅川县",
        "text": "淅川县"
      }, {
        "id": "1636-WW",
        "value": "社旗县",
        "text": "社旗县"
      }, {
        "id": "1637-4G",
        "value": "唐河县",
        "text": "唐河县"
      }, {
        "id": "1638-t4",
        "value": "新野县",
        "text": "新野县"
      }, {
        "id": "1639-nd",
        "value": "桐柏县",
        "text": "桐柏县"
      }, {
        "id": "1640-DB",
        "value": "邓州市",
        "text": "邓州市"
      } ],
      "id": "1627-7j",
      "value": "南阳市",
      "text": "南阳市"
    }, {
      "children": [ {
        "id": "1642-w6",
        "value": "梁园区",
        "text": "梁园区"
      }, {
        "id": "1643-9D",
        "value": "睢阳区",
        "text": "睢阳区"
      }, {
        "id": "1644-rq",
        "value": "民权县",
        "text": "民权县"
      }, {
        "id": "1645-oS",
        "value": "睢县",
        "text": "睢县"
      }, {
        "id": "1646-UD",
        "value": "宁陵县",
        "text": "宁陵县"
      }, {
        "id": "1647-Ll",
        "value": "柘城县",
        "text": "柘城县"
      }, {
        "id": "1648-08",
        "value": "虞城县",
        "text": "虞城县"
      }, {
        "id": "1649-YU",
        "value": "夏邑县",
        "text": "夏邑县"
      }, {
        "id": "1650-OO",
        "value": "永城市",
        "text": "永城市"
      } ],
      "id": "1641-81",
      "value": "商丘市",
      "text": "商丘市"
    }, {
      "children": [ {
        "id": "1652-Dv",
        "value": "浉河区",
        "text": "浉河区"
      }, {
        "id": "1653-nI",
        "value": "平桥区",
        "text": "平桥区"
      }, {
        "id": "1654-vU",
        "value": "罗山县",
        "text": "罗山县"
      }, {
        "id": "1655-gD",
        "value": "光山县",
        "text": "光山县"
      }, {
        "id": "1656-Cq",
        "value": "新县",
        "text": "新县"
      }, {
        "id": "1657-36",
        "value": "商城县",
        "text": "商城县"
      }, {
        "id": "1658-9X",
        "value": "固始县",
        "text": "固始县"
      }, {
        "id": "1659-RA",
        "value": "潢川县",
        "text": "潢川县"
      }, {
        "id": "1660-W8",
        "value": "淮滨县",
        "text": "淮滨县"
      }, {
        "id": "1661-MW",
        "value": "息县",
        "text": "息县"
      } ],
      "id": "1651-4e",
      "value": "信阳市",
      "text": "信阳市"
    }, {
      "children": [ {
        "id": "1663-Xm",
        "value": "川汇区",
        "text": "川汇区"
      }, {
        "id": "1664-Dp",
        "value": "扶沟县",
        "text": "扶沟县"
      }, {
        "id": "1665-5P",
        "value": "西华县",
        "text": "西华县"
      }, {
        "id": "1666-t3",
        "value": "商水县",
        "text": "商水县"
      }, {
        "id": "1667-98",
        "value": "沈丘县",
        "text": "沈丘县"
      }, {
        "id": "1668-Yd",
        "value": "郸城县",
        "text": "郸城县"
      }, {
        "id": "1669-c7",
        "value": "淮阳县",
        "text": "淮阳县"
      }, {
        "id": "1670-s1",
        "value": "太康县",
        "text": "太康县"
      }, {
        "id": "1671-hx",
        "value": "鹿邑县",
        "text": "鹿邑县"
      }, {
        "id": "1672-8p",
        "value": "项城市",
        "text": "项城市"
      } ],
      "id": "1662-5E",
      "value": "周口市",
      "text": "周口市"
    }, {
      "children": [ {
        "id": "1674-Sk",
        "value": "驿城区",
        "text": "驿城区"
      }, {
        "id": "1675-T1",
        "value": "西平县",
        "text": "西平县"
      }, {
        "id": "1676-dL",
        "value": "上蔡县",
        "text": "上蔡县"
      }, {
        "id": "1677-aG",
        "value": "平舆县",
        "text": "平舆县"
      }, {
        "id": "1678-Z8",
        "value": "正阳县",
        "text": "正阳县"
      }, {
        "id": "1679-IP",
        "value": "确山县",
        "text": "确山县"
      }, {
        "id": "1680-lv",
        "value": "泌阳县",
        "text": "泌阳县"
      }, {
        "id": "1681-7i",
        "value": "汝南县",
        "text": "汝南县"
      }, {
        "id": "1682-J6",
        "value": "遂平县",
        "text": "遂平县"
      }, {
        "id": "1683-1s",
        "value": "新蔡县",
        "text": "新蔡县"
      } ],
      "id": "1673-BU",
      "value": "驻马店市",
      "text": "驻马店市"
    }, {
      "children": [ {
        "id": "1685-44",
        "value": "济源市",
        "text": "济源市"
      } ],
      "id": "1684-mB",
      "value": "省直辖县级行政区划",
      "text": "省直辖县级行政区划"
    } ],
    "id": "1508-ti",
    "value": "河南省",
    "text": "河南省"
  }, {
    "children": [ {
      "children": [ {
        "id": "1688-g4",
        "value": "江岸区",
        "text": "江岸区"
      }, {
        "id": "1689-k4",
        "value": "江汉区",
        "text": "江汉区"
      }, {
        "id": "1690-jD",
        "value": "硚口区",
        "text": "硚口区"
      }, {
        "id": "1691-Nc",
        "value": "汉阳区",
        "text": "汉阳区"
      }, {
        "id": "1692-9L",
        "value": "武昌区",
        "text": "武昌区"
      }, {
        "id": "1693-BZ",
        "value": "青山区",
        "text": "青山区"
      }, {
        "id": "1694-Fe",
        "value": "洪山区",
        "text": "洪山区"
      }, {
        "id": "1695-33",
        "value": "东西湖区",
        "text": "东西湖区"
      }, {
        "id": "1696-k9",
        "value": "汉南区",
        "text": "汉南区"
      }, {
        "id": "1697-TX",
        "value": "蔡甸区",
        "text": "蔡甸区"
      }, {
        "id": "1698-5N",
        "value": "江夏区",
        "text": "江夏区"
      }, {
        "id": "1699-EI",
        "value": "黄陂区",
        "text": "黄陂区"
      }, {
        "id": "1700-Oe",
        "value": "新洲区",
        "text": "新洲区"
      } ],
      "id": "1687-CD",
      "value": "武汉市",
      "text": "武汉市"
    }, {
      "children": [ {
        "id": "1702-2T",
        "value": "黄石港区",
        "text": "黄石港区"
      }, {
        "id": "1703-cA",
        "value": "西塞山区",
        "text": "西塞山区"
      }, {
        "id": "1704-5c",
        "value": "下陆区",
        "text": "下陆区"
      }, {
        "id": "1705-NG",
        "value": "铁山区",
        "text": "铁山区"
      }, {
        "id": "1706-7r",
        "value": "阳新县",
        "text": "阳新县"
      }, {
        "id": "1707-vP",
        "value": "大冶市",
        "text": "大冶市"
      } ],
      "id": "1701-s5",
      "value": "黄石市",
      "text": "黄石市"
    }, {
      "children": [ {
        "id": "1709-IK",
        "value": "茅箭区",
        "text": "茅箭区"
      }, {
        "id": "1710-5U",
        "value": "张湾区",
        "text": "张湾区"
      }, {
        "id": "1711-ds",
        "value": "郧阳区",
        "text": "郧阳区"
      }, {
        "id": "1712-PD",
        "value": "郧西县",
        "text": "郧西县"
      }, {
        "id": "1713-B6",
        "value": "竹山县",
        "text": "竹山县"
      }, {
        "id": "1714-ll",
        "value": "竹溪县",
        "text": "竹溪县"
      }, {
        "id": "1715-5X",
        "value": "房县",
        "text": "房县"
      }, {
        "id": "1716-b9",
        "value": "丹江口市",
        "text": "丹江口市"
      } ],
      "id": "1708-DK",
      "value": "十堰市",
      "text": "十堰市"
    }, {
      "children": [ {
        "id": "1718-Zf",
        "value": "西陵区",
        "text": "西陵区"
      }, {
        "id": "1719-Yd",
        "value": "伍家岗区",
        "text": "伍家岗区"
      }, {
        "id": "1720-QP",
        "value": "点军区",
        "text": "点军区"
      }, {
        "id": "1721-iV",
        "value": "猇亭区",
        "text": "猇亭区"
      }, {
        "id": "1722-5k",
        "value": "夷陵区",
        "text": "夷陵区"
      }, {
        "id": "1723-OY",
        "value": "远安县",
        "text": "远安县"
      }, {
        "id": "1724-td",
        "value": "兴山县",
        "text": "兴山县"
      }, {
        "id": "1725-Mc",
        "value": "秭归县",
        "text": "秭归县"
      }, {
        "id": "1726-JU",
        "value": "长阳土家族自治县",
        "text": "长阳土家族自治县"
      }, {
        "id": "1727-ei",
        "value": "五峰土家族自治县",
        "text": "五峰土家族自治县"
      }, {
        "id": "1728-oP",
        "value": "宜都市",
        "text": "宜都市"
      }, {
        "id": "1729-bg",
        "value": "当阳市",
        "text": "当阳市"
      }, {
        "id": "1730-41",
        "value": "枝江市",
        "text": "枝江市"
      } ],
      "id": "1717-ig",
      "value": "宜昌市",
      "text": "宜昌市"
    }, {
      "children": [ {
        "id": "1732-61",
        "value": "襄城区",
        "text": "襄城区"
      }, {
        "id": "1733-XK",
        "value": "樊城区",
        "text": "樊城区"
      }, {
        "id": "1734-4J",
        "value": "襄州区",
        "text": "襄州区"
      }, {
        "id": "1735-II",
        "value": "南漳县",
        "text": "南漳县"
      }, {
        "id": "1736-bI",
        "value": "谷城县",
        "text": "谷城县"
      }, {
        "id": "1737-1t",
        "value": "保康县",
        "text": "保康县"
      }, {
        "id": "1738-1n",
        "value": "老河口市",
        "text": "老河口市"
      }, {
        "id": "1739-qL",
        "value": "枣阳市",
        "text": "枣阳市"
      }, {
        "id": "1740-lo",
        "value": "宜城市",
        "text": "宜城市"
      } ],
      "id": "1731-Kj",
      "value": "襄阳市",
      "text": "襄阳市"
    }, {
      "children": [ {
        "id": "1742-qV",
        "value": "梁子湖区",
        "text": "梁子湖区"
      }, {
        "id": "1743-78",
        "value": "华容区",
        "text": "华容区"
      }, {
        "id": "1744-zH",
        "value": "鄂城区",
        "text": "鄂城区"
      } ],
      "id": "1741-LK",
      "value": "鄂州市",
      "text": "鄂州市"
    }, {
      "children": [ {
        "id": "1746-Ls",
        "value": "东宝区",
        "text": "东宝区"
      }, {
        "id": "1747-v5",
        "value": "掇刀区",
        "text": "掇刀区"
      }, {
        "id": "1748-JA",
        "value": "京山县",
        "text": "京山县"
      }, {
        "id": "1749-I8",
        "value": "沙洋县",
        "text": "沙洋县"
      }, {
        "id": "1750-TP",
        "value": "钟祥市",
        "text": "钟祥市"
      } ],
      "id": "1745-z4",
      "value": "荆门市",
      "text": "荆门市"
    }, {
      "children": [ {
        "id": "1752-Wq",
        "value": "孝南区",
        "text": "孝南区"
      }, {
        "id": "1753-TK",
        "value": "孝昌县",
        "text": "孝昌县"
      }, {
        "id": "1754-gG",
        "value": "大悟县",
        "text": "大悟县"
      }, {
        "id": "1755-vQ",
        "value": "云梦县",
        "text": "云梦县"
      }, {
        "id": "1756-7y",
        "value": "应城市",
        "text": "应城市"
      }, {
        "id": "1757-t7",
        "value": "安陆市",
        "text": "安陆市"
      }, {
        "id": "1758-0k",
        "value": "汉川市",
        "text": "汉川市"
      } ],
      "id": "1751-cY",
      "value": "孝感市",
      "text": "孝感市"
    }, {
      "children": [ {
        "id": "1760-T9",
        "value": "沙市区",
        "text": "沙市区"
      }, {
        "id": "1761-1a",
        "value": "荆州区",
        "text": "荆州区"
      }, {
        "id": "1762-3J",
        "value": "公安县",
        "text": "公安县"
      }, {
        "id": "1763-Gx",
        "value": "监利县",
        "text": "监利县"
      }, {
        "id": "1764-Yb",
        "value": "江陵县",
        "text": "江陵县"
      }, {
        "id": "1765-2L",
        "value": "石首市",
        "text": "石首市"
      }, {
        "id": "1766-6O",
        "value": "洪湖市",
        "text": "洪湖市"
      }, {
        "id": "1767-sX",
        "value": "松滋市",
        "text": "松滋市"
      } ],
      "id": "1759-UN",
      "value": "荆州市",
      "text": "荆州市"
    }, {
      "children": [ {
        "id": "1769-tM",
        "value": "黄州区",
        "text": "黄州区"
      }, {
        "id": "1770-eR",
        "value": "团风县",
        "text": "团风县"
      }, {
        "id": "1771-T3",
        "value": "红安县",
        "text": "红安县"
      }, {
        "id": "1772-0S",
        "value": "罗田县",
        "text": "罗田县"
      }, {
        "id": "1773-oA",
        "value": "英山县",
        "text": "英山县"
      }, {
        "id": "1774-9B",
        "value": "浠水县",
        "text": "浠水县"
      }, {
        "id": "1775-XQ",
        "value": "蕲春县",
        "text": "蕲春县"
      }, {
        "id": "1776-Os",
        "value": "黄梅县",
        "text": "黄梅县"
      }, {
        "id": "1777-aK",
        "value": "麻城市",
        "text": "麻城市"
      }, {
        "id": "1778-Zp",
        "value": "武穴市",
        "text": "武穴市"
      } ],
      "id": "1768-Cp",
      "value": "黄冈市",
      "text": "黄冈市"
    }, {
      "children": [ {
        "id": "1780-PH",
        "value": "咸安区",
        "text": "咸安区"
      }, {
        "id": "1781-9W",
        "value": "嘉鱼县",
        "text": "嘉鱼县"
      }, {
        "id": "1782-T7",
        "value": "通城县",
        "text": "通城县"
      }, {
        "id": "1783-Zu",
        "value": "崇阳县",
        "text": "崇阳县"
      }, {
        "id": "1784-04",
        "value": "通山县",
        "text": "通山县"
      }, {
        "id": "1785-GO",
        "value": "赤壁市",
        "text": "赤壁市"
      } ],
      "id": "1779-fx",
      "value": "咸宁市",
      "text": "咸宁市"
    }, {
      "children": [ {
        "id": "1787-0j",
        "value": "曾都区",
        "text": "曾都区"
      }, {
        "id": "1788-nI",
        "value": "随县",
        "text": "随县"
      }, {
        "id": "1789-It",
        "value": "广水市",
        "text": "广水市"
      } ],
      "id": "1786-pc",
      "value": "随州市",
      "text": "随州市"
    }, {
      "children": [ {
        "id": "1791-B4",
        "value": "恩施市",
        "text": "恩施市"
      }, {
        "id": "1792-ur",
        "value": "利川市",
        "text": "利川市"
      }, {
        "id": "1793-27",
        "value": "建始县",
        "text": "建始县"
      }, {
        "id": "1794-kI",
        "value": "巴东县",
        "text": "巴东县"
      }, {
        "id": "1795-B4",
        "value": "宣恩县",
        "text": "宣恩县"
      }, {
        "id": "1796-7v",
        "value": "咸丰县",
        "text": "咸丰县"
      }, {
        "id": "1797-6o",
        "value": "来凤县",
        "text": "来凤县"
      }, {
        "id": "1798-CN",
        "value": "鹤峰县",
        "text": "鹤峰县"
      } ],
      "id": "1790-x4",
      "value": "恩施土家族苗族自治州",
      "text": "恩施土家族苗族自治州"
    }, {
      "children": [ {
        "id": "1800-rm",
        "value": "仙桃市",
        "text": "仙桃市"
      }, {
        "id": "1801-zo",
        "value": "潜江市",
        "text": "潜江市"
      }, {
        "id": "1802-5l",
        "value": "天门市",
        "text": "天门市"
      }, {
        "id": "1803-E0",
        "value": "神农架林区",
        "text": "神农架林区"
      } ],
      "id": "1799-j9",
      "value": "省直辖县级行政区划",
      "text": "省直辖县级行政区划"
    } ],
    "id": "1686-Yu",
    "value": "湖北省",
    "text": "湖北省"
  }, {
    "children": [ {
      "children": [ {
        "id": "1806-hO",
        "value": "芙蓉区",
        "text": "芙蓉区"
      }, {
        "id": "1807-4z",
        "value": "天心区",
        "text": "天心区"
      }, {
        "id": "1808-JW",
        "value": "岳麓区",
        "text": "岳麓区"
      }, {
        "id": "1809-Zm",
        "value": "开福区",
        "text": "开福区"
      }, {
        "id": "1810-r9",
        "value": "雨花区",
        "text": "雨花区"
      }, {
        "id": "1811-xx",
        "value": "望城区",
        "text": "望城区"
      }, {
        "id": "1812-lS",
        "value": "长沙县",
        "text": "长沙县"
      }, {
        "id": "1813-gh",
        "value": "宁乡县",
        "text": "宁乡县"
      }, {
        "id": "1814-iu",
        "value": "浏阳市",
        "text": "浏阳市"
      } ],
      "id": "1805-r2",
      "value": "长沙市",
      "text": "长沙市"
    }, {
      "children": [ {
        "id": "1816-Qo",
        "value": "荷塘区",
        "text": "荷塘区"
      }, {
        "id": "1817-e5",
        "value": "芦淞区",
        "text": "芦淞区"
      }, {
        "id": "1818-Kw",
        "value": "石峰区",
        "text": "石峰区"
      }, {
        "id": "1819-2M",
        "value": "天元区",
        "text": "天元区"
      }, {
        "id": "1820-CT",
        "value": "株洲县",
        "text": "株洲县"
      }, {
        "id": "1821-4B",
        "value": "攸县",
        "text": "攸县"
      }, {
        "id": "1822-eQ",
        "value": "茶陵县",
        "text": "茶陵县"
      }, {
        "id": "1823-Zu",
        "value": "炎陵县",
        "text": "炎陵县"
      }, {
        "id": "1824-Lp",
        "value": "醴陵市",
        "text": "醴陵市"
      } ],
      "id": "1815-qM",
      "value": "株洲市",
      "text": "株洲市"
    }, {
      "children": [ {
        "id": "1826-2e",
        "value": "雨湖区",
        "text": "雨湖区"
      }, {
        "id": "1827-G9",
        "value": "岳塘区",
        "text": "岳塘区"
      }, {
        "id": "1828-dL",
        "value": "湘潭县",
        "text": "湘潭县"
      }, {
        "id": "1829-2m",
        "value": "湘乡市",
        "text": "湘乡市"
      }, {
        "id": "1830-ug",
        "value": "韶山市",
        "text": "韶山市"
      } ],
      "id": "1825-nw",
      "value": "湘潭市",
      "text": "湘潭市"
    }, {
      "children": [ {
        "id": "1832-nL",
        "value": "珠晖区",
        "text": "珠晖区"
      }, {
        "id": "1833-HZ",
        "value": "雁峰区",
        "text": "雁峰区"
      }, {
        "id": "1834-Ai",
        "value": "石鼓区",
        "text": "石鼓区"
      }, {
        "id": "1835-an",
        "value": "蒸湘区",
        "text": "蒸湘区"
      }, {
        "id": "1836-sv",
        "value": "南岳区",
        "text": "南岳区"
      }, {
        "id": "1837-T4",
        "value": "衡阳县",
        "text": "衡阳县"
      }, {
        "id": "1838-8b",
        "value": "衡南县",
        "text": "衡南县"
      }, {
        "id": "1839-0I",
        "value": "衡山县",
        "text": "衡山县"
      }, {
        "id": "1840-HJ",
        "value": "衡东县",
        "text": "衡东县"
      }, {
        "id": "1841-zC",
        "value": "祁东县",
        "text": "祁东县"
      }, {
        "id": "1842-xp",
        "value": "耒阳市",
        "text": "耒阳市"
      }, {
        "id": "1843-NX",
        "value": "常宁市",
        "text": "常宁市"
      } ],
      "id": "1831-kw",
      "value": "衡阳市",
      "text": "衡阳市"
    }, {
      "children": [ {
        "id": "1845-2x",
        "value": "双清区",
        "text": "双清区"
      }, {
        "id": "1846-Up",
        "value": "大祥区",
        "text": "大祥区"
      }, {
        "id": "1847-OA",
        "value": "北塔区",
        "text": "北塔区"
      }, {
        "id": "1848-ru",
        "value": "邵东县",
        "text": "邵东县"
      }, {
        "id": "1849-Mf",
        "value": "新邵县",
        "text": "新邵县"
      }, {
        "id": "1850-bf",
        "value": "邵阳县",
        "text": "邵阳县"
      }, {
        "id": "1851-Ax",
        "value": "隆回县",
        "text": "隆回县"
      }, {
        "id": "1852-eK",
        "value": "洞口县",
        "text": "洞口县"
      }, {
        "id": "1853-a6",
        "value": "绥宁县",
        "text": "绥宁县"
      }, {
        "id": "1854-bO",
        "value": "新宁县",
        "text": "新宁县"
      }, {
        "id": "1855-fG",
        "value": "城步苗族自治县",
        "text": "城步苗族自治县"
      }, {
        "id": "1856-2U",
        "value": "武冈市",
        "text": "武冈市"
      } ],
      "id": "1844-2g",
      "value": "邵阳市",
      "text": "邵阳市"
    }, {
      "children": [ {
        "id": "1858-Tt",
        "value": "岳阳楼区",
        "text": "岳阳楼区"
      }, {
        "id": "1859-wd",
        "value": "云溪区",
        "text": "云溪区"
      }, {
        "id": "1860-p6",
        "value": "君山区",
        "text": "君山区"
      }, {
        "id": "1861-Ac",
        "value": "岳阳县",
        "text": "岳阳县"
      }, {
        "id": "1862-7k",
        "value": "华容县",
        "text": "华容县"
      }, {
        "id": "1863-OT",
        "value": "湘阴县",
        "text": "湘阴县"
      }, {
        "id": "1864-lp",
        "value": "平江县",
        "text": "平江县"
      }, {
        "id": "1865-kL",
        "value": "汨罗市",
        "text": "汨罗市"
      }, {
        "id": "1866-wt",
        "value": "临湘市",
        "text": "临湘市"
      } ],
      "id": "1857-ae",
      "value": "岳阳市",
      "text": "岳阳市"
    }, {
      "children": [ {
        "id": "1868-ED",
        "value": "武陵区",
        "text": "武陵区"
      }, {
        "id": "1869-JE",
        "value": "鼎城区",
        "text": "鼎城区"
      }, {
        "id": "1870-Rp",
        "value": "安乡县",
        "text": "安乡县"
      }, {
        "id": "1871-L3",
        "value": "汉寿县",
        "text": "汉寿县"
      }, {
        "id": "1872-CN",
        "value": "澧县",
        "text": "澧县"
      }, {
        "id": "1873-fb",
        "value": "临澧县",
        "text": "临澧县"
      }, {
        "id": "1874-Ks",
        "value": "桃源县",
        "text": "桃源县"
      }, {
        "id": "1875-Aw",
        "value": "石门县",
        "text": "石门县"
      }, {
        "id": "1876-rI",
        "value": "津市市",
        "text": "津市市"
      } ],
      "id": "1867-vU",
      "value": "常德市",
      "text": "常德市"
    }, {
      "children": [ {
        "id": "1878-W2",
        "value": "永定区",
        "text": "永定区"
      }, {
        "id": "1879-jQ",
        "value": "武陵源区",
        "text": "武陵源区"
      }, {
        "id": "1880-ic",
        "value": "慈利县",
        "text": "慈利县"
      }, {
        "id": "1881-zj",
        "value": "桑植县",
        "text": "桑植县"
      } ],
      "id": "1877-Cb",
      "value": "张家界市",
      "text": "张家界市"
    }, {
      "children": [ {
        "id": "1883-6D",
        "value": "资阳区",
        "text": "资阳区"
      }, {
        "id": "1884-52",
        "value": "赫山区",
        "text": "赫山区"
      }, {
        "id": "1885-ix",
        "value": "南县",
        "text": "南县"
      }, {
        "id": "1886-Zs",
        "value": "桃江县",
        "text": "桃江县"
      }, {
        "id": "1887-gF",
        "value": "安化县",
        "text": "安化县"
      }, {
        "id": "1888-p4",
        "value": "沅江市",
        "text": "沅江市"
      } ],
      "id": "1882-AA",
      "value": "益阳市",
      "text": "益阳市"
    }, {
      "children": [ {
        "id": "1890-sj",
        "value": "北湖区",
        "text": "北湖区"
      }, {
        "id": "1891-hL",
        "value": "苏仙区",
        "text": "苏仙区"
      }, {
        "id": "1892-Ag",
        "value": "桂阳县",
        "text": "桂阳县"
      }, {
        "id": "1893-Ql",
        "value": "宜章县",
        "text": "宜章县"
      }, {
        "id": "1894-5D",
        "value": "永兴县",
        "text": "永兴县"
      }, {
        "id": "1895-GB",
        "value": "嘉禾县",
        "text": "嘉禾县"
      }, {
        "id": "1896-Ew",
        "value": "临武县",
        "text": "临武县"
      }, {
        "id": "1897-hS",
        "value": "汝城县",
        "text": "汝城县"
      }, {
        "id": "1898-Zn",
        "value": "桂东县",
        "text": "桂东县"
      }, {
        "id": "1899-WT",
        "value": "安仁县",
        "text": "安仁县"
      }, {
        "id": "1900-6T",
        "value": "资兴市",
        "text": "资兴市"
      } ],
      "id": "1889-iO",
      "value": "郴州市",
      "text": "郴州市"
    }, {
      "children": [ {
        "id": "1902-CQ",
        "value": "零陵区",
        "text": "零陵区"
      }, {
        "id": "1903-3G",
        "value": "冷水滩区",
        "text": "冷水滩区"
      }, {
        "id": "1904-T4",
        "value": "祁阳县",
        "text": "祁阳县"
      }, {
        "id": "1905-tQ",
        "value": "东安县",
        "text": "东安县"
      }, {
        "id": "1906-Ke",
        "value": "双牌县",
        "text": "双牌县"
      }, {
        "id": "1907-4u",
        "value": "道县",
        "text": "道县"
      }, {
        "id": "1908-KY",
        "value": "江永县",
        "text": "江永县"
      }, {
        "id": "1909-vC",
        "value": "宁远县",
        "text": "宁远县"
      }, {
        "id": "1910-Sv",
        "value": "蓝山县",
        "text": "蓝山县"
      }, {
        "id": "1911-b0",
        "value": "新田县",
        "text": "新田县"
      }, {
        "id": "1912-aR",
        "value": "江华瑶族自治县",
        "text": "江华瑶族自治县"
      } ],
      "id": "1901-Vc",
      "value": "永州市",
      "text": "永州市"
    }, {
      "children": [ {
        "id": "1914-ec",
        "value": "鹤城区",
        "text": "鹤城区"
      }, {
        "id": "1915-NH",
        "value": "中方县",
        "text": "中方县"
      }, {
        "id": "1916-0J",
        "value": "沅陵县",
        "text": "沅陵县"
      }, {
        "id": "1917-IY",
        "value": "辰溪县",
        "text": "辰溪县"
      }, {
        "id": "1918-2o",
        "value": "溆浦县",
        "text": "溆浦县"
      }, {
        "id": "1919-yG",
        "value": "会同县",
        "text": "会同县"
      }, {
        "id": "1920-JD",
        "value": "麻阳苗族自治县",
        "text": "麻阳苗族自治县"
      }, {
        "id": "1921-sb",
        "value": "新晃侗族自治县",
        "text": "新晃侗族自治县"
      }, {
        "id": "1922-IN",
        "value": "芷江侗族自治县",
        "text": "芷江侗族自治县"
      }, {
        "id": "1923-Vw",
        "value": "靖州苗族侗族自治县",
        "text": "靖州苗族侗族自治县"
      }, {
        "id": "1924-k5",
        "value": "通道侗族自治县",
        "text": "通道侗族自治县"
      }, {
        "id": "1925-ts",
        "value": "洪江市",
        "text": "洪江市"
      } ],
      "id": "1913-aG",
      "value": "怀化市",
      "text": "怀化市"
    }, {
      "children": [ {
        "id": "1927-ce",
        "value": "娄星区",
        "text": "娄星区"
      }, {
        "id": "1928-DW",
        "value": "双峰县",
        "text": "双峰县"
      }, {
        "id": "1929-nt",
        "value": "新化县",
        "text": "新化县"
      }, {
        "id": "1930-SH",
        "value": "冷水江市",
        "text": "冷水江市"
      }, {
        "id": "1931-HI",
        "value": "涟源市",
        "text": "涟源市"
      } ],
      "id": "1926-Sr",
      "value": "娄底市",
      "text": "娄底市"
    }, {
      "children": [ {
        "id": "1933-gC",
        "value": "吉首市",
        "text": "吉首市"
      }, {
        "id": "1934-Bk",
        "value": "泸溪县",
        "text": "泸溪县"
      }, {
        "id": "1935-TE",
        "value": "凤凰县",
        "text": "凤凰县"
      }, {
        "id": "1936-hm",
        "value": "花垣县",
        "text": "花垣县"
      }, {
        "id": "1937-IP",
        "value": "保靖县",
        "text": "保靖县"
      }, {
        "id": "1938-xD",
        "value": "古丈县",
        "text": "古丈县"
      }, {
        "id": "1939-GY",
        "value": "永顺县",
        "text": "永顺县"
      }, {
        "id": "1940-qD",
        "value": "龙山县",
        "text": "龙山县"
      } ],
      "id": "1932-AU",
      "value": "湘西土家族苗族自治州",
      "text": "湘西土家族苗族自治州"
    } ],
    "id": "1804-in",
    "value": "湖南省",
    "text": "湖南省"
  }, {
    "children": [ {
      "children": [ {
        "id": "1943-op",
        "value": "荔湾区",
        "text": "荔湾区"
      }, {
        "id": "1944-Bq",
        "value": "越秀区",
        "text": "越秀区"
      }, {
        "id": "1945-rX",
        "value": "海珠区",
        "text": "海珠区"
      }, {
        "id": "1946-Wz",
        "value": "天河区",
        "text": "天河区"
      }, {
        "id": "1947-tU",
        "value": "白云区",
        "text": "白云区"
      }, {
        "id": "1948-eD",
        "value": "黄埔区",
        "text": "黄埔区"
      }, {
        "id": "1949-Dl",
        "value": "番禺区",
        "text": "番禺区"
      }, {
        "id": "1950-pY",
        "value": "花都区",
        "text": "花都区"
      }, {
        "id": "1951-4c",
        "value": "南沙区",
        "text": "南沙区"
      }, {
        "id": "1952-jm",
        "value": "从化区",
        "text": "从化区"
      }, {
        "id": "1953-8t",
        "value": "增城区",
        "text": "增城区"
      } ],
      "id": "1942-j6",
      "value": "广州市",
      "text": "广州市"
    }, {
      "children": [ {
        "id": "1955-Wi",
        "value": "武江区",
        "text": "武江区"
      }, {
        "id": "1956-Za",
        "value": "浈江区",
        "text": "浈江区"
      }, {
        "id": "1957-zB",
        "value": "曲江区",
        "text": "曲江区"
      }, {
        "id": "1958-3J",
        "value": "始兴县",
        "text": "始兴县"
      }, {
        "id": "1959-Aq",
        "value": "仁化县",
        "text": "仁化县"
      }, {
        "id": "1960-qP",
        "value": "翁源县",
        "text": "翁源县"
      }, {
        "id": "1961-SB",
        "value": "乳源瑶族自治县",
        "text": "乳源瑶族自治县"
      }, {
        "id": "1962-om",
        "value": "新丰县",
        "text": "新丰县"
      }, {
        "id": "1963-ZA",
        "value": "乐昌市",
        "text": "乐昌市"
      }, {
        "id": "1964-PO",
        "value": "南雄市",
        "text": "南雄市"
      } ],
      "id": "1954-vw",
      "value": "韶关市",
      "text": "韶关市"
    }, {
      "children": [ {
        "id": "1966-GD",
        "value": "罗湖区",
        "text": "罗湖区"
      }, {
        "id": "1967-Cm",
        "value": "福田区",
        "text": "福田区"
      }, {
        "id": "1968-ty",
        "value": "南山区",
        "text": "南山区"
      }, {
        "id": "1969-ri",
        "value": "宝安区",
        "text": "宝安区"
      }, {
        "id": "1970-JH",
        "value": "龙岗区",
        "text": "龙岗区"
      }, {
        "id": "1971-l0",
        "value": "盐田区",
        "text": "盐田区"
      } ],
      "id": "1965-Z3",
      "value": "深圳市",
      "text": "深圳市"
    }, {
      "children": [ {
        "id": "1973-mL",
        "value": "香洲区",
        "text": "香洲区"
      }, {
        "id": "1974-Qf",
        "value": "斗门区",
        "text": "斗门区"
      }, {
        "id": "1975-I1",
        "value": "金湾区",
        "text": "金湾区"
      } ],
      "id": "1972-Qx",
      "value": "珠海市",
      "text": "珠海市"
    }, {
      "children": [ {
        "id": "1977-mV",
        "value": "龙湖区",
        "text": "龙湖区"
      }, {
        "id": "1978-r6",
        "value": "金平区",
        "text": "金平区"
      }, {
        "id": "1979-d1",
        "value": "濠江区",
        "text": "濠江区"
      }, {
        "id": "1980-Um",
        "value": "潮阳区",
        "text": "潮阳区"
      }, {
        "id": "1981-jb",
        "value": "潮南区",
        "text": "潮南区"
      }, {
        "id": "1982-R9",
        "value": "澄海区",
        "text": "澄海区"
      }, {
        "id": "1983-4n",
        "value": "南澳县",
        "text": "南澳县"
      } ],
      "id": "1976-sr",
      "value": "汕头市",
      "text": "汕头市"
    }, {
      "children": [ {
        "id": "1985-Xw",
        "value": "禅城区",
        "text": "禅城区"
      }, {
        "id": "1986-fw",
        "value": "南海区",
        "text": "南海区"
      }, {
        "id": "1987-o1",
        "value": "顺德区",
        "text": "顺德区"
      }, {
        "id": "1988-Nx",
        "value": "三水区",
        "text": "三水区"
      }, {
        "id": "1989-3n",
        "value": "高明区",
        "text": "高明区"
      } ],
      "id": "1984-k5",
      "value": "佛山市",
      "text": "佛山市"
    }, {
      "children": [ {
        "id": "1991-Pw",
        "value": "蓬江区",
        "text": "蓬江区"
      }, {
        "id": "1992-Bu",
        "value": "江海区",
        "text": "江海区"
      }, {
        "id": "1993-bB",
        "value": "新会区",
        "text": "新会区"
      }, {
        "id": "1994-kn",
        "value": "台山市",
        "text": "台山市"
      }, {
        "id": "1995-Mc",
        "value": "开平市",
        "text": "开平市"
      }, {
        "id": "1996-pN",
        "value": "鹤山市",
        "text": "鹤山市"
      }, {
        "id": "1997-vv",
        "value": "恩平市",
        "text": "恩平市"
      } ],
      "id": "1990-qa",
      "value": "江门市",
      "text": "江门市"
    }, {
      "children": [ {
        "id": "1999-Ow",
        "value": "赤坎区",
        "text": "赤坎区"
      }, {
        "id": "2000-vq",
        "value": "霞山区",
        "text": "霞山区"
      }, {
        "id": "2001-Mg",
        "value": "坡头区",
        "text": "坡头区"
      }, {
        "id": "2002-oc",
        "value": "麻章区",
        "text": "麻章区"
      }, {
        "id": "2003-eo",
        "value": "遂溪县",
        "text": "遂溪县"
      }, {
        "id": "2004-Wy",
        "value": "徐闻县",
        "text": "徐闻县"
      }, {
        "id": "2005-VE",
        "value": "廉江市",
        "text": "廉江市"
      }, {
        "id": "2006-GV",
        "value": "雷州市",
        "text": "雷州市"
      }, {
        "id": "2007-Hf",
        "value": "吴川市",
        "text": "吴川市"
      } ],
      "id": "1998-So",
      "value": "湛江市",
      "text": "湛江市"
    }, {
      "children": [ {
        "id": "2009-zi",
        "value": "茂南区",
        "text": "茂南区"
      }, {
        "id": "2010-z7",
        "value": "电白区",
        "text": "电白区"
      }, {
        "id": "2011-ra",
        "value": "高州市",
        "text": "高州市"
      }, {
        "id": "2012-wR",
        "value": "化州市",
        "text": "化州市"
      }, {
        "id": "2013-c7",
        "value": "信宜市",
        "text": "信宜市"
      } ],
      "id": "2008-vl",
      "value": "茂名市",
      "text": "茂名市"
    }, {
      "children": [ {
        "id": "2015-TL",
        "value": "端州区",
        "text": "端州区"
      }, {
        "id": "2016-Eo",
        "value": "鼎湖区",
        "text": "鼎湖区"
      }, {
        "id": "2017-YX",
        "value": "高要区",
        "text": "高要区"
      }, {
        "id": "2018-Bd",
        "value": "广宁县",
        "text": "广宁县"
      }, {
        "id": "2019-aJ",
        "value": "怀集县",
        "text": "怀集县"
      }, {
        "id": "2020-1l",
        "value": "封开县",
        "text": "封开县"
      }, {
        "id": "2021-SK",
        "value": "德庆县",
        "text": "德庆县"
      }, {
        "id": "2022-hT",
        "value": "四会市",
        "text": "四会市"
      } ],
      "id": "2014-FM",
      "value": "肇庆市",
      "text": "肇庆市"
    }, {
      "children": [ {
        "id": "2024-LB",
        "value": "惠城区",
        "text": "惠城区"
      }, {
        "id": "2025-OA",
        "value": "惠阳区",
        "text": "惠阳区"
      }, {
        "id": "2026-eX",
        "value": "博罗县",
        "text": "博罗县"
      }, {
        "id": "2027-Qx",
        "value": "惠东县",
        "text": "惠东县"
      }, {
        "id": "2028-hV",
        "value": "龙门县",
        "text": "龙门县"
      } ],
      "id": "2023-zs",
      "value": "惠州市",
      "text": "惠州市"
    }, {
      "children": [ {
        "id": "2030-nG",
        "value": "梅江区",
        "text": "梅江区"
      }, {
        "id": "2031-v5",
        "value": "梅县区",
        "text": "梅县区"
      }, {
        "id": "2032-N8",
        "value": "大埔县",
        "text": "大埔县"
      }, {
        "id": "2033-EP",
        "value": "丰顺县",
        "text": "丰顺县"
      }, {
        "id": "2034-ob",
        "value": "五华县",
        "text": "五华县"
      }, {
        "id": "2035-zS",
        "value": "平远县",
        "text": "平远县"
      }, {
        "id": "2036-il",
        "value": "蕉岭县",
        "text": "蕉岭县"
      }, {
        "id": "2037-TP",
        "value": "兴宁市",
        "text": "兴宁市"
      } ],
      "id": "2029-88",
      "value": "梅州市",
      "text": "梅州市"
    }, {
      "children": [ {
        "id": "2039-44",
        "value": "城区",
        "text": "城区"
      }, {
        "id": "2040-t2",
        "value": "海丰县",
        "text": "海丰县"
      }, {
        "id": "2041-6Y",
        "value": "陆河县",
        "text": "陆河县"
      }, {
        "id": "2042-2R",
        "value": "陆丰市",
        "text": "陆丰市"
      } ],
      "id": "2038-V7",
      "value": "汕尾市",
      "text": "汕尾市"
    }, {
      "children": [ {
        "id": "2044-5a",
        "value": "源城区",
        "text": "源城区"
      }, {
        "id": "2045-BW",
        "value": "紫金县",
        "text": "紫金县"
      }, {
        "id": "2046-iR",
        "value": "龙川县",
        "text": "龙川县"
      }, {
        "id": "2047-Ld",
        "value": "连平县",
        "text": "连平县"
      }, {
        "id": "2048-6B",
        "value": "和平县",
        "text": "和平县"
      }, {
        "id": "2049-g5",
        "value": "东源县",
        "text": "东源县"
      } ],
      "id": "2043-1o",
      "value": "河源市",
      "text": "河源市"
    }, {
      "children": [ {
        "id": "2051-TA",
        "value": "江城区",
        "text": "江城区"
      }, {
        "id": "2052-G4",
        "value": "阳东区",
        "text": "阳东区"
      }, {
        "id": "2053-jA",
        "value": "阳西县",
        "text": "阳西县"
      }, {
        "id": "2054-aB",
        "value": "阳春市",
        "text": "阳春市"
      } ],
      "id": "2050-h9",
      "value": "阳江市",
      "text": "阳江市"
    }, {
      "children": [ {
        "id": "2056-gY",
        "value": "清城区",
        "text": "清城区"
      }, {
        "id": "2057-q0",
        "value": "清新区",
        "text": "清新区"
      }, {
        "id": "2058-8l",
        "value": "佛冈县",
        "text": "佛冈县"
      }, {
        "id": "2059-qa",
        "value": "阳山县",
        "text": "阳山县"
      }, {
        "id": "2060-iU",
        "value": "连山壮族瑶族自治县",
        "text": "连山壮族瑶族自治县"
      }, {
        "id": "2061-8Y",
        "value": "连南瑶族自治县",
        "text": "连南瑶族自治县"
      }, {
        "id": "2062-3T",
        "value": "英德市",
        "text": "英德市"
      }, {
        "id": "2063-uq",
        "value": "连州市",
        "text": "连州市"
      } ],
      "id": "2055-y0",
      "value": "清远市",
      "text": "清远市"
    }, {
      "id": "2064-Sc",
      "value": "东莞市",
      "text": "东莞市"
    }, {
      "id": "2065-YE",
      "value": "中山市",
      "text": "中山市"
    }, {
      "children": [ {
        "id": "2067-uU",
        "value": "湘桥区",
        "text": "湘桥区"
      }, {
        "id": "2068-FD",
        "value": "潮安区",
        "text": "潮安区"
      }, {
        "id": "2069-7U",
        "value": "饶平县",
        "text": "饶平县"
      } ],
      "id": "2066-Ky",
      "value": "潮州市",
      "text": "潮州市"
    }, {
      "children": [ {
        "id": "2071-Bs",
        "value": "榕城区",
        "text": "榕城区"
      }, {
        "id": "2072-OE",
        "value": "揭东区",
        "text": "揭东区"
      }, {
        "id": "2073-TC",
        "value": "揭西县",
        "text": "揭西县"
      }, {
        "id": "2074-PP",
        "value": "惠来县",
        "text": "惠来县"
      }, {
        "id": "2075-mG",
        "value": "普宁市",
        "text": "普宁市"
      } ],
      "id": "2070-DN",
      "value": "揭阳市",
      "text": "揭阳市"
    }, {
      "children": [ {
        "id": "2077-Sv",
        "value": "云城区",
        "text": "云城区"
      }, {
        "id": "2078-Aa",
        "value": "云安区",
        "text": "云安区"
      }, {
        "id": "2079-f2",
        "value": "新兴县",
        "text": "新兴县"
      }, {
        "id": "2080-Ih",
        "value": "郁南县",
        "text": "郁南县"
      }, {
        "id": "2081-PI",
        "value": "罗定市",
        "text": "罗定市"
      } ],
      "id": "2076-ye",
      "value": "云浮市",
      "text": "云浮市"
    } ],
    "id": "1941-hZ",
    "value": "广东省",
    "text": "广东省"
  }, {
    "children": [ {
      "children": [ {
        "id": "2084-dd",
        "value": "兴宁区",
        "text": "兴宁区"
      }, {
        "id": "2085-8s",
        "value": "青秀区",
        "text": "青秀区"
      }, {
        "id": "2086-iK",
        "value": "江南区",
        "text": "江南区"
      }, {
        "id": "2087-EZ",
        "value": "西乡塘区",
        "text": "西乡塘区"
      }, {
        "id": "2088-qV",
        "value": "良庆区",
        "text": "良庆区"
      }, {
        "id": "2089-TO",
        "value": "邕宁区",
        "text": "邕宁区"
      }, {
        "id": "2090-fX",
        "value": "武鸣区",
        "text": "武鸣区"
      }, {
        "id": "2091-Q0",
        "value": "隆安县",
        "text": "隆安县"
      }, {
        "id": "2092-ez",
        "value": "马山县",
        "text": "马山县"
      }, {
        "id": "2093-11",
        "value": "上林县",
        "text": "上林县"
      }, {
        "id": "2094-Pa",
        "value": "宾阳县",
        "text": "宾阳县"
      }, {
        "id": "2095-C5",
        "value": "横县",
        "text": "横县"
      } ],
      "id": "2083-PO",
      "value": "南宁市",
      "text": "南宁市"
    }, {
      "children": [ {
        "id": "2097-lG",
        "value": "城中区",
        "text": "城中区"
      }, {
        "id": "2098-Rl",
        "value": "鱼峰区",
        "text": "鱼峰区"
      }, {
        "id": "2099-wO",
        "value": "柳南区",
        "text": "柳南区"
      }, {
        "id": "2100-Fi",
        "value": "柳北区",
        "text": "柳北区"
      }, {
        "id": "2101-b3",
        "value": "柳江区",
        "text": "柳江区"
      }, {
        "id": "2102-Ve",
        "value": "柳城县",
        "text": "柳城县"
      }, {
        "id": "2103-Kr",
        "value": "鹿寨县",
        "text": "鹿寨县"
      }, {
        "id": "2104-T1",
        "value": "融安县",
        "text": "融安县"
      }, {
        "id": "2105-J6",
        "value": "融水苗族自治县",
        "text": "融水苗族自治县"
      }, {
        "id": "2106-5C",
        "value": "三江侗族自治县",
        "text": "三江侗族自治县"
      } ],
      "id": "2096-u1",
      "value": "柳州市",
      "text": "柳州市"
    }, {
      "children": [ {
        "id": "2108-s4",
        "value": "秀峰区",
        "text": "秀峰区"
      }, {
        "id": "2109-GD",
        "value": "叠彩区",
        "text": "叠彩区"
      }, {
        "id": "2110-rX",
        "value": "象山区",
        "text": "象山区"
      }, {
        "id": "2111-EC",
        "value": "七星区",
        "text": "七星区"
      }, {
        "id": "2112-2r",
        "value": "雁山区",
        "text": "雁山区"
      }, {
        "id": "2113-Wk",
        "value": "临桂区",
        "text": "临桂区"
      }, {
        "id": "2114-Tu",
        "value": "阳朔县",
        "text": "阳朔县"
      }, {
        "id": "2115-fq",
        "value": "灵川县",
        "text": "灵川县"
      }, {
        "id": "2116-Da",
        "value": "全州县",
        "text": "全州县"
      }, {
        "id": "2117-G6",
        "value": "兴安县",
        "text": "兴安县"
      }, {
        "id": "2118-7f",
        "value": "永福县",
        "text": "永福县"
      }, {
        "id": "2119-Dw",
        "value": "灌阳县",
        "text": "灌阳县"
      }, {
        "id": "2120-kp",
        "value": "龙胜各族自治县",
        "text": "龙胜各族自治县"
      }, {
        "id": "2121-AC",
        "value": "资源县",
        "text": "资源县"
      }, {
        "id": "2122-40",
        "value": "平乐县",
        "text": "平乐县"
      }, {
        "id": "2123-7Q",
        "value": "荔浦县",
        "text": "荔浦县"
      }, {
        "id": "2124-ii",
        "value": "恭城瑶族自治县",
        "text": "恭城瑶族自治县"
      } ],
      "id": "2107-ZQ",
      "value": "桂林市",
      "text": "桂林市"
    }, {
      "children": [ {
        "id": "2126-PC",
        "value": "万秀区",
        "text": "万秀区"
      }, {
        "id": "2127-RW",
        "value": "长洲区",
        "text": "长洲区"
      }, {
        "id": "2128-Wt",
        "value": "龙圩区",
        "text": "龙圩区"
      }, {
        "id": "2129-Li",
        "value": "苍梧县",
        "text": "苍梧县"
      }, {
        "id": "2130-Hy",
        "value": "藤县",
        "text": "藤县"
      }, {
        "id": "2131-46",
        "value": "蒙山县",
        "text": "蒙山县"
      }, {
        "id": "2132-MH",
        "value": "岑溪市",
        "text": "岑溪市"
      } ],
      "id": "2125-aZ",
      "value": "梧州市",
      "text": "梧州市"
    }, {
      "children": [ {
        "id": "2134-L8",
        "value": "海城区",
        "text": "海城区"
      }, {
        "id": "2135-JT",
        "value": "银海区",
        "text": "银海区"
      }, {
        "id": "2136-6Z",
        "value": "铁山港区",
        "text": "铁山港区"
      }, {
        "id": "2137-CF",
        "value": "合浦县",
        "text": "合浦县"
      } ],
      "id": "2133-34",
      "value": "北海市",
      "text": "北海市"
    }, {
      "children": [ {
        "id": "2139-np",
        "value": "港口区",
        "text": "港口区"
      }, {
        "id": "2140-WZ",
        "value": "防城区",
        "text": "防城区"
      }, {
        "id": "2141-ib",
        "value": "上思县",
        "text": "上思县"
      }, {
        "id": "2142-KW",
        "value": "东兴市",
        "text": "东兴市"
      } ],
      "id": "2138-ZW",
      "value": "防城港市",
      "text": "防城港市"
    }, {
      "children": [ {
        "id": "2144-rm",
        "value": "钦南区",
        "text": "钦南区"
      }, {
        "id": "2145-i0",
        "value": "钦北区",
        "text": "钦北区"
      }, {
        "id": "2146-gn",
        "value": "灵山县",
        "text": "灵山县"
      }, {
        "id": "2147-2H",
        "value": "浦北县",
        "text": "浦北县"
      } ],
      "id": "2143-20",
      "value": "钦州市",
      "text": "钦州市"
    }, {
      "children": [ {
        "id": "2149-7c",
        "value": "港北区",
        "text": "港北区"
      }, {
        "id": "2150-jf",
        "value": "港南区",
        "text": "港南区"
      }, {
        "id": "2151-yM",
        "value": "覃塘区",
        "text": "覃塘区"
      }, {
        "id": "2152-Iz",
        "value": "平南县",
        "text": "平南县"
      }, {
        "id": "2153-Vo",
        "value": "桂平市",
        "text": "桂平市"
      } ],
      "id": "2148-KF",
      "value": "贵港市",
      "text": "贵港市"
    }, {
      "children": [ {
        "id": "2155-Xt",
        "value": "玉州区",
        "text": "玉州区"
      }, {
        "id": "2156-Mj",
        "value": "福绵区",
        "text": "福绵区"
      }, {
        "id": "2157-R5",
        "value": "容县",
        "text": "容县"
      }, {
        "id": "2158-PM",
        "value": "陆川县",
        "text": "陆川县"
      }, {
        "id": "2159-xo",
        "value": "博白县",
        "text": "博白县"
      }, {
        "id": "2160-D8",
        "value": "兴业县",
        "text": "兴业县"
      }, {
        "id": "2161-Te",
        "value": "北流市",
        "text": "北流市"
      } ],
      "id": "2154-zj",
      "value": "玉林市",
      "text": "玉林市"
    }, {
      "children": [ {
        "id": "2163-aj",
        "value": "右江区",
        "text": "右江区"
      }, {
        "id": "2164-ia",
        "value": "田阳县",
        "text": "田阳县"
      }, {
        "id": "2165-Aq",
        "value": "田东县",
        "text": "田东县"
      }, {
        "id": "2166-cK",
        "value": "平果县",
        "text": "平果县"
      }, {
        "id": "2167-Vc",
        "value": "德保县",
        "text": "德保县"
      }, {
        "id": "2168-3d",
        "value": "那坡县",
        "text": "那坡县"
      }, {
        "id": "2169-sU",
        "value": "凌云县",
        "text": "凌云县"
      }, {
        "id": "2170-nI",
        "value": "乐业县",
        "text": "乐业县"
      }, {
        "id": "2171-fR",
        "value": "田林县",
        "text": "田林县"
      }, {
        "id": "2172-Om",
        "value": "西林县",
        "text": "西林县"
      }, {
        "id": "2173-GB",
        "value": "隆林各族自治县",
        "text": "隆林各族自治县"
      }, {
        "id": "2174-mx",
        "value": "靖西市",
        "text": "靖西市"
      } ],
      "id": "2162-v1",
      "value": "百色市",
      "text": "百色市"
    }, {
      "children": [ {
        "id": "2176-Id",
        "value": "八步区",
        "text": "八步区"
      }, {
        "id": "2177-1S",
        "value": "平桂区",
        "text": "平桂区"
      }, {
        "id": "2178-W6",
        "value": "昭平县",
        "text": "昭平县"
      }, {
        "id": "2179-O4",
        "value": "钟山县",
        "text": "钟山县"
      }, {
        "id": "2180-fh",
        "value": "富川瑶族自治县",
        "text": "富川瑶族自治县"
      } ],
      "id": "2175-Bq",
      "value": "贺州市",
      "text": "贺州市"
    }, {
      "children": [ {
        "id": "2182-sN",
        "value": "金城江区",
        "text": "金城江区"
      }, {
        "id": "2183-xW",
        "value": "南丹县",
        "text": "南丹县"
      }, {
        "id": "2184-Lb",
        "value": "天峨县",
        "text": "天峨县"
      }, {
        "id": "2185-d2",
        "value": "凤山县",
        "text": "凤山县"
      }, {
        "id": "2186-Gr",
        "value": "东兰县",
        "text": "东兰县"
      }, {
        "id": "2187-zy",
        "value": "罗城仫佬族自治县",
        "text": "罗城仫佬族自治县"
      }, {
        "id": "2188-BU",
        "value": "环江毛南族自治县",
        "text": "环江毛南族自治县"
      }, {
        "id": "2189-wu",
        "value": "巴马瑶族自治县",
        "text": "巴马瑶族自治县"
      }, {
        "id": "2190-fs",
        "value": "都安瑶族自治县",
        "text": "都安瑶族自治县"
      }, {
        "id": "2191-5t",
        "value": "大化瑶族自治县",
        "text": "大化瑶族自治县"
      }, {
        "id": "2192-By",
        "value": "宜州市",
        "text": "宜州市"
      } ],
      "id": "2181-Wp",
      "value": "河池市",
      "text": "河池市"
    }, {
      "children": [ {
        "id": "2194-hK",
        "value": "兴宾区",
        "text": "兴宾区"
      }, {
        "id": "2195-Ci",
        "value": "忻城县",
        "text": "忻城县"
      }, {
        "id": "2196-QD",
        "value": "象州县",
        "text": "象州县"
      }, {
        "id": "2197-u3",
        "value": "武宣县",
        "text": "武宣县"
      }, {
        "id": "2198-Ik",
        "value": "金秀瑶族自治县",
        "text": "金秀瑶族自治县"
      }, {
        "id": "2199-sp",
        "value": "合山市",
        "text": "合山市"
      } ],
      "id": "2193-ug",
      "value": "来宾市",
      "text": "来宾市"
    }, {
      "children": [ {
        "id": "2201-Dt",
        "value": "江州区",
        "text": "江州区"
      }, {
        "id": "2202-Nm",
        "value": "扶绥县",
        "text": "扶绥县"
      }, {
        "id": "2203-e9",
        "value": "宁明县",
        "text": "宁明县"
      }, {
        "id": "2204-HG",
        "value": "龙州县",
        "text": "龙州县"
      }, {
        "id": "2205-Gx",
        "value": "大新县",
        "text": "大新县"
      }, {
        "id": "2206-vc",
        "value": "天等县",
        "text": "天等县"
      }, {
        "id": "2207-8x",
        "value": "凭祥市",
        "text": "凭祥市"
      } ],
      "id": "2200-cE",
      "value": "崇左市",
      "text": "崇左市"
    } ],
    "id": "2082-Hq",
    "value": "广西壮族自治区",
    "text": "广西壮族自治区"
  }, {
    "children": [ {
      "children": [ {
        "id": "2210-rU",
        "value": "秀英区",
        "text": "秀英区"
      }, {
        "id": "2211-Af",
        "value": "龙华区",
        "text": "龙华区"
      }, {
        "id": "2212-5x",
        "value": "琼山区",
        "text": "琼山区"
      }, {
        "id": "2213-o7",
        "value": "美兰区",
        "text": "美兰区"
      } ],
      "id": "2209-2g",
      "value": "海口市",
      "text": "海口市"
    }, {
      "children": [ {
        "id": "2215-W7",
        "value": "海棠区",
        "text": "海棠区"
      }, {
        "id": "2216-E6",
        "value": "吉阳区",
        "text": "吉阳区"
      }, {
        "id": "2217-OM",
        "value": "天涯区",
        "text": "天涯区"
      }, {
        "id": "2218-Zi",
        "value": "崖州区",
        "text": "崖州区"
      } ],
      "id": "2214-Y1",
      "value": "三亚市",
      "text": "三亚市"
    }, {
      "id": "2219-DH",
      "value": "三沙市",
      "text": "三沙市"
    }, {
      "id": "2220-8o",
      "value": "儋州市",
      "text": "儋州市"
    }, {
      "children": [ {
        "id": "2222-Uh",
        "value": "五指山市",
        "text": "五指山市"
      }, {
        "id": "2223-b2",
        "value": "琼海市",
        "text": "琼海市"
      }, {
        "id": "2224-M6",
        "value": "文昌市",
        "text": "文昌市"
      }, {
        "id": "2225-tO",
        "value": "万宁市",
        "text": "万宁市"
      }, {
        "id": "2226-9Q",
        "value": "东方市",
        "text": "东方市"
      }, {
        "id": "2227-lW",
        "value": "定安县",
        "text": "定安县"
      }, {
        "id": "2228-nO",
        "value": "屯昌县",
        "text": "屯昌县"
      }, {
        "id": "2229-Jt",
        "value": "澄迈县",
        "text": "澄迈县"
      }, {
        "id": "2230-jV",
        "value": "临高县",
        "text": "临高县"
      }, {
        "id": "2231-ak",
        "value": "白沙黎族自治县",
        "text": "白沙黎族自治县"
      }, {
        "id": "2232-S2",
        "value": "昌江黎族自治县",
        "text": "昌江黎族自治县"
      }, {
        "id": "2233-mx",
        "value": "乐东黎族自治县",
        "text": "乐东黎族自治县"
      }, {
        "id": "2234-Sk",
        "value": "陵水黎族自治县",
        "text": "陵水黎族自治县"
      }, {
        "id": "2235-GA",
        "value": "保亭黎族苗族自治县",
        "text": "保亭黎族苗族自治县"
      }, {
        "id": "2236-fn",
        "value": "琼中黎族苗族自治县",
        "text": "琼中黎族苗族自治县"
      } ],
      "id": "2221-Ev",
      "value": "省直辖县级行政区划",
      "text": "省直辖县级行政区划"
    } ],
    "id": "2208-Yc",
    "value": "海南省",
    "text": "海南省"
  }, {
    "children": [ {
      "children": [ {
        "id": "2239-s7",
        "value": "万州区",
        "text": "万州区"
      }, {
        "id": "2240-Hx",
        "value": "涪陵区",
        "text": "涪陵区"
      }, {
        "id": "2241-Dl",
        "value": "渝中区",
        "text": "渝中区"
      }, {
        "id": "2242-5t",
        "value": "大渡口区",
        "text": "大渡口区"
      }, {
        "id": "2243-hP",
        "value": "江北区",
        "text": "江北区"
      }, {
        "id": "2244-zc",
        "value": "沙坪坝区",
        "text": "沙坪坝区"
      }, {
        "id": "2245-n4",
        "value": "九龙坡区",
        "text": "九龙坡区"
      }, {
        "id": "2246-oX",
        "value": "南岸区",
        "text": "南岸区"
      }, {
        "id": "2247-Ep",
        "value": "北碚区",
        "text": "北碚区"
      }, {
        "id": "2248-Di",
        "value": "綦江区",
        "text": "綦江区"
      }, {
        "id": "2249-Ay",
        "value": "大足区",
        "text": "大足区"
      }, {
        "id": "2250-3t",
        "value": "渝北区",
        "text": "渝北区"
      }, {
        "id": "2251-Kb",
        "value": "巴南区",
        "text": "巴南区"
      }, {
        "id": "2252-S3",
        "value": "黔江区",
        "text": "黔江区"
      }, {
        "id": "2253-ls",
        "value": "长寿区",
        "text": "长寿区"
      }, {
        "id": "2254-TO",
        "value": "江津区",
        "text": "江津区"
      }, {
        "id": "2255-dn",
        "value": "合川区",
        "text": "合川区"
      }, {
        "id": "2256-oD",
        "value": "永川区",
        "text": "永川区"
      }, {
        "id": "2257-3q",
        "value": "南川区",
        "text": "南川区"
      }, {
        "id": "2258-Sl",
        "value": "璧山区",
        "text": "璧山区"
      }, {
        "id": "2259-OK",
        "value": "铜梁区",
        "text": "铜梁区"
      }, {
        "id": "2260-x7",
        "value": "潼南区",
        "text": "潼南区"
      }, {
        "id": "2261-UA",
        "value": "荣昌区",
        "text": "荣昌区"
      }, {
        "id": "2262-4G",
        "value": "开州区",
        "text": "开州区"
      }, {
        "id": "2263-hi",
        "value": "梁平县",
        "text": "梁平县"
      }, {
        "id": "2264-VS",
        "value": "城口县",
        "text": "城口县"
      }, {
        "id": "2265-EE",
        "value": "丰都县",
        "text": "丰都县"
      }, {
        "id": "2266-Wl",
        "value": "垫江县",
        "text": "垫江县"
      }, {
        "id": "2267-Ct",
        "value": "武隆县",
        "text": "武隆县"
      }, {
        "id": "2268-ul",
        "value": "忠县",
        "text": "忠县"
      }, {
        "id": "2269-pM",
        "value": "云阳县",
        "text": "云阳县"
      }, {
        "id": "2270-e2",
        "value": "奉节县",
        "text": "奉节县"
      }, {
        "id": "2271-ow",
        "value": "巫山县",
        "text": "巫山县"
      }, {
        "id": "2272-Lb",
        "value": "巫溪县",
        "text": "巫溪县"
      }, {
        "id": "2273-93",
        "value": "石柱土家族自治县",
        "text": "石柱土家族自治县"
      }, {
        "id": "2274-jN",
        "value": "秀山土家族苗族自治县",
        "text": "秀山土家族苗族自治县"
      }, {
        "id": "2275-Pz",
        "value": "酉阳土家族苗族自治县",
        "text": "酉阳土家族苗族自治县"
      }, {
        "id": "2276-cu",
        "value": "彭水苗族土家族自治县",
        "text": "彭水苗族土家族自治县"
      } ],
      "id": "2238-li",
      "value": "重庆市",
      "text": "重庆市"
    } ],
    "id": "2237-Dx",
    "value": "重庆市",
    "text": "重庆市"
  }, {
    "children": [ {
      "children": [ {
        "id": "2279-Kd",
        "value": "锦江区",
        "text": "锦江区"
      }, {
        "id": "2280-iH",
        "value": "青羊区",
        "text": "青羊区"
      }, {
        "id": "2281-kh",
        "value": "金牛区",
        "text": "金牛区"
      }, {
        "id": "2282-0G",
        "value": "武侯区",
        "text": "武侯区"
      }, {
        "id": "2283-r1",
        "value": "成华区",
        "text": "成华区"
      }, {
        "id": "2284-jf",
        "value": "龙泉驿区",
        "text": "龙泉驿区"
      }, {
        "id": "2285-Ei",
        "value": "青白江区",
        "text": "青白江区"
      }, {
        "id": "2286-ix",
        "value": "新都区",
        "text": "新都区"
      }, {
        "id": "2287-4Y",
        "value": "温江区",
        "text": "温江区"
      }, {
        "id": "2288-kn",
        "value": "双流区",
        "text": "双流区"
      }, {
        "id": "2289-vr",
        "value": "金堂县",
        "text": "金堂县"
      }, {
        "id": "2290-be",
        "value": "郫县",
        "text": "郫县"
      }, {
        "id": "2291-rt",
        "value": "大邑县",
        "text": "大邑县"
      }, {
        "id": "2292-J6",
        "value": "蒲江县",
        "text": "蒲江县"
      }, {
        "id": "2293-UW",
        "value": "新津县",
        "text": "新津县"
      }, {
        "id": "2294-e6",
        "value": "都江堰市",
        "text": "都江堰市"
      }, {
        "id": "2295-jE",
        "value": "彭州市",
        "text": "彭州市"
      }, {
        "id": "2296-mT",
        "value": "邛崃市",
        "text": "邛崃市"
      }, {
        "id": "2297-zC",
        "value": "崇州市",
        "text": "崇州市"
      }, {
        "id": "2298-bK",
        "value": "简阳市",
        "text": "简阳市"
      } ],
      "id": "2278-3s",
      "value": "成都市",
      "text": "成都市"
    }, {
      "children": [ {
        "id": "2300-QQ",
        "value": "自流井区",
        "text": "自流井区"
      }, {
        "id": "2301-Dk",
        "value": "贡井区",
        "text": "贡井区"
      }, {
        "id": "2302-M2",
        "value": "大安区",
        "text": "大安区"
      }, {
        "id": "2303-Ku",
        "value": "沿滩区",
        "text": "沿滩区"
      }, {
        "id": "2304-SI",
        "value": "荣县",
        "text": "荣县"
      }, {
        "id": "2305-Ny",
        "value": "富顺县",
        "text": "富顺县"
      } ],
      "id": "2299-W7",
      "value": "自贡市",
      "text": "自贡市"
    }, {
      "children": [ {
        "id": "2307-nx",
        "value": "东区",
        "text": "东区"
      }, {
        "id": "2308-bv",
        "value": "西区",
        "text": "西区"
      }, {
        "id": "2309-7W",
        "value": "仁和区",
        "text": "仁和区"
      }, {
        "id": "2310-sd",
        "value": "米易县",
        "text": "米易县"
      }, {
        "id": "2311-1l",
        "value": "盐边县",
        "text": "盐边县"
      } ],
      "id": "2306-hq",
      "value": "攀枝花市",
      "text": "攀枝花市"
    }, {
      "children": [ {
        "id": "2313-aG",
        "value": "江阳区",
        "text": "江阳区"
      }, {
        "id": "2314-Ii",
        "value": "纳溪区",
        "text": "纳溪区"
      }, {
        "id": "2315-hU",
        "value": "龙马潭区",
        "text": "龙马潭区"
      }, {
        "id": "2316-y9",
        "value": "泸县",
        "text": "泸县"
      }, {
        "id": "2317-fN",
        "value": "合江县",
        "text": "合江县"
      }, {
        "id": "2318-vE",
        "value": "叙永县",
        "text": "叙永县"
      }, {
        "id": "2319-yJ",
        "value": "古蔺县",
        "text": "古蔺县"
      } ],
      "id": "2312-kP",
      "value": "泸州市",
      "text": "泸州市"
    }, {
      "children": [ {
        "id": "2321-lS",
        "value": "旌阳区",
        "text": "旌阳区"
      }, {
        "id": "2322-bL",
        "value": "中江县",
        "text": "中江县"
      }, {
        "id": "2323-Ta",
        "value": "罗江县",
        "text": "罗江县"
      }, {
        "id": "2324-y1",
        "value": "广汉市",
        "text": "广汉市"
      }, {
        "id": "2325-pp",
        "value": "什邡市",
        "text": "什邡市"
      }, {
        "id": "2326-Gq",
        "value": "绵竹市",
        "text": "绵竹市"
      } ],
      "id": "2320-N6",
      "value": "德阳市",
      "text": "德阳市"
    }, {
      "children": [ {
        "id": "2328-7E",
        "value": "涪城区",
        "text": "涪城区"
      }, {
        "id": "2329-V4",
        "value": "游仙区",
        "text": "游仙区"
      }, {
        "id": "2330-aC",
        "value": "安州区",
        "text": "安州区"
      }, {
        "id": "2331-hk",
        "value": "三台县",
        "text": "三台县"
      }, {
        "id": "2332-dx",
        "value": "盐亭县",
        "text": "盐亭县"
      }, {
        "id": "2333-uV",
        "value": "梓潼县",
        "text": "梓潼县"
      }, {
        "id": "2334-e6",
        "value": "北川羌族自治县",
        "text": "北川羌族自治县"
      }, {
        "id": "2335-Tb",
        "value": "平武县",
        "text": "平武县"
      }, {
        "id": "2336-ap",
        "value": "江油市",
        "text": "江油市"
      } ],
      "id": "2327-4R",
      "value": "绵阳市",
      "text": "绵阳市"
    }, {
      "children": [ {
        "id": "2338-Ey",
        "value": "利州区",
        "text": "利州区"
      }, {
        "id": "2339-xj",
        "value": "昭化区",
        "text": "昭化区"
      }, {
        "id": "2340-vh",
        "value": "朝天区",
        "text": "朝天区"
      }, {
        "id": "2341-2i",
        "value": "旺苍县",
        "text": "旺苍县"
      }, {
        "id": "2342-2v",
        "value": "青川县",
        "text": "青川县"
      }, {
        "id": "2343-9Q",
        "value": "剑阁县",
        "text": "剑阁县"
      }, {
        "id": "2344-o2",
        "value": "苍溪县",
        "text": "苍溪县"
      } ],
      "id": "2337-JE",
      "value": "广元市",
      "text": "广元市"
    }, {
      "children": [ {
        "id": "2346-tv",
        "value": "船山区",
        "text": "船山区"
      }, {
        "id": "2347-Bl",
        "value": "安居区",
        "text": "安居区"
      }, {
        "id": "2348-SB",
        "value": "蓬溪县",
        "text": "蓬溪县"
      }, {
        "id": "2349-xS",
        "value": "射洪县",
        "text": "射洪县"
      }, {
        "id": "2350-sz",
        "value": "大英县",
        "text": "大英县"
      } ],
      "id": "2345-wS",
      "value": "遂宁市",
      "text": "遂宁市"
    }, {
      "children": [ {
        "id": "2352-eM",
        "value": "市中区",
        "text": "市中区"
      }, {
        "id": "2353-XO",
        "value": "东兴区",
        "text": "东兴区"
      }, {
        "id": "2354-jp",
        "value": "威远县",
        "text": "威远县"
      }, {
        "id": "2355-ar",
        "value": "资中县",
        "text": "资中县"
      }, {
        "id": "2356-dy",
        "value": "隆昌县",
        "text": "隆昌县"
      } ],
      "id": "2351-sE",
      "value": "内江市",
      "text": "内江市"
    }, {
      "children": [ {
        "id": "2358-Tm",
        "value": "市中区",
        "text": "市中区"
      }, {
        "id": "2359-Cg",
        "value": "沙湾区",
        "text": "沙湾区"
      }, {
        "id": "2360-RH",
        "value": "五通桥区",
        "text": "五通桥区"
      }, {
        "id": "2361-I4",
        "value": "金口河区",
        "text": "金口河区"
      }, {
        "id": "2362-Hz",
        "value": "犍为县",
        "text": "犍为县"
      }, {
        "id": "2363-OM",
        "value": "井研县",
        "text": "井研县"
      }, {
        "id": "2364-Br",
        "value": "夹江县",
        "text": "夹江县"
      }, {
        "id": "2365-VD",
        "value": "沐川县",
        "text": "沐川县"
      }, {
        "id": "2366-od",
        "value": "峨边彝族自治县",
        "text": "峨边彝族自治县"
      }, {
        "id": "2367-aj",
        "value": "马边彝族自治县",
        "text": "马边彝族自治县"
      }, {
        "id": "2368-Qr",
        "value": "峨眉山市",
        "text": "峨眉山市"
      } ],
      "id": "2357-IQ",
      "value": "乐山市",
      "text": "乐山市"
    }, {
      "children": [ {
        "id": "2370-8g",
        "value": "顺庆区",
        "text": "顺庆区"
      }, {
        "id": "2371-QP",
        "value": "高坪区",
        "text": "高坪区"
      }, {
        "id": "2372-Yl",
        "value": "嘉陵区",
        "text": "嘉陵区"
      }, {
        "id": "2373-F8",
        "value": "南部县",
        "text": "南部县"
      }, {
        "id": "2374-3q",
        "value": "营山县",
        "text": "营山县"
      }, {
        "id": "2375-vy",
        "value": "蓬安县",
        "text": "蓬安县"
      }, {
        "id": "2376-Ow",
        "value": "仪陇县",
        "text": "仪陇县"
      }, {
        "id": "2377-K7",
        "value": "西充县",
        "text": "西充县"
      }, {
        "id": "2378-W9",
        "value": "阆中市",
        "text": "阆中市"
      } ],
      "id": "2369-pm",
      "value": "南充市",
      "text": "南充市"
    }, {
      "children": [ {
        "id": "2380-Q9",
        "value": "东坡区",
        "text": "东坡区"
      }, {
        "id": "2381-5Y",
        "value": "彭山区",
        "text": "彭山区"
      }, {
        "id": "2382-Ih",
        "value": "仁寿县",
        "text": "仁寿县"
      }, {
        "id": "2383-6M",
        "value": "洪雅县",
        "text": "洪雅县"
      }, {
        "id": "2384-y8",
        "value": "丹棱县",
        "text": "丹棱县"
      }, {
        "id": "2385-is",
        "value": "青神县",
        "text": "青神县"
      } ],
      "id": "2379-CP",
      "value": "眉山市",
      "text": "眉山市"
    }, {
      "children": [ {
        "id": "2387-te",
        "value": "翠屏区",
        "text": "翠屏区"
      }, {
        "id": "2388-AA",
        "value": "南溪区",
        "text": "南溪区"
      }, {
        "id": "2389-MS",
        "value": "宜宾县",
        "text": "宜宾县"
      }, {
        "id": "2390-VB",
        "value": "江安县",
        "text": "江安县"
      }, {
        "id": "2391-Lf",
        "value": "长宁县",
        "text": "长宁县"
      }, {
        "id": "2392-rs",
        "value": "高县",
        "text": "高县"
      }, {
        "id": "2393-Pw",
        "value": "珙县",
        "text": "珙县"
      }, {
        "id": "2394-aq",
        "value": "筠连县",
        "text": "筠连县"
      }, {
        "id": "2395-xC",
        "value": "兴文县",
        "text": "兴文县"
      }, {
        "id": "2396-6E",
        "value": "屏山县",
        "text": "屏山县"
      } ],
      "id": "2386-kr",
      "value": "宜宾市",
      "text": "宜宾市"
    }, {
      "children": [ {
        "id": "2398-O7",
        "value": "广安区",
        "text": "广安区"
      }, {
        "id": "2399-8q",
        "value": "前锋区",
        "text": "前锋区"
      }, {
        "id": "2400-Rz",
        "value": "岳池县",
        "text": "岳池县"
      }, {
        "id": "2401-oo",
        "value": "武胜县",
        "text": "武胜县"
      }, {
        "id": "2402-hM",
        "value": "邻水县",
        "text": "邻水县"
      }, {
        "id": "2403-jl",
        "value": "华蓥市",
        "text": "华蓥市"
      } ],
      "id": "2397-eO",
      "value": "广安市",
      "text": "广安市"
    }, {
      "children": [ {
        "id": "2405-nF",
        "value": "通川区",
        "text": "通川区"
      }, {
        "id": "2406-n7",
        "value": "达川区",
        "text": "达川区"
      }, {
        "id": "2407-DF",
        "value": "宣汉县",
        "text": "宣汉县"
      }, {
        "id": "2408-Hx",
        "value": "开江县",
        "text": "开江县"
      }, {
        "id": "2409-RT",
        "value": "大竹县",
        "text": "大竹县"
      }, {
        "id": "2410-IR",
        "value": "渠县",
        "text": "渠县"
      }, {
        "id": "2411-1F",
        "value": "万源市",
        "text": "万源市"
      } ],
      "id": "2404-y4",
      "value": "达州市",
      "text": "达州市"
    }, {
      "children": [ {
        "id": "2413-oy",
        "value": "雨城区",
        "text": "雨城区"
      }, {
        "id": "2414-xT",
        "value": "名山区",
        "text": "名山区"
      }, {
        "id": "2415-JZ",
        "value": "荥经县",
        "text": "荥经县"
      }, {
        "id": "2416-2H",
        "value": "汉源县",
        "text": "汉源县"
      }, {
        "id": "2417-V7",
        "value": "石棉县",
        "text": "石棉县"
      }, {
        "id": "2418-Z2",
        "value": "天全县",
        "text": "天全县"
      }, {
        "id": "2419-gj",
        "value": "芦山县",
        "text": "芦山县"
      }, {
        "id": "2420-cN",
        "value": "宝兴县",
        "text": "宝兴县"
      } ],
      "id": "2412-v3",
      "value": "雅安市",
      "text": "雅安市"
    }, {
      "children": [ {
        "id": "2422-9r",
        "value": "巴州区",
        "text": "巴州区"
      }, {
        "id": "2423-Hk",
        "value": "恩阳区",
        "text": "恩阳区"
      }, {
        "id": "2424-ZP",
        "value": "通江县",
        "text": "通江县"
      }, {
        "id": "2425-yv",
        "value": "南江县",
        "text": "南江县"
      }, {
        "id": "2426-Gy",
        "value": "平昌县",
        "text": "平昌县"
      } ],
      "id": "2421-tt",
      "value": "巴中市",
      "text": "巴中市"
    }, {
      "children": [ {
        "id": "2428-bb",
        "value": "雁江区",
        "text": "雁江区"
      }, {
        "id": "2429-JV",
        "value": "安岳县",
        "text": "安岳县"
      }, {
        "id": "2430-bC",
        "value": "乐至县",
        "text": "乐至县"
      } ],
      "id": "2427-Ni",
      "value": "资阳市",
      "text": "资阳市"
    }, {
      "children": [ {
        "id": "2432-2I",
        "value": "马尔康市",
        "text": "马尔康市"
      }, {
        "id": "2433-pR",
        "value": "汶川县",
        "text": "汶川县"
      }, {
        "id": "2434-ZP",
        "value": "理县",
        "text": "理县"
      }, {
        "id": "2435-K1",
        "value": "茂县",
        "text": "茂县"
      }, {
        "id": "2436-nI",
        "value": "松潘县",
        "text": "松潘县"
      }, {
        "id": "2437-7o",
        "value": "九寨沟县",
        "text": "九寨沟县"
      }, {
        "id": "2438-sR",
        "value": "金川县",
        "text": "金川县"
      }, {
        "id": "2439-Qr",
        "value": "小金县",
        "text": "小金县"
      }, {
        "id": "2440-Ci",
        "value": "黑水县",
        "text": "黑水县"
      }, {
        "id": "2441-oc",
        "value": "壤塘县",
        "text": "壤塘县"
      }, {
        "id": "2442-zU",
        "value": "阿坝县",
        "text": "阿坝县"
      }, {
        "id": "2443-Qw",
        "value": "若尔盖县",
        "text": "若尔盖县"
      }, {
        "id": "2444-vu",
        "value": "红原县",
        "text": "红原县"
      } ],
      "id": "2431-fB",
      "value": "阿坝藏族羌族自治州",
      "text": "阿坝藏族羌族自治州"
    }, {
      "children": [ {
        "id": "2446-h4",
        "value": "康定市",
        "text": "康定市"
      }, {
        "id": "2447-Pg",
        "value": "泸定县",
        "text": "泸定县"
      }, {
        "id": "2448-Ev",
        "value": "丹巴县",
        "text": "丹巴县"
      }, {
        "id": "2449-MJ",
        "value": "九龙县",
        "text": "九龙县"
      }, {
        "id": "2450-nS",
        "value": "雅江县",
        "text": "雅江县"
      }, {
        "id": "2451-cz",
        "value": "道孚县",
        "text": "道孚县"
      }, {
        "id": "2452-OO",
        "value": "炉霍县",
        "text": "炉霍县"
      }, {
        "id": "2453-RH",
        "value": "甘孜县",
        "text": "甘孜县"
      }, {
        "id": "2454-gc",
        "value": "新龙县",
        "text": "新龙县"
      }, {
        "id": "2455-B0",
        "value": "德格县",
        "text": "德格县"
      }, {
        "id": "2456-Hi",
        "value": "白玉县",
        "text": "白玉县"
      }, {
        "id": "2457-e6",
        "value": "石渠县",
        "text": "石渠县"
      }, {
        "id": "2458-KB",
        "value": "色达县",
        "text": "色达县"
      }, {
        "id": "2459-aM",
        "value": "理塘县",
        "text": "理塘县"
      }, {
        "id": "2460-kA",
        "value": "巴塘县",
        "text": "巴塘县"
      }, {
        "id": "2461-Z1",
        "value": "乡城县",
        "text": "乡城县"
      }, {
        "id": "2462-Vs",
        "value": "稻城县",
        "text": "稻城县"
      }, {
        "id": "2463-VS",
        "value": "得荣县",
        "text": "得荣县"
      } ],
      "id": "2445-Lw",
      "value": "甘孜藏族自治州",
      "text": "甘孜藏族自治州"
    }, {
      "children": [ {
        "id": "2465-Vt",
        "value": "西昌市",
        "text": "西昌市"
      }, {
        "id": "2466-aI",
        "value": "木里藏族自治县",
        "text": "木里藏族自治县"
      }, {
        "id": "2467-nP",
        "value": "盐源县",
        "text": "盐源县"
      }, {
        "id": "2468-7c",
        "value": "德昌县",
        "text": "德昌县"
      }, {
        "id": "2469-Eq",
        "value": "会理县",
        "text": "会理县"
      }, {
        "id": "2470-w3",
        "value": "会东县",
        "text": "会东县"
      }, {
        "id": "2471-51",
        "value": "宁南县",
        "text": "宁南县"
      }, {
        "id": "2472-Kc",
        "value": "普格县",
        "text": "普格县"
      }, {
        "id": "2473-6D",
        "value": "布拖县",
        "text": "布拖县"
      }, {
        "id": "2474-Bd",
        "value": "金阳县",
        "text": "金阳县"
      }, {
        "id": "2475-IN",
        "value": "昭觉县",
        "text": "昭觉县"
      }, {
        "id": "2476-8X",
        "value": "喜德县",
        "text": "喜德县"
      }, {
        "id": "2477-A5",
        "value": "冕宁县",
        "text": "冕宁县"
      }, {
        "id": "2478-A7",
        "value": "越西县",
        "text": "越西县"
      }, {
        "id": "2479-vB",
        "value": "甘洛县",
        "text": "甘洛县"
      }, {
        "id": "2480-Kc",
        "value": "美姑县",
        "text": "美姑县"
      }, {
        "id": "2481-Id",
        "value": "雷波县",
        "text": "雷波县"
      } ],
      "id": "2464-bx",
      "value": "凉山彝族自治州",
      "text": "凉山彝族自治州"
    } ],
    "id": "2277-gJ",
    "value": "四川省",
    "text": "四川省"
  }, {
    "children": [ {
      "children": [ {
        "id": "2484-xw",
        "value": "南明区",
        "text": "南明区"
      }, {
        "id": "2485-tx",
        "value": "云岩区",
        "text": "云岩区"
      }, {
        "id": "2486-7e",
        "value": "花溪区",
        "text": "花溪区"
      }, {
        "id": "2487-8d",
        "value": "乌当区",
        "text": "乌当区"
      }, {
        "id": "2488-7s",
        "value": "白云区",
        "text": "白云区"
      }, {
        "id": "2489-qJ",
        "value": "观山湖区",
        "text": "观山湖区"
      }, {
        "id": "2490-Lq",
        "value": "开阳县",
        "text": "开阳县"
      }, {
        "id": "2491-qV",
        "value": "息烽县",
        "text": "息烽县"
      }, {
        "id": "2492-9R",
        "value": "修文县",
        "text": "修文县"
      }, {
        "id": "2493-dy",
        "value": "清镇市",
        "text": "清镇市"
      } ],
      "id": "2483-nd",
      "value": "贵阳市",
      "text": "贵阳市"
    }, {
      "children": [ {
        "id": "2495-YX",
        "value": "钟山区",
        "text": "钟山区"
      }, {
        "id": "2496-8v",
        "value": "六枝特区",
        "text": "六枝特区"
      }, {
        "id": "2497-SX",
        "value": "水城县",
        "text": "水城县"
      }, {
        "id": "2498-3W",
        "value": "盘县",
        "text": "盘县"
      } ],
      "id": "2494-90",
      "value": "六盘水市",
      "text": "六盘水市"
    }, {
      "children": [ {
        "id": "2500-Y5",
        "value": "红花岗区",
        "text": "红花岗区"
      }, {
        "id": "2501-T5",
        "value": "汇川区",
        "text": "汇川区"
      }, {
        "id": "2502-UC",
        "value": "播州区",
        "text": "播州区"
      }, {
        "id": "2503-Yg",
        "value": "桐梓县",
        "text": "桐梓县"
      }, {
        "id": "2504-Ej",
        "value": "绥阳县",
        "text": "绥阳县"
      }, {
        "id": "2505-2R",
        "value": "正安县",
        "text": "正安县"
      }, {
        "id": "2506-ym",
        "value": "道真仡佬族苗族自治县",
        "text": "道真仡佬族苗族自治县"
      }, {
        "id": "2507-0y",
        "value": "务川仡佬族苗族自治县",
        "text": "务川仡佬族苗族自治县"
      }, {
        "id": "2508-0Z",
        "value": "凤冈县",
        "text": "凤冈县"
      }, {
        "id": "2509-py",
        "value": "湄潭县",
        "text": "湄潭县"
      }, {
        "id": "2510-AQ",
        "value": "余庆县",
        "text": "余庆县"
      }, {
        "id": "2511-oL",
        "value": "习水县",
        "text": "习水县"
      }, {
        "id": "2512-14",
        "value": "赤水市",
        "text": "赤水市"
      }, {
        "id": "2513-NW",
        "value": "仁怀市",
        "text": "仁怀市"
      } ],
      "id": "2499-Wu",
      "value": "遵义市",
      "text": "遵义市"
    }, {
      "children": [ {
        "id": "2515-Yg",
        "value": "西秀区",
        "text": "西秀区"
      }, {
        "id": "2516-T2",
        "value": "平坝区",
        "text": "平坝区"
      }, {
        "id": "2517-TS",
        "value": "普定县",
        "text": "普定县"
      }, {
        "id": "2518-jl",
        "value": "镇宁布依族苗族自治县",
        "text": "镇宁布依族苗族自治县"
      }, {
        "id": "2519-De",
        "value": "关岭布依族苗族自治县",
        "text": "关岭布依族苗族自治县"
      }, {
        "id": "2520-5S",
        "value": "紫云苗族布依族自治县",
        "text": "紫云苗族布依族自治县"
      } ],
      "id": "2514-v2",
      "value": "安顺市",
      "text": "安顺市"
    }, {
      "children": [ {
        "id": "2522-eu",
        "value": "七星关区",
        "text": "七星关区"
      }, {
        "id": "2523-Od",
        "value": "大方县",
        "text": "大方县"
      }, {
        "id": "2524-rl",
        "value": "黔西县",
        "text": "黔西县"
      }, {
        "id": "2525-Xt",
        "value": "金沙县",
        "text": "金沙县"
      }, {
        "id": "2526-8M",
        "value": "织金县",
        "text": "织金县"
      }, {
        "id": "2527-dl",
        "value": "纳雍县",
        "text": "纳雍县"
      }, {
        "id": "2528-IY",
        "value": "威宁彝族回族苗族自治县",
        "text": "威宁彝族回族苗族自治县"
      }, {
        "id": "2529-sV",
        "value": "赫章县",
        "text": "赫章县"
      } ],
      "id": "2521-cD",
      "value": "毕节市",
      "text": "毕节市"
    }, {
      "children": [ {
        "id": "2531-x8",
        "value": "碧江区",
        "text": "碧江区"
      }, {
        "id": "2532-LY",
        "value": "万山区",
        "text": "万山区"
      }, {
        "id": "2533-0t",
        "value": "江口县",
        "text": "江口县"
      }, {
        "id": "2534-XY",
        "value": "玉屏侗族自治县",
        "text": "玉屏侗族自治县"
      }, {
        "id": "2535-4I",
        "value": "石阡县",
        "text": "石阡县"
      }, {
        "id": "2536-9n",
        "value": "思南县",
        "text": "思南县"
      }, {
        "id": "2537-VT",
        "value": "印江土家族苗族自治县",
        "text": "印江土家族苗族自治县"
      }, {
        "id": "2538-rh",
        "value": "德江县",
        "text": "德江县"
      }, {
        "id": "2539-fy",
        "value": "沿河土家族自治县",
        "text": "沿河土家族自治县"
      }, {
        "id": "2540-si",
        "value": "松桃苗族自治县",
        "text": "松桃苗族自治县"
      } ],
      "id": "2530-FY",
      "value": "铜仁市",
      "text": "铜仁市"
    }, {
      "children": [ {
        "id": "2542-ep",
        "value": "兴义市",
        "text": "兴义市"
      }, {
        "id": "2543-uJ",
        "value": "兴仁县",
        "text": "兴仁县"
      }, {
        "id": "2544-7j",
        "value": "普安县",
        "text": "普安县"
      }, {
        "id": "2545-yF",
        "value": "晴隆县",
        "text": "晴隆县"
      }, {
        "id": "2546-Yt",
        "value": "贞丰县",
        "text": "贞丰县"
      }, {
        "id": "2547-S5",
        "value": "望谟县",
        "text": "望谟县"
      }, {
        "id": "2548-4J",
        "value": "册亨县",
        "text": "册亨县"
      }, {
        "id": "2549-xy",
        "value": "安龙县",
        "text": "安龙县"
      } ],
      "id": "2541-h5",
      "value": "黔西南布依族苗族自治州",
      "text": "黔西南布依族苗族自治州"
    }, {
      "children": [ {
        "id": "2551-2e",
        "value": "凯里市",
        "text": "凯里市"
      }, {
        "id": "2552-LU",
        "value": "黄平县",
        "text": "黄平县"
      }, {
        "id": "2553-R3",
        "value": "施秉县",
        "text": "施秉县"
      }, {
        "id": "2554-h6",
        "value": "三穗县",
        "text": "三穗县"
      }, {
        "id": "2555-lZ",
        "value": "镇远县",
        "text": "镇远县"
      }, {
        "id": "2556-QX",
        "value": "岑巩县",
        "text": "岑巩县"
      }, {
        "id": "2557-Jp",
        "value": "天柱县",
        "text": "天柱县"
      }, {
        "id": "2558-V1",
        "value": "锦屏县",
        "text": "锦屏县"
      }, {
        "id": "2559-4D",
        "value": "剑河县",
        "text": "剑河县"
      }, {
        "id": "2560-qb",
        "value": "台江县",
        "text": "台江县"
      }, {
        "id": "2561-J2",
        "value": "黎平县",
        "text": "黎平县"
      }, {
        "id": "2562-14",
        "value": "榕江县",
        "text": "榕江县"
      }, {
        "id": "2563-rM",
        "value": "从江县",
        "text": "从江县"
      }, {
        "id": "2564-rx",
        "value": "雷山县",
        "text": "雷山县"
      }, {
        "id": "2565-mK",
        "value": "麻江县",
        "text": "麻江县"
      }, {
        "id": "2566-H3",
        "value": "丹寨县",
        "text": "丹寨县"
      } ],
      "id": "2550-8A",
      "value": "黔东南苗族侗族自治州",
      "text": "黔东南苗族侗族自治州"
    }, {
      "children": [ {
        "id": "2568-Ht",
        "value": "都匀市",
        "text": "都匀市"
      }, {
        "id": "2569-oS",
        "value": "福泉市",
        "text": "福泉市"
      }, {
        "id": "2570-eI",
        "value": "荔波县",
        "text": "荔波县"
      }, {
        "id": "2571-Kc",
        "value": "贵定县",
        "text": "贵定县"
      }, {
        "id": "2572-DS",
        "value": "瓮安县",
        "text": "瓮安县"
      }, {
        "id": "2573-3o",
        "value": "独山县",
        "text": "独山县"
      }, {
        "id": "2574-xJ",
        "value": "平塘县",
        "text": "平塘县"
      }, {
        "id": "2575-6d",
        "value": "罗甸县",
        "text": "罗甸县"
      }, {
        "id": "2576-2I",
        "value": "长顺县",
        "text": "长顺县"
      }, {
        "id": "2577-7c",
        "value": "龙里县",
        "text": "龙里县"
      }, {
        "id": "2578-tq",
        "value": "惠水县",
        "text": "惠水县"
      }, {
        "id": "2579-Ul",
        "value": "三都水族自治县",
        "text": "三都水族自治县"
      } ],
      "id": "2567-mP",
      "value": "黔南布依族苗族自治州",
      "text": "黔南布依族苗族自治州"
    } ],
    "id": "2482-jR",
    "value": "贵州省",
    "text": "贵州省"
  }, {
    "children": [ {
      "children": [ {
        "id": "2582-B4",
        "value": "五华区",
        "text": "五华区"
      }, {
        "id": "2583-uf",
        "value": "盘龙区",
        "text": "盘龙区"
      }, {
        "id": "2584-Cl",
        "value": "官渡区",
        "text": "官渡区"
      }, {
        "id": "2585-eG",
        "value": "西山区",
        "text": "西山区"
      }, {
        "id": "2586-Zb",
        "value": "东川区",
        "text": "东川区"
      }, {
        "id": "2587-vk",
        "value": "呈贡区",
        "text": "呈贡区"
      }, {
        "id": "2588-v8",
        "value": "晋宁县",
        "text": "晋宁县"
      }, {
        "id": "2589-0n",
        "value": "富民县",
        "text": "富民县"
      }, {
        "id": "2590-OA",
        "value": "宜良县",
        "text": "宜良县"
      }, {
        "id": "2591-3J",
        "value": "石林彝族自治县",
        "text": "石林彝族自治县"
      }, {
        "id": "2592-Ws",
        "value": "嵩明县",
        "text": "嵩明县"
      }, {
        "id": "2593-i0",
        "value": "禄劝彝族苗族自治县",
        "text": "禄劝彝族苗族自治县"
      }, {
        "id": "2594-cE",
        "value": "寻甸回族彝族自治县",
        "text": "寻甸回族彝族自治县"
      }, {
        "id": "2595-CR",
        "value": "安宁市",
        "text": "安宁市"
      } ],
      "id": "2581-xk",
      "value": "昆明市",
      "text": "昆明市"
    }, {
      "children": [ {
        "id": "2597-Wi",
        "value": "麒麟区",
        "text": "麒麟区"
      }, {
        "id": "2598-87",
        "value": "沾益区",
        "text": "沾益区"
      }, {
        "id": "2599-pz",
        "value": "马龙县",
        "text": "马龙县"
      }, {
        "id": "2600-1M",
        "value": "陆良县",
        "text": "陆良县"
      }, {
        "id": "2601-i8",
        "value": "师宗县",
        "text": "师宗县"
      }, {
        "id": "2602-AZ",
        "value": "罗平县",
        "text": "罗平县"
      }, {
        "id": "2603-8D",
        "value": "富源县",
        "text": "富源县"
      }, {
        "id": "2604-WM",
        "value": "会泽县",
        "text": "会泽县"
      }, {
        "id": "2605-RR",
        "value": "宣威市",
        "text": "宣威市"
      } ],
      "id": "2596-Pt",
      "value": "曲靖市",
      "text": "曲靖市"
    }, {
      "children": [ {
        "id": "2607-9P",
        "value": "红塔区",
        "text": "红塔区"
      }, {
        "id": "2608-cN",
        "value": "江川区",
        "text": "江川区"
      }, {
        "id": "2609-x7",
        "value": "澄江县",
        "text": "澄江县"
      }, {
        "id": "2610-Hp",
        "value": "通海县",
        "text": "通海县"
      }, {
        "id": "2611-Or",
        "value": "华宁县",
        "text": "华宁县"
      }, {
        "id": "2612-ak",
        "value": "易门县",
        "text": "易门县"
      }, {
        "id": "2613-Vh",
        "value": "峨山彝族自治县",
        "text": "峨山彝族自治县"
      }, {
        "id": "2614-Pq",
        "value": "新平彝族傣族自治县",
        "text": "新平彝族傣族自治县"
      }, {
        "id": "2615-No",
        "value": "元江哈尼族彝族傣族自治县",
        "text": "元江哈尼族彝族傣族自治县"
      } ],
      "id": "2606-Qi",
      "value": "玉溪市",
      "text": "玉溪市"
    }, {
      "children": [ {
        "id": "2617-9c",
        "value": "隆阳区",
        "text": "隆阳区"
      }, {
        "id": "2618-8B",
        "value": "施甸县",
        "text": "施甸县"
      }, {
        "id": "2619-PC",
        "value": "龙陵县",
        "text": "龙陵县"
      }, {
        "id": "2620-vm",
        "value": "昌宁县",
        "text": "昌宁县"
      }, {
        "id": "2621-KW",
        "value": "腾冲市",
        "text": "腾冲市"
      } ],
      "id": "2616-gc",
      "value": "保山市",
      "text": "保山市"
    }, {
      "children": [ {
        "id": "2623-2T",
        "value": "昭阳区",
        "text": "昭阳区"
      }, {
        "id": "2624-9q",
        "value": "鲁甸县",
        "text": "鲁甸县"
      }, {
        "id": "2625-Vb",
        "value": "巧家县",
        "text": "巧家县"
      }, {
        "id": "2626-HS",
        "value": "盐津县",
        "text": "盐津县"
      }, {
        "id": "2627-el",
        "value": "大关县",
        "text": "大关县"
      }, {
        "id": "2628-O0",
        "value": "永善县",
        "text": "永善县"
      }, {
        "id": "2629-R8",
        "value": "绥江县",
        "text": "绥江县"
      }, {
        "id": "2630-bz",
        "value": "镇雄县",
        "text": "镇雄县"
      }, {
        "id": "2631-2W",
        "value": "彝良县",
        "text": "彝良县"
      }, {
        "id": "2632-Ln",
        "value": "威信县",
        "text": "威信县"
      }, {
        "id": "2633-v6",
        "value": "水富县",
        "text": "水富县"
      } ],
      "id": "2622-o7",
      "value": "昭通市",
      "text": "昭通市"
    }, {
      "children": [ {
        "id": "2635-pR",
        "value": "古城区",
        "text": "古城区"
      }, {
        "id": "2636-hu",
        "value": "玉龙纳西族自治县",
        "text": "玉龙纳西族自治县"
      }, {
        "id": "2637-rO",
        "value": "永胜县",
        "text": "永胜县"
      }, {
        "id": "2638-eK",
        "value": "华坪县",
        "text": "华坪县"
      }, {
        "id": "2639-QV",
        "value": "宁蒗彝族自治县",
        "text": "宁蒗彝族自治县"
      } ],
      "id": "2634-lc",
      "value": "丽江市",
      "text": "丽江市"
    }, {
      "children": [ {
        "id": "2641-4X",
        "value": "思茅区",
        "text": "思茅区"
      }, {
        "id": "2642-Iz",
        "value": "宁洱哈尼族彝族自治县",
        "text": "宁洱哈尼族彝族自治县"
      }, {
        "id": "2643-8S",
        "value": "墨江哈尼族自治县",
        "text": "墨江哈尼族自治县"
      }, {
        "id": "2644-jl",
        "value": "景东彝族自治县",
        "text": "景东彝族自治县"
      }, {
        "id": "2645-Z3",
        "value": "景谷傣族彝族自治县",
        "text": "景谷傣族彝族自治县"
      }, {
        "id": "2646-90",
        "value": "镇沅彝族哈尼族拉祜族自治县",
        "text": "镇沅彝族哈尼族拉祜族自治县"
      }, {
        "id": "2647-In",
        "value": "江城哈尼族彝族自治县",
        "text": "江城哈尼族彝族自治县"
      }, {
        "id": "2648-qD",
        "value": "孟连傣族拉祜族佤族自治县",
        "text": "孟连傣族拉祜族佤族自治县"
      }, {
        "id": "2649-iI",
        "value": "澜沧拉祜族自治县",
        "text": "澜沧拉祜族自治县"
      }, {
        "id": "2650-pL",
        "value": "西盟佤族自治县",
        "text": "西盟佤族自治县"
      } ],
      "id": "2640-oI",
      "value": "普洱市",
      "text": "普洱市"
    }, {
      "children": [ {
        "id": "2652-RL",
        "value": "临翔区",
        "text": "临翔区"
      }, {
        "id": "2653-XT",
        "value": "凤庆县",
        "text": "凤庆县"
      }, {
        "id": "2654-kc",
        "value": "云县",
        "text": "云县"
      }, {
        "id": "2655-sB",
        "value": "永德县",
        "text": "永德县"
      }, {
        "id": "2656-KE",
        "value": "镇康县",
        "text": "镇康县"
      }, {
        "id": "2657-mH",
        "value": "双江拉祜族佤族布朗族傣族自治县",
        "text": "双江拉祜族佤族布朗族傣族自治县"
      }, {
        "id": "2658-uX",
        "value": "耿马傣族佤族自治县",
        "text": "耿马傣族佤族自治县"
      }, {
        "id": "2659-S9",
        "value": "沧源佤族自治县",
        "text": "沧源佤族自治县"
      } ],
      "id": "2651-Np",
      "value": "临沧市",
      "text": "临沧市"
    }, {
      "children": [ {
        "id": "2661-8n",
        "value": "楚雄市",
        "text": "楚雄市"
      }, {
        "id": "2662-Rl",
        "value": "双柏县",
        "text": "双柏县"
      }, {
        "id": "2663-S3",
        "value": "牟定县",
        "text": "牟定县"
      }, {
        "id": "2664-bi",
        "value": "南华县",
        "text": "南华县"
      }, {
        "id": "2665-wj",
        "value": "姚安县",
        "text": "姚安县"
      }, {
        "id": "2666-qV",
        "value": "大姚县",
        "text": "大姚县"
      }, {
        "id": "2667-VU",
        "value": "永仁县",
        "text": "永仁县"
      }, {
        "id": "2668-aW",
        "value": "元谋县",
        "text": "元谋县"
      }, {
        "id": "2669-td",
        "value": "武定县",
        "text": "武定县"
      }, {
        "id": "2670-og",
        "value": "禄丰县",
        "text": "禄丰县"
      } ],
      "id": "2660-Uw",
      "value": "楚雄彝族自治州",
      "text": "楚雄彝族自治州"
    }, {
      "children": [ {
        "id": "2672-Ul",
        "value": "个旧市",
        "text": "个旧市"
      }, {
        "id": "2673-hv",
        "value": "开远市",
        "text": "开远市"
      }, {
        "id": "2674-GG",
        "value": "蒙自市",
        "text": "蒙自市"
      }, {
        "id": "2675-Kp",
        "value": "弥勒市",
        "text": "弥勒市"
      }, {
        "id": "2676-E1",
        "value": "屏边苗族自治县",
        "text": "屏边苗族自治县"
      }, {
        "id": "2677-SJ",
        "value": "建水县",
        "text": "建水县"
      }, {
        "id": "2678-gv",
        "value": "石屏县",
        "text": "石屏县"
      }, {
        "id": "2679-or",
        "value": "泸西县",
        "text": "泸西县"
      }, {
        "id": "2680-Da",
        "value": "元阳县",
        "text": "元阳县"
      }, {
        "id": "2681-Uf",
        "value": "红河县",
        "text": "红河县"
      }, {
        "id": "2682-Lb",
        "value": "金平苗族瑶族傣族自治县",
        "text": "金平苗族瑶族傣族自治县"
      }, {
        "id": "2683-J9",
        "value": "绿春县",
        "text": "绿春县"
      }, {
        "id": "2684-Ng",
        "value": "河口瑶族自治县",
        "text": "河口瑶族自治县"
      } ],
      "id": "2671-WM",
      "value": "红河哈尼族彝族自治州",
      "text": "红河哈尼族彝族自治州"
    }, {
      "children": [ {
        "id": "2686-nF",
        "value": "文山市",
        "text": "文山市"
      }, {
        "id": "2687-Rx",
        "value": "砚山县",
        "text": "砚山县"
      }, {
        "id": "2688-Qv",
        "value": "西畴县",
        "text": "西畴县"
      }, {
        "id": "2689-jQ",
        "value": "麻栗坡县",
        "text": "麻栗坡县"
      }, {
        "id": "2690-fH",
        "value": "马关县",
        "text": "马关县"
      }, {
        "id": "2691-w5",
        "value": "丘北县",
        "text": "丘北县"
      }, {
        "id": "2692-Mw",
        "value": "广南县",
        "text": "广南县"
      }, {
        "id": "2693-cy",
        "value": "富宁县",
        "text": "富宁县"
      } ],
      "id": "2685-Rv",
      "value": "文山壮族苗族自治州",
      "text": "文山壮族苗族自治州"
    }, {
      "children": [ {
        "id": "2695-WJ",
        "value": "景洪市",
        "text": "景洪市"
      }, {
        "id": "2696-yu",
        "value": "勐海县",
        "text": "勐海县"
      }, {
        "id": "2697-Zy",
        "value": "勐腊县",
        "text": "勐腊县"
      } ],
      "id": "2694-Op",
      "value": "西双版纳傣族自治州",
      "text": "西双版纳傣族自治州"
    }, {
      "children": [ {
        "id": "2699-Wo",
        "value": "大理市",
        "text": "大理市"
      }, {
        "id": "2700-18",
        "value": "漾濞彝族自治县",
        "text": "漾濞彝族自治县"
      }, {
        "id": "2701-x8",
        "value": "祥云县",
        "text": "祥云县"
      }, {
        "id": "2702-0v",
        "value": "宾川县",
        "text": "宾川县"
      }, {
        "id": "2703-mD",
        "value": "弥渡县",
        "text": "弥渡县"
      }, {
        "id": "2704-Mp",
        "value": "南涧彝族自治县",
        "text": "南涧彝族自治县"
      }, {
        "id": "2705-NM",
        "value": "巍山彝族回族自治县",
        "text": "巍山彝族回族自治县"
      }, {
        "id": "2706-VK",
        "value": "永平县",
        "text": "永平县"
      }, {
        "id": "2707-mu",
        "value": "云龙县",
        "text": "云龙县"
      }, {
        "id": "2708-Ys",
        "value": "洱源县",
        "text": "洱源县"
      }, {
        "id": "2709-1r",
        "value": "剑川县",
        "text": "剑川县"
      }, {
        "id": "2710-mi",
        "value": "鹤庆县",
        "text": "鹤庆县"
      } ],
      "id": "2698-d8",
      "value": "大理白族自治州",
      "text": "大理白族自治州"
    }, {
      "children": [ {
        "id": "2712-tN",
        "value": "瑞丽市",
        "text": "瑞丽市"
      }, {
        "id": "2713-UG",
        "value": "芒市",
        "text": "芒市"
      }, {
        "id": "2714-Y3",
        "value": "梁河县",
        "text": "梁河县"
      }, {
        "id": "2715-sR",
        "value": "盈江县",
        "text": "盈江县"
      }, {
        "id": "2716-NR",
        "value": "陇川县",
        "text": "陇川县"
      } ],
      "id": "2711-Vv",
      "value": "德宏傣族景颇族自治州",
      "text": "德宏傣族景颇族自治州"
    }, {
      "children": [ {
        "id": "2718-Cc",
        "value": "泸水市",
        "text": "泸水市"
      }, {
        "id": "2719-do",
        "value": "福贡县",
        "text": "福贡县"
      }, {
        "id": "2720-96",
        "value": "贡山独龙族怒族自治县",
        "text": "贡山独龙族怒族自治县"
      }, {
        "id": "2721-S9",
        "value": "兰坪白族普米族自治县",
        "text": "兰坪白族普米族自治县"
      } ],
      "id": "2717-mb",
      "value": "怒江傈僳族自治州",
      "text": "怒江傈僳族自治州"
    }, {
      "children": [ {
        "id": "2723-on",
        "value": "香格里拉市",
        "text": "香格里拉市"
      }, {
        "id": "2724-km",
        "value": "德钦县",
        "text": "德钦县"
      }, {
        "id": "2725-Kc",
        "value": "维西傈僳族自治县",
        "text": "维西傈僳族自治县"
      } ],
      "id": "2722-Od",
      "value": "迪庆藏族自治州",
      "text": "迪庆藏族自治州"
    } ],
    "id": "2580-UA",
    "value": "云南省",
    "text": "云南省"
  }, {
    "children": [ {
      "children": [ {
        "id": "2728-wp",
        "value": "城关区",
        "text": "城关区"
      }, {
        "id": "2729-vO",
        "value": "堆龙德庆区",
        "text": "堆龙德庆区"
      }, {
        "id": "2730-UO",
        "value": "林周县",
        "text": "林周县"
      }, {
        "id": "2731-dH",
        "value": "当雄县",
        "text": "当雄县"
      }, {
        "id": "2732-0u",
        "value": "尼木县",
        "text": "尼木县"
      }, {
        "id": "2733-1E",
        "value": "曲水县",
        "text": "曲水县"
      }, {
        "id": "2734-aH",
        "value": "达孜县",
        "text": "达孜县"
      }, {
        "id": "2735-Sj",
        "value": "墨竹工卡县",
        "text": "墨竹工卡县"
      } ],
      "id": "2727-Tn",
      "value": "拉萨市",
      "text": "拉萨市"
    }, {
      "children": [ {
        "id": "2737-tg",
        "value": "桑珠孜区",
        "text": "桑珠孜区"
      }, {
        "id": "2738-x7",
        "value": "南木林县",
        "text": "南木林县"
      }, {
        "id": "2739-6Z",
        "value": "江孜县",
        "text": "江孜县"
      }, {
        "id": "2740-HW",
        "value": "定日县",
        "text": "定日县"
      }, {
        "id": "2741-GV",
        "value": "萨迦县",
        "text": "萨迦县"
      }, {
        "id": "2742-WS",
        "value": "拉孜县",
        "text": "拉孜县"
      }, {
        "id": "2743-Cq",
        "value": "昂仁县",
        "text": "昂仁县"
      }, {
        "id": "2744-l2",
        "value": "谢通门县",
        "text": "谢通门县"
      }, {
        "id": "2745-K7",
        "value": "白朗县",
        "text": "白朗县"
      }, {
        "id": "2746-D5",
        "value": "仁布县",
        "text": "仁布县"
      }, {
        "id": "2747-Aj",
        "value": "康马县",
        "text": "康马县"
      }, {
        "id": "2748-tF",
        "value": "定结县",
        "text": "定结县"
      }, {
        "id": "2749-4m",
        "value": "仲巴县",
        "text": "仲巴县"
      }, {
        "id": "2750-LA",
        "value": "亚东县",
        "text": "亚东县"
      }, {
        "id": "2751-Fd",
        "value": "吉隆县",
        "text": "吉隆县"
      }, {
        "id": "2752-Oc",
        "value": "聂拉木县",
        "text": "聂拉木县"
      }, {
        "id": "2753-1G",
        "value": "萨嘎县",
        "text": "萨嘎县"
      }, {
        "id": "2754-VH",
        "value": "岗巴县",
        "text": "岗巴县"
      } ],
      "id": "2736-t3",
      "value": "日喀则市",
      "text": "日喀则市"
    }, {
      "children": [ {
        "id": "2756-h5",
        "value": "卡若区",
        "text": "卡若区"
      }, {
        "id": "2757-R7",
        "value": "江达县",
        "text": "江达县"
      }, {
        "id": "2758-W9",
        "value": "贡觉县",
        "text": "贡觉县"
      }, {
        "id": "2759-cX",
        "value": "类乌齐县",
        "text": "类乌齐县"
      }, {
        "id": "2760-AV",
        "value": "丁青县",
        "text": "丁青县"
      }, {
        "id": "2761-68",
        "value": "察雅县",
        "text": "察雅县"
      }, {
        "id": "2762-2D",
        "value": "八宿县",
        "text": "八宿县"
      }, {
        "id": "2763-bt",
        "value": "左贡县",
        "text": "左贡县"
      }, {
        "id": "2764-Br",
        "value": "芒康县",
        "text": "芒康县"
      }, {
        "id": "2765-5y",
        "value": "洛隆县",
        "text": "洛隆县"
      }, {
        "id": "2766-az",
        "value": "边坝县",
        "text": "边坝县"
      } ],
      "id": "2755-Q8",
      "value": "昌都市",
      "text": "昌都市"
    }, {
      "children": [ {
        "id": "2768-K9",
        "value": "巴宜区",
        "text": "巴宜区"
      }, {
        "id": "2769-dp",
        "value": "工布江达县",
        "text": "工布江达县"
      }, {
        "id": "2770-Mr",
        "value": "米林县",
        "text": "米林县"
      }, {
        "id": "2771-L2",
        "value": "墨脱县",
        "text": "墨脱县"
      }, {
        "id": "2772-3i",
        "value": "波密县",
        "text": "波密县"
      }, {
        "id": "2773-wT",
        "value": "察隅县",
        "text": "察隅县"
      }, {
        "id": "2774-Tm",
        "value": "朗县",
        "text": "朗县"
      } ],
      "id": "2767-gk",
      "value": "林芝市",
      "text": "林芝市"
    }, {
      "children": [ {
        "id": "2776-Ed",
        "value": "乃东区",
        "text": "乃东区"
      }, {
        "id": "2777-KN",
        "value": "扎囊县",
        "text": "扎囊县"
      }, {
        "id": "2778-7r",
        "value": "贡嘎县",
        "text": "贡嘎县"
      }, {
        "id": "2779-4T",
        "value": "桑日县",
        "text": "桑日县"
      }, {
        "id": "2780-qu",
        "value": "琼结县",
        "text": "琼结县"
      }, {
        "id": "2781-A0",
        "value": "曲松县",
        "text": "曲松县"
      }, {
        "id": "2782-iS",
        "value": "措美县",
        "text": "措美县"
      }, {
        "id": "2783-pn",
        "value": "洛扎县",
        "text": "洛扎县"
      }, {
        "id": "2784-g3",
        "value": "加查县",
        "text": "加查县"
      }, {
        "id": "2785-k4",
        "value": "隆子县",
        "text": "隆子县"
      }, {
        "id": "2786-JR",
        "value": "错那县",
        "text": "错那县"
      }, {
        "id": "2787-7t",
        "value": "浪卡子县",
        "text": "浪卡子县"
      } ],
      "id": "2775-BY",
      "value": "山南市",
      "text": "山南市"
    }, {
      "children": [ {
        "id": "2789-uM",
        "value": "那曲县",
        "text": "那曲县"
      }, {
        "id": "2790-l7",
        "value": "嘉黎县",
        "text": "嘉黎县"
      }, {
        "id": "2791-FV",
        "value": "比如县",
        "text": "比如县"
      }, {
        "id": "2792-3b",
        "value": "聂荣县",
        "text": "聂荣县"
      }, {
        "id": "2793-43",
        "value": "安多县",
        "text": "安多县"
      }, {
        "id": "2794-xC",
        "value": "申扎县",
        "text": "申扎县"
      }, {
        "id": "2795-I6",
        "value": "索县",
        "text": "索县"
      }, {
        "id": "2796-8t",
        "value": "班戈县",
        "text": "班戈县"
      }, {
        "id": "2797-20",
        "value": "巴青县",
        "text": "巴青县"
      }, {
        "id": "2798-h2",
        "value": "尼玛县",
        "text": "尼玛县"
      }, {
        "id": "2799-4y",
        "value": "双湖县",
        "text": "双湖县"
      } ],
      "id": "2788-kq",
      "value": "那曲地区",
      "text": "那曲地区"
    }, {
      "children": [ {
        "id": "2801-RX",
        "value": "普兰县",
        "text": "普兰县"
      }, {
        "id": "2802-kT",
        "value": "札达县",
        "text": "札达县"
      }, {
        "id": "2803-G3",
        "value": "噶尔县",
        "text": "噶尔县"
      }, {
        "id": "2804-cL",
        "value": "日土县",
        "text": "日土县"
      }, {
        "id": "2805-dz",
        "value": "革吉县",
        "text": "革吉县"
      }, {
        "id": "2806-Ii",
        "value": "改则县",
        "text": "改则县"
      }, {
        "id": "2807-eS",
        "value": "措勤县",
        "text": "措勤县"
      } ],
      "id": "2800-Eb",
      "value": "阿里地区",
      "text": "阿里地区"
    } ],
    "id": "2726-3h",
    "value": "西藏自治区",
    "text": "西藏自治区"
  }, {
    "children": [ {
      "children": [ {
        "id": "2810-xr",
        "value": "新城区",
        "text": "新城区"
      }, {
        "id": "2811-mb",
        "value": "碑林区",
        "text": "碑林区"
      }, {
        "id": "2812-vY",
        "value": "莲湖区",
        "text": "莲湖区"
      }, {
        "id": "2813-5Q",
        "value": "灞桥区",
        "text": "灞桥区"
      }, {
        "id": "2814-xn",
        "value": "未央区",
        "text": "未央区"
      }, {
        "id": "2815-TN",
        "value": "雁塔区",
        "text": "雁塔区"
      }, {
        "id": "2816-xC",
        "value": "阎良区",
        "text": "阎良区"
      }, {
        "id": "2817-5V",
        "value": "临潼区",
        "text": "临潼区"
      }, {
        "id": "2818-KU",
        "value": "长安区",
        "text": "长安区"
      }, {
        "id": "2819-lJ",
        "value": "高陵区",
        "text": "高陵区"
      }, {
        "id": "2820-JJ",
        "value": "蓝田县",
        "text": "蓝田县"
      }, {
        "id": "2821-8J",
        "value": "周至县",
        "text": "周至县"
      }, {
        "id": "2822-8i",
        "value": "户县",
        "text": "户县"
      } ],
      "id": "2809-PT",
      "value": "西安市",
      "text": "西安市"
    }, {
      "children": [ {
        "id": "2824-iR",
        "value": "王益区",
        "text": "王益区"
      }, {
        "id": "2825-ta",
        "value": "印台区",
        "text": "印台区"
      }, {
        "id": "2826-DW",
        "value": "耀州区",
        "text": "耀州区"
      }, {
        "id": "2827-vI",
        "value": "宜君县",
        "text": "宜君县"
      } ],
      "id": "2823-PK",
      "value": "铜川市",
      "text": "铜川市"
    }, {
      "children": [ {
        "id": "2829-Bl",
        "value": "渭滨区",
        "text": "渭滨区"
      }, {
        "id": "2830-oH",
        "value": "金台区",
        "text": "金台区"
      }, {
        "id": "2831-4C",
        "value": "陈仓区",
        "text": "陈仓区"
      }, {
        "id": "2832-L5",
        "value": "凤翔县",
        "text": "凤翔县"
      }, {
        "id": "2833-kO",
        "value": "岐山县",
        "text": "岐山县"
      }, {
        "id": "2834-ar",
        "value": "扶风县",
        "text": "扶风县"
      }, {
        "id": "2835-jP",
        "value": "眉县",
        "text": "眉县"
      }, {
        "id": "2836-0P",
        "value": "陇县",
        "text": "陇县"
      }, {
        "id": "2837-BW",
        "value": "千阳县",
        "text": "千阳县"
      }, {
        "id": "2838-Nw",
        "value": "麟游县",
        "text": "麟游县"
      }, {
        "id": "2839-8X",
        "value": "凤县",
        "text": "凤县"
      }, {
        "id": "2840-oI",
        "value": "太白县",
        "text": "太白县"
      } ],
      "id": "2828-Pq",
      "value": "宝鸡市",
      "text": "宝鸡市"
    }, {
      "children": [ {
        "id": "2842-ZO",
        "value": "秦都区",
        "text": "秦都区"
      }, {
        "id": "2843-Ht",
        "value": "杨陵区",
        "text": "杨陵区"
      }, {
        "id": "2844-Gl",
        "value": "渭城区",
        "text": "渭城区"
      }, {
        "id": "2845-oH",
        "value": "三原县",
        "text": "三原县"
      }, {
        "id": "2846-6d",
        "value": "泾阳县",
        "text": "泾阳县"
      }, {
        "id": "2847-r3",
        "value": "乾县",
        "text": "乾县"
      }, {
        "id": "2848-xJ",
        "value": "礼泉县",
        "text": "礼泉县"
      }, {
        "id": "2849-v7",
        "value": "永寿县",
        "text": "永寿县"
      }, {
        "id": "2850-pe",
        "value": "彬县",
        "text": "彬县"
      }, {
        "id": "2851-ps",
        "value": "长武县",
        "text": "长武县"
      }, {
        "id": "2852-Z4",
        "value": "旬邑县",
        "text": "旬邑县"
      }, {
        "id": "2853-We",
        "value": "淳化县",
        "text": "淳化县"
      }, {
        "id": "2854-uW",
        "value": "武功县",
        "text": "武功县"
      }, {
        "id": "2855-uM",
        "value": "兴平市",
        "text": "兴平市"
      } ],
      "id": "2841-tE",
      "value": "咸阳市",
      "text": "咸阳市"
    }, {
      "children": [ {
        "id": "2857-1Z",
        "value": "临渭区",
        "text": "临渭区"
      }, {
        "id": "2858-Bn",
        "value": "华州区",
        "text": "华州区"
      }, {
        "id": "2859-ce",
        "value": "潼关县",
        "text": "潼关县"
      }, {
        "id": "2860-X5",
        "value": "大荔县",
        "text": "大荔县"
      }, {
        "id": "2861-kD",
        "value": "合阳县",
        "text": "合阳县"
      }, {
        "id": "2862-0b",
        "value": "澄城县",
        "text": "澄城县"
      }, {
        "id": "2863-FO",
        "value": "蒲城县",
        "text": "蒲城县"
      }, {
        "id": "2864-GF",
        "value": "白水县",
        "text": "白水县"
      }, {
        "id": "2865-RM",
        "value": "富平县",
        "text": "富平县"
      }, {
        "id": "2866-pw",
        "value": "韩城市",
        "text": "韩城市"
      }, {
        "id": "2867-Gs",
        "value": "华阴市",
        "text": "华阴市"
      } ],
      "id": "2856-IC",
      "value": "渭南市",
      "text": "渭南市"
    }, {
      "children": [ {
        "id": "2869-en",
        "value": "宝塔区",
        "text": "宝塔区"
      }, {
        "id": "2870-CB",
        "value": "安塞区",
        "text": "安塞区"
      }, {
        "id": "2871-mK",
        "value": "延长县",
        "text": "延长县"
      }, {
        "id": "2872-Dp",
        "value": "延川县",
        "text": "延川县"
      }, {
        "id": "2873-Si",
        "value": "子长县",
        "text": "子长县"
      }, {
        "id": "2874-Sp",
        "value": "志丹县",
        "text": "志丹县"
      }, {
        "id": "2875-z2",
        "value": "吴起县",
        "text": "吴起县"
      }, {
        "id": "2876-JJ",
        "value": "甘泉县",
        "text": "甘泉县"
      }, {
        "id": "2877-rV",
        "value": "富县",
        "text": "富县"
      }, {
        "id": "2878-76",
        "value": "洛川县",
        "text": "洛川县"
      }, {
        "id": "2879-vQ",
        "value": "宜川县",
        "text": "宜川县"
      }, {
        "id": "2880-oH",
        "value": "黄龙县",
        "text": "黄龙县"
      }, {
        "id": "2881-sS",
        "value": "黄陵县",
        "text": "黄陵县"
      } ],
      "id": "2868-tz",
      "value": "延安市",
      "text": "延安市"
    }, {
      "children": [ {
        "id": "2883-fv",
        "value": "汉台区",
        "text": "汉台区"
      }, {
        "id": "2884-Na",
        "value": "南郑县",
        "text": "南郑县"
      }, {
        "id": "2885-dH",
        "value": "城固县",
        "text": "城固县"
      }, {
        "id": "2886-Wi",
        "value": "洋县",
        "text": "洋县"
      }, {
        "id": "2887-HP",
        "value": "西乡县",
        "text": "西乡县"
      }, {
        "id": "2888-QP",
        "value": "勉县",
        "text": "勉县"
      }, {
        "id": "2889-no",
        "value": "宁强县",
        "text": "宁强县"
      }, {
        "id": "2890-J1",
        "value": "略阳县",
        "text": "略阳县"
      }, {
        "id": "2891-mp",
        "value": "镇巴县",
        "text": "镇巴县"
      }, {
        "id": "2892-nP",
        "value": "留坝县",
        "text": "留坝县"
      }, {
        "id": "2893-ZS",
        "value": "佛坪县",
        "text": "佛坪县"
      } ],
      "id": "2882-cO",
      "value": "汉中市",
      "text": "汉中市"
    }, {
      "children": [ {
        "id": "2895-S7",
        "value": "榆阳区",
        "text": "榆阳区"
      }, {
        "id": "2896-rF",
        "value": "横山区",
        "text": "横山区"
      }, {
        "id": "2897-S3",
        "value": "神木县",
        "text": "神木县"
      }, {
        "id": "2898-Bi",
        "value": "府谷县",
        "text": "府谷县"
      }, {
        "id": "2899-VQ",
        "value": "靖边县",
        "text": "靖边县"
      }, {
        "id": "2900-95",
        "value": "定边县",
        "text": "定边县"
      }, {
        "id": "2901-f2",
        "value": "绥德县",
        "text": "绥德县"
      }, {
        "id": "2902-4c",
        "value": "米脂县",
        "text": "米脂县"
      }, {
        "id": "2903-iA",
        "value": "佳县",
        "text": "佳县"
      }, {
        "id": "2904-X5",
        "value": "吴堡县",
        "text": "吴堡县"
      }, {
        "id": "2905-Q8",
        "value": "清涧县",
        "text": "清涧县"
      }, {
        "id": "2906-3g",
        "value": "子洲县",
        "text": "子洲县"
      } ],
      "id": "2894-uB",
      "value": "榆林市",
      "text": "榆林市"
    }, {
      "children": [ {
        "id": "2908-Wv",
        "value": "汉滨区",
        "text": "汉滨区"
      }, {
        "id": "2909-V7",
        "value": "汉阴县",
        "text": "汉阴县"
      }, {
        "id": "2910-QA",
        "value": "石泉县",
        "text": "石泉县"
      }, {
        "id": "2911-Dy",
        "value": "宁陕县",
        "text": "宁陕县"
      }, {
        "id": "2912-W7",
        "value": "紫阳县",
        "text": "紫阳县"
      }, {
        "id": "2913-dH",
        "value": "岚皋县",
        "text": "岚皋县"
      }, {
        "id": "2914-xQ",
        "value": "平利县",
        "text": "平利县"
      }, {
        "id": "2915-xw",
        "value": "镇坪县",
        "text": "镇坪县"
      }, {
        "id": "2916-nA",
        "value": "旬阳县",
        "text": "旬阳县"
      }, {
        "id": "2917-mI",
        "value": "白河县",
        "text": "白河县"
      } ],
      "id": "2907-zY",
      "value": "安康市",
      "text": "安康市"
    }, {
      "children": [ {
        "id": "2919-rm",
        "value": "商州区",
        "text": "商州区"
      }, {
        "id": "2920-Km",
        "value": "洛南县",
        "text": "洛南县"
      }, {
        "id": "2921-UP",
        "value": "丹凤县",
        "text": "丹凤县"
      }, {
        "id": "2922-S4",
        "value": "商南县",
        "text": "商南县"
      }, {
        "id": "2923-dC",
        "value": "山阳县",
        "text": "山阳县"
      }, {
        "id": "2924-jG",
        "value": "镇安县",
        "text": "镇安县"
      }, {
        "id": "2925-6W",
        "value": "柞水县",
        "text": "柞水县"
      } ],
      "id": "2918-2E",
      "value": "商洛市",
      "text": "商洛市"
    } ],
    "id": "2808-YP",
    "value": "陕西省",
    "text": "陕西省"
  }, {
    "children": [ {
      "children": [ {
        "id": "2928-FV",
        "value": "城关区",
        "text": "城关区"
      }, {
        "id": "2929-SK",
        "value": "七里河区",
        "text": "七里河区"
      }, {
        "id": "2930-a3",
        "value": "西固区",
        "text": "西固区"
      }, {
        "id": "2931-eN",
        "value": "安宁区",
        "text": "安宁区"
      }, {
        "id": "2932-4l",
        "value": "红古区",
        "text": "红古区"
      }, {
        "id": "2933-cG",
        "value": "永登县",
        "text": "永登县"
      }, {
        "id": "2934-Ef",
        "value": "皋兰县",
        "text": "皋兰县"
      }, {
        "id": "2935-mq",
        "value": "榆中县",
        "text": "榆中县"
      } ],
      "id": "2927-zr",
      "value": "兰州市",
      "text": "兰州市"
    }, {
      "id": "2936-py",
      "value": "嘉峪关市",
      "text": "嘉峪关市"
    }, {
      "children": [ {
        "id": "2938-mT",
        "value": "金川区",
        "text": "金川区"
      }, {
        "id": "2939-3H",
        "value": "永昌县",
        "text": "永昌县"
      } ],
      "id": "2937-e2",
      "value": "金昌市",
      "text": "金昌市"
    }, {
      "children": [ {
        "id": "2941-kR",
        "value": "白银区",
        "text": "白银区"
      }, {
        "id": "2942-PD",
        "value": "平川区",
        "text": "平川区"
      }, {
        "id": "2943-KP",
        "value": "靖远县",
        "text": "靖远县"
      }, {
        "id": "2944-7c",
        "value": "会宁县",
        "text": "会宁县"
      }, {
        "id": "2945-xo",
        "value": "景泰县",
        "text": "景泰县"
      } ],
      "id": "2940-Bd",
      "value": "白银市",
      "text": "白银市"
    }, {
      "children": [ {
        "id": "2947-xc",
        "value": "秦州区",
        "text": "秦州区"
      }, {
        "id": "2948-OA",
        "value": "麦积区",
        "text": "麦积区"
      }, {
        "id": "2949-px",
        "value": "清水县",
        "text": "清水县"
      }, {
        "id": "2950-mi",
        "value": "秦安县",
        "text": "秦安县"
      }, {
        "id": "2951-Zl",
        "value": "甘谷县",
        "text": "甘谷县"
      }, {
        "id": "2952-Se",
        "value": "武山县",
        "text": "武山县"
      }, {
        "id": "2953-6J",
        "value": "张家川回族自治县",
        "text": "张家川回族自治县"
      } ],
      "id": "2946-ft",
      "value": "天水市",
      "text": "天水市"
    }, {
      "children": [ {
        "id": "2955-bD",
        "value": "凉州区",
        "text": "凉州区"
      }, {
        "id": "2956-FY",
        "value": "民勤县",
        "text": "民勤县"
      }, {
        "id": "2957-RX",
        "value": "古浪县",
        "text": "古浪县"
      }, {
        "id": "2958-yu",
        "value": "天祝藏族自治县",
        "text": "天祝藏族自治县"
      } ],
      "id": "2954-gK",
      "value": "武威市",
      "text": "武威市"
    }, {
      "children": [ {
        "id": "2960-XH",
        "value": "甘州区",
        "text": "甘州区"
      }, {
        "id": "2961-6E",
        "value": "肃南裕固族自治县",
        "text": "肃南裕固族自治县"
      }, {
        "id": "2962-lb",
        "value": "民乐县",
        "text": "民乐县"
      }, {
        "id": "2963-5v",
        "value": "临泽县",
        "text": "临泽县"
      }, {
        "id": "2964-8M",
        "value": "高台县",
        "text": "高台县"
      }, {
        "id": "2965-SY",
        "value": "山丹县",
        "text": "山丹县"
      } ],
      "id": "2959-2l",
      "value": "张掖市",
      "text": "张掖市"
    }, {
      "children": [ {
        "id": "2967-SD",
        "value": "崆峒区",
        "text": "崆峒区"
      }, {
        "id": "2968-w4",
        "value": "泾川县",
        "text": "泾川县"
      }, {
        "id": "2969-k5",
        "value": "灵台县",
        "text": "灵台县"
      }, {
        "id": "2970-4f",
        "value": "崇信县",
        "text": "崇信县"
      }, {
        "id": "2971-cd",
        "value": "华亭县",
        "text": "华亭县"
      }, {
        "id": "2972-IH",
        "value": "庄浪县",
        "text": "庄浪县"
      }, {
        "id": "2973-Yn",
        "value": "静宁县",
        "text": "静宁县"
      } ],
      "id": "2966-hs",
      "value": "平凉市",
      "text": "平凉市"
    }, {
      "children": [ {
        "id": "2975-TY",
        "value": "肃州区",
        "text": "肃州区"
      }, {
        "id": "2976-s4",
        "value": "金塔县",
        "text": "金塔县"
      }, {
        "id": "2977-C5",
        "value": "瓜州县",
        "text": "瓜州县"
      }, {
        "id": "2978-X4",
        "value": "肃北蒙古族自治县",
        "text": "肃北蒙古族自治县"
      }, {
        "id": "2979-nI",
        "value": "阿克塞哈萨克族自治县",
        "text": "阿克塞哈萨克族自治县"
      }, {
        "id": "2980-32",
        "value": "玉门市",
        "text": "玉门市"
      }, {
        "id": "2981-mV",
        "value": "敦煌市",
        "text": "敦煌市"
      } ],
      "id": "2974-kn",
      "value": "酒泉市",
      "text": "酒泉市"
    }, {
      "children": [ {
        "id": "2983-Jj",
        "value": "西峰区",
        "text": "西峰区"
      }, {
        "id": "2984-na",
        "value": "庆城县",
        "text": "庆城县"
      }, {
        "id": "2985-ma",
        "value": "环县",
        "text": "环县"
      }, {
        "id": "2986-J7",
        "value": "华池县",
        "text": "华池县"
      }, {
        "id": "2987-N2",
        "value": "合水县",
        "text": "合水县"
      }, {
        "id": "2988-cV",
        "value": "正宁县",
        "text": "正宁县"
      }, {
        "id": "2989-3A",
        "value": "宁县",
        "text": "宁县"
      }, {
        "id": "2990-rV",
        "value": "镇原县",
        "text": "镇原县"
      } ],
      "id": "2982-qC",
      "value": "庆阳市",
      "text": "庆阳市"
    }, {
      "children": [ {
        "id": "2992-0r",
        "value": "安定区",
        "text": "安定区"
      }, {
        "id": "2993-Ag",
        "value": "通渭县",
        "text": "通渭县"
      }, {
        "id": "2994-Nx",
        "value": "陇西县",
        "text": "陇西县"
      }, {
        "id": "2995-dA",
        "value": "渭源县",
        "text": "渭源县"
      }, {
        "id": "2996-Kk",
        "value": "临洮县",
        "text": "临洮县"
      }, {
        "id": "2997-iF",
        "value": "漳县",
        "text": "漳县"
      }, {
        "id": "2998-cP",
        "value": "岷县",
        "text": "岷县"
      } ],
      "id": "2991-NL",
      "value": "定西市",
      "text": "定西市"
    }, {
      "children": [ {
        "id": "3000-cF",
        "value": "武都区",
        "text": "武都区"
      }, {
        "id": "3001-4O",
        "value": "成县",
        "text": "成县"
      }, {
        "id": "3002-rx",
        "value": "文县",
        "text": "文县"
      }, {
        "id": "3003-ll",
        "value": "宕昌县",
        "text": "宕昌县"
      }, {
        "id": "3004-1O",
        "value": "康县",
        "text": "康县"
      }, {
        "id": "3005-5s",
        "value": "西和县",
        "text": "西和县"
      }, {
        "id": "3006-yY",
        "value": "礼县",
        "text": "礼县"
      }, {
        "id": "3007-hl",
        "value": "徽县",
        "text": "徽县"
      }, {
        "id": "3008-nK",
        "value": "两当县",
        "text": "两当县"
      } ],
      "id": "2999-gx",
      "value": "陇南市",
      "text": "陇南市"
    }, {
      "children": [ {
        "id": "3010-fw",
        "value": "临夏市",
        "text": "临夏市"
      }, {
        "id": "3011-xu",
        "value": "临夏县",
        "text": "临夏县"
      }, {
        "id": "3012-UW",
        "value": "康乐县",
        "text": "康乐县"
      }, {
        "id": "3013-mt",
        "value": "永靖县",
        "text": "永靖县"
      }, {
        "id": "3014-Fq",
        "value": "广河县",
        "text": "广河县"
      }, {
        "id": "3015-av",
        "value": "和政县",
        "text": "和政县"
      }, {
        "id": "3016-yg",
        "value": "东乡族自治县",
        "text": "东乡族自治县"
      }, {
        "id": "3017-pr",
        "value": "积石山保安族东乡族撒拉族自治县",
        "text": "积石山保安族东乡族撒拉族自治县"
      } ],
      "id": "3009-vy",
      "value": "临夏回族自治州",
      "text": "临夏回族自治州"
    }, {
      "children": [ {
        "id": "3019-XA",
        "value": "合作市",
        "text": "合作市"
      }, {
        "id": "3020-kO",
        "value": "临潭县",
        "text": "临潭县"
      }, {
        "id": "3021-XJ",
        "value": "卓尼县",
        "text": "卓尼县"
      }, {
        "id": "3022-86",
        "value": "舟曲县",
        "text": "舟曲县"
      }, {
        "id": "3023-Sm",
        "value": "迭部县",
        "text": "迭部县"
      }, {
        "id": "3024-s0",
        "value": "玛曲县",
        "text": "玛曲县"
      }, {
        "id": "3025-zT",
        "value": "碌曲县",
        "text": "碌曲县"
      }, {
        "id": "3026-5X",
        "value": "夏河县",
        "text": "夏河县"
      } ],
      "id": "3018-Dn",
      "value": "甘南藏族自治州",
      "text": "甘南藏族自治州"
    } ],
    "id": "2926-HB",
    "value": "甘肃省",
    "text": "甘肃省"
  }, {
    "children": [ {
      "children": [ {
        "id": "3029-d8",
        "value": "城东区",
        "text": "城东区"
      }, {
        "id": "3030-9n",
        "value": "城中区",
        "text": "城中区"
      }, {
        "id": "3031-wL",
        "value": "城西区",
        "text": "城西区"
      }, {
        "id": "3032-GY",
        "value": "城北区",
        "text": "城北区"
      }, {
        "id": "3033-tF",
        "value": "大通回族土族自治县",
        "text": "大通回族土族自治县"
      }, {
        "id": "3034-7c",
        "value": "湟中县",
        "text": "湟中县"
      }, {
        "id": "3035-9O",
        "value": "湟源县",
        "text": "湟源县"
      } ],
      "id": "3028-sz",
      "value": "西宁市",
      "text": "西宁市"
    }, {
      "children": [ {
        "id": "3037-Tg",
        "value": "乐都区",
        "text": "乐都区"
      }, {
        "id": "3038-zc",
        "value": "平安区",
        "text": "平安区"
      }, {
        "id": "3039-Ig",
        "value": "民和回族土族自治县",
        "text": "民和回族土族自治县"
      }, {
        "id": "3040-Rz",
        "value": "互助土族自治县",
        "text": "互助土族自治县"
      }, {
        "id": "3041-8I",
        "value": "化隆回族自治县",
        "text": "化隆回族自治县"
      }, {
        "id": "3042-DZ",
        "value": "循化撒拉族自治县",
        "text": "循化撒拉族自治县"
      } ],
      "id": "3036-81",
      "value": "海东市",
      "text": "海东市"
    }, {
      "children": [ {
        "id": "3044-bE",
        "value": "门源回族自治县",
        "text": "门源回族自治县"
      }, {
        "id": "3045-Y1",
        "value": "祁连县",
        "text": "祁连县"
      }, {
        "id": "3046-09",
        "value": "海晏县",
        "text": "海晏县"
      }, {
        "id": "3047-qw",
        "value": "刚察县",
        "text": "刚察县"
      } ],
      "id": "3043-GE",
      "value": "海北藏族自治州",
      "text": "海北藏族自治州"
    }, {
      "children": [ {
        "id": "3049-B4",
        "value": "同仁县",
        "text": "同仁县"
      }, {
        "id": "3050-Dl",
        "value": "尖扎县",
        "text": "尖扎县"
      }, {
        "id": "3051-AW",
        "value": "泽库县",
        "text": "泽库县"
      }, {
        "id": "3052-V0",
        "value": "河南蒙古族自治县",
        "text": "河南蒙古族自治县"
      } ],
      "id": "3048-pm",
      "value": "黄南藏族自治州",
      "text": "黄南藏族自治州"
    }, {
      "children": [ {
        "id": "3054-a8",
        "value": "共和县",
        "text": "共和县"
      }, {
        "id": "3055-IE",
        "value": "同德县",
        "text": "同德县"
      }, {
        "id": "3056-B9",
        "value": "贵德县",
        "text": "贵德县"
      }, {
        "id": "3057-3A",
        "value": "兴海县",
        "text": "兴海县"
      }, {
        "id": "3058-dq",
        "value": "贵南县",
        "text": "贵南县"
      } ],
      "id": "3053-RB",
      "value": "海南藏族自治州",
      "text": "海南藏族自治州"
    }, {
      "children": [ {
        "id": "3060-fD",
        "value": "玛沁县",
        "text": "玛沁县"
      }, {
        "id": "3061-Q5",
        "value": "班玛县",
        "text": "班玛县"
      }, {
        "id": "3062-9N",
        "value": "甘德县",
        "text": "甘德县"
      }, {
        "id": "3063-Zm",
        "value": "达日县",
        "text": "达日县"
      }, {
        "id": "3064-0s",
        "value": "久治县",
        "text": "久治县"
      }, {
        "id": "3065-br",
        "value": "玛多县",
        "text": "玛多县"
      } ],
      "id": "3059-SW",
      "value": "果洛藏族自治州",
      "text": "果洛藏族自治州"
    }, {
      "children": [ {
        "id": "3067-8S",
        "value": "玉树市",
        "text": "玉树市"
      }, {
        "id": "3068-Qe",
        "value": "杂多县",
        "text": "杂多县"
      }, {
        "id": "3069-Ar",
        "value": "称多县",
        "text": "称多县"
      }, {
        "id": "3070-2l",
        "value": "治多县",
        "text": "治多县"
      }, {
        "id": "3071-ue",
        "value": "囊谦县",
        "text": "囊谦县"
      }, {
        "id": "3072-ny",
        "value": "曲麻莱县",
        "text": "曲麻莱县"
      } ],
      "id": "3066-e6",
      "value": "玉树藏族自治州",
      "text": "玉树藏族自治州"
    }, {
      "children": [ {
        "id": "3074-3v",
        "value": "格尔木市",
        "text": "格尔木市"
      }, {
        "id": "3075-s1",
        "value": "德令哈市",
        "text": "德令哈市"
      }, {
        "id": "3076-8C",
        "value": "乌兰县",
        "text": "乌兰县"
      }, {
        "id": "3077-E1",
        "value": "都兰县",
        "text": "都兰县"
      }, {
        "id": "3078-SS",
        "value": "天峻县",
        "text": "天峻县"
      } ],
      "id": "3073-9A",
      "value": "海西蒙古族藏族自治州",
      "text": "海西蒙古族藏族自治州"
    } ],
    "id": "3027-h1",
    "value": "青海省",
    "text": "青海省"
  }, {
    "children": [ {
      "children": [ {
        "id": "3081-Cr",
        "value": "兴庆区",
        "text": "兴庆区"
      }, {
        "id": "3082-ST",
        "value": "西夏区",
        "text": "西夏区"
      }, {
        "id": "3083-CS",
        "value": "金凤区",
        "text": "金凤区"
      }, {
        "id": "3084-qr",
        "value": "永宁县",
        "text": "永宁县"
      }, {
        "id": "3085-8Q",
        "value": "贺兰县",
        "text": "贺兰县"
      }, {
        "id": "3086-5w",
        "value": "灵武市",
        "text": "灵武市"
      } ],
      "id": "3080-CX",
      "value": "银川市",
      "text": "银川市"
    }, {
      "children": [ {
        "id": "3088-JA",
        "value": "大武口区",
        "text": "大武口区"
      }, {
        "id": "3089-W3",
        "value": "惠农区",
        "text": "惠农区"
      }, {
        "id": "3090-R7",
        "value": "平罗县",
        "text": "平罗县"
      } ],
      "id": "3087-Sx",
      "value": "石嘴山市",
      "text": "石嘴山市"
    }, {
      "children": [ {
        "id": "3092-CN",
        "value": "利通区",
        "text": "利通区"
      }, {
        "id": "3093-v9",
        "value": "红寺堡区",
        "text": "红寺堡区"
      }, {
        "id": "3094-H0",
        "value": "盐池县",
        "text": "盐池县"
      }, {
        "id": "3095-Fd",
        "value": "同心县",
        "text": "同心县"
      }, {
        "id": "3096-1Y",
        "value": "青铜峡市",
        "text": "青铜峡市"
      } ],
      "id": "3091-J4",
      "value": "吴忠市",
      "text": "吴忠市"
    }, {
      "children": [ {
        "id": "3098-mr",
        "value": "原州区",
        "text": "原州区"
      }, {
        "id": "3099-Ap",
        "value": "西吉县",
        "text": "西吉县"
      }, {
        "id": "3100-Ea",
        "value": "隆德县",
        "text": "隆德县"
      }, {
        "id": "3101-DW",
        "value": "泾源县",
        "text": "泾源县"
      }, {
        "id": "3102-EJ",
        "value": "彭阳县",
        "text": "彭阳县"
      } ],
      "id": "3097-xr",
      "value": "固原市",
      "text": "固原市"
    }, {
      "children": [ {
        "id": "3104-g8",
        "value": "沙坡头区",
        "text": "沙坡头区"
      }, {
        "id": "3105-Pg",
        "value": "中宁县",
        "text": "中宁县"
      }, {
        "id": "3106-p3",
        "value": "海原县",
        "text": "海原县"
      } ],
      "id": "3103-v1",
      "value": "中卫市",
      "text": "中卫市"
    } ],
    "id": "3079-cF",
    "value": "宁夏回族自治区",
    "text": "宁夏回族自治区"
  }, {
    "children": [ {
      "children": [ {
        "id": "3109-yF",
        "value": "天山区",
        "text": "天山区"
      }, {
        "id": "3110-Bb",
        "value": "沙依巴克区",
        "text": "沙依巴克区"
      }, {
        "id": "3111-Z2",
        "value": "新市区",
        "text": "新市区"
      }, {
        "id": "3112-9j",
        "value": "水磨沟区",
        "text": "水磨沟区"
      }, {
        "id": "3113-ha",
        "value": "头屯河区",
        "text": "头屯河区"
      }, {
        "id": "3114-7O",
        "value": "达坂城区",
        "text": "达坂城区"
      }, {
        "id": "3115-FH",
        "value": "东山区",
        "text": "东山区"
      }, {
        "id": "3116-yg",
        "value": "乌鲁木齐县",
        "text": "乌鲁木齐县"
      }, {
        "id": "3117-Pt",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3108-8Z",
      "value": "乌鲁木齐",
      "text": "乌鲁木齐"
    }, {
      "children": [ {
        "id": "3119-mV",
        "value": "克拉玛依区",
        "text": "克拉玛依区"
      }, {
        "id": "3120-29",
        "value": "独山子区",
        "text": "独山子区"
      }, {
        "id": "3121-K9",
        "value": "白碱滩区",
        "text": "白碱滩区"
      }, {
        "id": "3122-kU",
        "value": "乌尔禾区",
        "text": "乌尔禾区"
      }, {
        "id": "3123-pR",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3118-Qo",
      "value": "克拉玛依",
      "text": "克拉玛依"
    }, {
      "children": [ {
        "id": "3125-2M",
        "value": "吐鲁番市",
        "text": "吐鲁番市"
      }, {
        "id": "3126-sw",
        "value": "托克逊县",
        "text": "托克逊县"
      }, {
        "id": "3127-nw",
        "value": "鄯善县",
        "text": "鄯善县"
      }, {
        "id": "3128-Mm",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3124-Ag",
      "value": "吐鲁番地区",
      "text": "吐鲁番地区"
    }, {
      "children": [ {
        "id": "3130-A1",
        "value": "哈密市",
        "text": "哈密市"
      }, {
        "id": "3131-Lu",
        "value": "伊吾县",
        "text": "伊吾县"
      }, {
        "id": "3132-Xl",
        "value": "巴里坤哈萨克自治县",
        "text": "巴里坤哈萨克自治县"
      }, {
        "id": "3133-DW",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3129-Z4",
      "value": "哈密地区",
      "text": "哈密地区"
    }, {
      "children": [ {
        "id": "3135-qJ",
        "value": "和田市",
        "text": "和田市"
      }, {
        "id": "3136-Au",
        "value": "和田县",
        "text": "和田县"
      }, {
        "id": "3137-Yz",
        "value": "洛浦县",
        "text": "洛浦县"
      }, {
        "id": "3138-Z8",
        "value": "民丰县",
        "text": "民丰县"
      }, {
        "id": "3139-Qg",
        "value": "皮山县",
        "text": "皮山县"
      }, {
        "id": "3140-ku",
        "value": "策勒县",
        "text": "策勒县"
      }, {
        "id": "3141-kl",
        "value": "于田县",
        "text": "于田县"
      }, {
        "id": "3142-9C",
        "value": "墨玉县",
        "text": "墨玉县"
      }, {
        "id": "3143-R9",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3134-jF",
      "value": "和田地区",
      "text": "和田地区"
    }, {
      "children": [ {
        "id": "3145-UP",
        "value": "阿克苏市",
        "text": "阿克苏市"
      }, {
        "id": "3146-HC",
        "value": "温宿县",
        "text": "温宿县"
      }, {
        "id": "3147-Fe",
        "value": "沙雅县",
        "text": "沙雅县"
      }, {
        "id": "3148-RR",
        "value": "拜城县",
        "text": "拜城县"
      }, {
        "id": "3149-4g",
        "value": "阿瓦提县",
        "text": "阿瓦提县"
      }, {
        "id": "3150-FQ",
        "value": "库车县",
        "text": "库车县"
      }, {
        "id": "3151-5D",
        "value": "柯坪县",
        "text": "柯坪县"
      }, {
        "id": "3152-qs",
        "value": "新和县",
        "text": "新和县"
      }, {
        "id": "3153-O4",
        "value": "乌什县",
        "text": "乌什县"
      }, {
        "id": "3154-h6",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3144-tA",
      "value": "阿克苏地区",
      "text": "阿克苏地区"
    }, {
      "children": [ {
        "id": "3156-bg",
        "value": "喀什市",
        "text": "喀什市"
      }, {
        "id": "3157-bL",
        "value": "巴楚县",
        "text": "巴楚县"
      }, {
        "id": "3158-sX",
        "value": "泽普县",
        "text": "泽普县"
      }, {
        "id": "3159-U5",
        "value": "伽师县",
        "text": "伽师县"
      }, {
        "id": "3160-Au",
        "value": "叶城县",
        "text": "叶城县"
      }, {
        "id": "3161-lZ",
        "value": "岳普湖县",
        "text": "岳普湖县"
      }, {
        "id": "3162-Eo",
        "value": "疏勒县",
        "text": "疏勒县"
      }, {
        "id": "3163-TD",
        "value": "麦盖提县",
        "text": "麦盖提县"
      }, {
        "id": "3164-LF",
        "value": "英吉沙县",
        "text": "英吉沙县"
      }, {
        "id": "3165-sz",
        "value": "莎车县",
        "text": "莎车县"
      }, {
        "id": "3166-FF",
        "value": "疏附县",
        "text": "疏附县"
      }, {
        "id": "3167-qk",
        "value": "塔什库尔干塔吉克自治县",
        "text": "塔什库尔干塔吉克自治县"
      }, {
        "id": "3168-rp",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3155-Sh",
      "value": "喀什地区",
      "text": "喀什地区"
    }, {
      "children": [ {
        "id": "3170-YP",
        "value": "阿图什市",
        "text": "阿图什市"
      }, {
        "id": "3171-Qg",
        "value": "阿合奇县",
        "text": "阿合奇县"
      }, {
        "id": "3172-yK",
        "value": "乌恰县",
        "text": "乌恰县"
      }, {
        "id": "3173-dZ",
        "value": "阿克陶县",
        "text": "阿克陶县"
      }, {
        "id": "3174-8y",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3169-a4",
      "value": "克孜勒苏柯尔克孜自治州",
      "text": "克孜勒苏柯尔克孜自治州"
    }, {
      "children": [ {
        "id": "3176-1k",
        "value": "库尔勒市",
        "text": "库尔勒市"
      }, {
        "id": "3177-92",
        "value": "和静县",
        "text": "和静县"
      }, {
        "id": "3178-nu",
        "value": "尉犁县",
        "text": "尉犁县"
      }, {
        "id": "3179-tB",
        "value": "和硕县",
        "text": "和硕县"
      }, {
        "id": "3180-G5",
        "value": "且末县",
        "text": "且末县"
      }, {
        "id": "3181-e6",
        "value": "博湖县",
        "text": "博湖县"
      }, {
        "id": "3182-kI",
        "value": "轮台县",
        "text": "轮台县"
      }, {
        "id": "3183-rI",
        "value": "若羌县",
        "text": "若羌县"
      }, {
        "id": "3184-04",
        "value": "焉耆回族自治县",
        "text": "焉耆回族自治县"
      }, {
        "id": "3185-Dc",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3175-mY",
      "value": "巴音郭楞蒙古自治州",
      "text": "巴音郭楞蒙古自治州"
    }, {
      "children": [ {
        "id": "3187-eB",
        "value": "昌吉市",
        "text": "昌吉市"
      }, {
        "id": "3188-AO",
        "value": "阜康市",
        "text": "阜康市"
      }, {
        "id": "3189-9W",
        "value": "奇台县",
        "text": "奇台县"
      }, {
        "id": "3190-Fk",
        "value": "玛纳斯县",
        "text": "玛纳斯县"
      }, {
        "id": "3191-BJ",
        "value": "吉木萨尔县",
        "text": "吉木萨尔县"
      }, {
        "id": "3192-Uv",
        "value": "呼图壁县",
        "text": "呼图壁县"
      }, {
        "id": "3193-zz",
        "value": "木垒哈萨克自治县",
        "text": "木垒哈萨克自治县"
      }, {
        "id": "3194-sT",
        "value": "米泉市",
        "text": "米泉市"
      }, {
        "id": "3195-Ed",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3186-Kd",
      "value": "昌吉回族自治州",
      "text": "昌吉回族自治州"
    }, {
      "children": [ {
        "id": "3197-Nx",
        "value": "博乐市",
        "text": "博乐市"
      }, {
        "id": "3198-Bh",
        "value": "精河县",
        "text": "精河县"
      }, {
        "id": "3199-Qi",
        "value": "温泉县",
        "text": "温泉县"
      }, {
        "id": "3200-W3",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3196-CF",
      "value": "博尔塔拉蒙古自治州",
      "text": "博尔塔拉蒙古自治州"
    }, {
      "children": [ {
        "id": "3202-9N",
        "value": "石河子",
        "text": "石河子"
      } ],
      "id": "3201-Y5",
      "value": "石河子",
      "text": "石河子"
    }, {
      "children": [ {
        "id": "3204-Lc",
        "value": "阿拉尔",
        "text": "阿拉尔"
      } ],
      "id": "3203-Cy",
      "value": "阿拉尔",
      "text": "阿拉尔"
    }, {
      "children": [ {
        "id": "3206-KY",
        "value": "图木舒克",
        "text": "图木舒克"
      } ],
      "id": "3205-Tx",
      "value": "图木舒克",
      "text": "图木舒克"
    }, {
      "children": [ {
        "id": "3208-2v",
        "value": "五家渠",
        "text": "五家渠"
      } ],
      "id": "3207-As",
      "value": "五家渠",
      "text": "五家渠"
    }, {
      "children": [ {
        "id": "3210-Kp",
        "value": "伊宁市",
        "text": "伊宁市"
      }, {
        "id": "3211-0f",
        "value": "奎屯市",
        "text": "奎屯市"
      }, {
        "id": "3212-OF",
        "value": "伊宁县",
        "text": "伊宁县"
      }, {
        "id": "3213-iB",
        "value": "特克斯县",
        "text": "特克斯县"
      }, {
        "id": "3214-1h",
        "value": "尼勒克县",
        "text": "尼勒克县"
      }, {
        "id": "3215-Nd",
        "value": "昭苏县",
        "text": "昭苏县"
      }, {
        "id": "3216-2c",
        "value": "新源县",
        "text": "新源县"
      }, {
        "id": "3217-RO",
        "value": "霍城县",
        "text": "霍城县"
      }, {
        "id": "3218-5p",
        "value": "巩留县",
        "text": "巩留县"
      }, {
        "id": "3219-4P",
        "value": "察布查尔锡伯自治县",
        "text": "察布查尔锡伯自治县"
      }, {
        "id": "3220-d9",
        "value": "塔城地区",
        "text": "塔城地区"
      }, {
        "id": "3221-AN",
        "value": "阿勒泰地区",
        "text": "阿勒泰地区"
      }, {
        "id": "3222-FJ",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3209-SN",
      "value": "伊犁哈萨克自治州",
      "text": "伊犁哈萨克自治州"
    }, {
      "children": [ {
        "id": "3224-YX",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3223-oe",
      "value": "其他",
      "text": "其他"
    } ],
    "id": "3107-RZ",
    "value": "新疆",
    "text": "新疆"
  }, {
    "children": [ {
      "children": [ {
        "id": "3227-Mu",
        "value": "台北市",
        "text": "台北市"
      }, {
        "id": "3228-C5",
        "value": "高雄市",
        "text": "高雄市"
      }, {
        "id": "3229-0l",
        "value": "台北县",
        "text": "台北县"
      }, {
        "id": "3230-ew",
        "value": "桃园县",
        "text": "桃园县"
      }, {
        "id": "3231-o0",
        "value": "新竹县",
        "text": "新竹县"
      }, {
        "id": "3232-cu",
        "value": "苗栗县",
        "text": "苗栗县"
      }, {
        "id": "3233-a6",
        "value": "台中县",
        "text": "台中县"
      }, {
        "id": "3234-h7",
        "value": "彰化县",
        "text": "彰化县"
      }, {
        "id": "3235-Nc",
        "value": "南投县",
        "text": "南投县"
      }, {
        "id": "3236-hP",
        "value": "云林县",
        "text": "云林县"
      }, {
        "id": "3237-K1",
        "value": "嘉义县",
        "text": "嘉义县"
      }, {
        "id": "3238-FX",
        "value": "台南县",
        "text": "台南县"
      }, {
        "id": "3239-ba",
        "value": "高雄县",
        "text": "高雄县"
      }, {
        "id": "3240-HW",
        "value": "屏东县",
        "text": "屏东县"
      }, {
        "id": "3241-AZ",
        "value": "宜兰县",
        "text": "宜兰县"
      }, {
        "id": "3242-h6",
        "value": "花莲县",
        "text": "花莲县"
      }, {
        "id": "3243-Eh",
        "value": "台东县",
        "text": "台东县"
      }, {
        "id": "3244-f3",
        "value": "澎湖县",
        "text": "澎湖县"
      }, {
        "id": "3245-AR",
        "value": "基隆市",
        "text": "基隆市"
      }, {
        "id": "3246-nG",
        "value": "新竹市",
        "text": "新竹市"
      }, {
        "id": "3247-EX",
        "value": "台中市",
        "text": "台中市"
      }, {
        "id": "3248-9s",
        "value": "嘉义市",
        "text": "嘉义市"
      }, {
        "id": "3249-IN",
        "value": "台南市",
        "text": "台南市"
      }, {
        "id": "3250-01",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3226-01",
      "value": "台湾",
      "text": "台湾"
    }, {
      "children": [ {
        "id": "3252-2I",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3251-AO",
      "value": "其他",
      "text": "其他"
    } ],
    "id": "3225-xh",
    "value": "台湾",
    "text": "台湾"
  }, {
    "children": [ {
      "children": [ {
        "id": "3255-mA",
        "value": "花地玛堂区",
        "text": "花地玛堂区"
      }, {
        "id": "3256-UD",
        "value": "圣安多尼堂区",
        "text": "圣安多尼堂区"
      }, {
        "id": "3257-UH",
        "value": "大堂区",
        "text": "大堂区"
      }, {
        "id": "3258-wd",
        "value": "望德堂区",
        "text": "望德堂区"
      }, {
        "id": "3259-Qm",
        "value": "风顺堂区",
        "text": "风顺堂区"
      }, {
        "id": "3260-Ex",
        "value": "嘉模堂区",
        "text": "嘉模堂区"
      }, {
        "id": "3261-LK",
        "value": "圣方济各堂区",
        "text": "圣方济各堂区"
      }, {
        "id": "3262-NH",
        "value": "路凼",
        "text": "路凼"
      }, {
        "id": "3263-Wo",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3254-3w",
      "value": "澳门",
      "text": "澳门"
    } ],
    "id": "3253-Xt",
    "value": "澳门",
    "text": "澳门"
  }, {
    "children": [ {
      "children": [ {
        "id": "3266-b3",
        "value": "中西区",
        "text": "中西区"
      }, {
        "id": "3267-19",
        "value": "湾仔区",
        "text": "湾仔区"
      }, {
        "id": "3268-DN",
        "value": "东区",
        "text": "东区"
      }, {
        "id": "3269-xD",
        "value": "南区",
        "text": "南区"
      }, {
        "id": "3270-os",
        "value": "深水埗区",
        "text": "深水埗区"
      }, {
        "id": "3271-ed",
        "value": "油尖旺区",
        "text": "油尖旺区"
      }, {
        "id": "3272-j3",
        "value": "九龙城区",
        "text": "九龙城区"
      }, {
        "id": "3273-4l",
        "value": "黄大仙区",
        "text": "黄大仙区"
      }, {
        "id": "3274-Tt",
        "value": "观塘区",
        "text": "观塘区"
      }, {
        "id": "3275-86",
        "value": "北区",
        "text": "北区"
      }, {
        "id": "3276-7D",
        "value": "大埔区",
        "text": "大埔区"
      }, {
        "id": "3277-DL",
        "value": "沙田区",
        "text": "沙田区"
      }, {
        "id": "3278-Ze",
        "value": "西贡区",
        "text": "西贡区"
      }, {
        "id": "3279-Sh",
        "value": "元朗区",
        "text": "元朗区"
      }, {
        "id": "3280-Jl",
        "value": "屯门区",
        "text": "屯门区"
      }, {
        "id": "3281-cN",
        "value": "荃湾区",
        "text": "荃湾区"
      }, {
        "id": "3282-CT",
        "value": "葵青区",
        "text": "葵青区"
      }, {
        "id": "3283-MF",
        "value": "离岛区",
        "text": "离岛区"
      }, {
        "id": "3284-Q6",
        "value": "其他",
        "text": "其他"
      } ],
      "id": "3265-6J",
      "value": "香港",
      "text": "香港"
    } ],
    "id": "3264-5S",
    "value": "香港",
    "text": "香港"
  }, {
    "children": [ {
      "children": [ {
        "id": "3287-NF",
        "value": "钓鱼岛",
        "text": "钓鱼岛"
      } ],
      "id": "3286-Ea",
      "value": "钓鱼岛",
      "text": "钓鱼岛"
    } ],
    "id": "3285-IL",
    "value": "钓鱼岛",
    "text": "钓鱼岛"
  } ]
}



// WEBPACK FOOTER //
// ./src/utils/regions-m.js